export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: number; output: number; }
  date: { input: string; output: string; }
  jsonb: { input: object; output: object; }
  numeric: { input: number; output: number; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OrganizationCourse = {
  __typename?: 'OrganizationCourse';
  archived: Scalars['Boolean']['output'];
  assignmentTypeWeights: Array<OrganizationCourseAssignmentTypeWeights>;
  color: Scalars['String']['output'];
  copiedFromCourseId?: Maybe<Scalars['uuid']['output']>;
  credits?: Maybe<Scalars['numeric']['output']>;
  defaultDaysOfTheWeek?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradeYears?: Maybe<Scalars['jsonb']['output']>;
  gradingStyle: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  numberOfDaysPerWeek: Scalars['Int']['output'];
  numberOfWeeks: Scalars['Int']['output'];
  organizationCourseGroups: Array<OrganizationCourseOrganizationCourseGroupsType>;
  picture?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Scalars['jsonb']['output']>;
  useAssignmentTypeWeights?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationCourseAssignmentTypeWeights = {
  __typename?: 'OrganizationCourseAssignmentTypeWeights';
  assignmentType?: Maybe<Scalars['String']['output']>;
  customAssignmentType?: Maybe<OrganizationCourseCustomAssignmnetType>;
  id: Scalars['uuid']['output'];
  sortOrder: Scalars['Int']['output'];
  weight: Scalars['numeric']['output'];
};

export type OrganizationCourseCustomAssignmnetType = {
  __typename?: 'OrganizationCourseCustomAssignmnetType';
  color: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationCourseOrganizationCourseGroupType = {
  __typename?: 'OrganizationCourseOrganizationCourseGroupType';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationCourseOrganizationCourseGroupsType = {
  __typename?: 'OrganizationCourseOrganizationCourseGroupsType';
  organizationCourseGroup: OrganizationCourseOrganizationCourseGroupType;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "assignment_type" */
export type Assignment_Type = {
  __typename?: 'assignment_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "assignment_type" */
export type Assignment_Type_Aggregate = {
  __typename?: 'assignment_type_aggregate';
  aggregate?: Maybe<Assignment_Type_Aggregate_Fields>;
  nodes: Array<Assignment_Type>;
};

/** aggregate fields of "assignment_type" */
export type Assignment_Type_Aggregate_Fields = {
  __typename?: 'assignment_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assignment_Type_Max_Fields>;
  min?: Maybe<Assignment_Type_Min_Fields>;
};


/** aggregate fields of "assignment_type" */
export type Assignment_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export type Assignment_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Type_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_type" */
export enum Assignment_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssignmentTypePkey = 'assignment_type_pkey'
}

export enum Assignment_Type_Enum {
  Homework = 'HOMEWORK',
  Lab = 'LAB',
  Other = 'OTHER',
  Paper = 'PAPER',
  Quiz = 'QUIZ',
  Test = 'TEST'
}

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export type Assignment_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Assignment_Type_Enum>;
  _in?: InputMaybe<Array<Assignment_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Assignment_Type_Enum>;
  _nin?: InputMaybe<Array<Assignment_Type_Enum>>;
};

/** input type for inserting data into table "assignment_type" */
export type Assignment_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Assignment_Type_Max_Fields = {
  __typename?: 'assignment_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Assignment_Type_Min_Fields = {
  __typename?: 'assignment_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "assignment_type" */
export type Assignment_Type_Mutation_Response = {
  __typename?: 'assignment_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Type>;
};

/** on_conflict condition type for table "assignment_type" */
export type Assignment_Type_On_Conflict = {
  constraint: Assignment_Type_Constraint;
  update_columns?: Array<Assignment_Type_Update_Column>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_type". */
export type Assignment_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_type */
export type Assignment_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "assignment_type" */
export enum Assignment_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "assignment_type" */
export type Assignment_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "assignment_type" */
export type Assignment_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "assignment_type" */
export enum Assignment_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Assignment_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Type_Bool_Exp;
};

/** columns and relationships of "assignment_type_weights" */
export type Assignment_Type_Weights = {
  __typename?: 'assignment_type_weights';
  assignmentType?: Maybe<Assignment_Type_Enum>;
  /** An object relationship */
  course: Courses;
  course_id: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customAssignmentType?: Maybe<Custom_Assignment_Types>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  weight: Scalars['numeric']['output'];
};

/** aggregated selection of "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate = {
  __typename?: 'assignment_type_weights_aggregate';
  aggregate?: Maybe<Assignment_Type_Weights_Aggregate_Fields>;
  nodes: Array<Assignment_Type_Weights>;
};

export type Assignment_Type_Weights_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assignment_Type_Weights_Aggregate_Bool_Exp_Count>;
};

export type Assignment_Type_Weights_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate_Fields = {
  __typename?: 'assignment_type_weights_aggregate_fields';
  avg?: Maybe<Assignment_Type_Weights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assignment_Type_Weights_Max_Fields>;
  min?: Maybe<Assignment_Type_Weights_Min_Fields>;
  stddev?: Maybe<Assignment_Type_Weights_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Type_Weights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Type_Weights_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Type_Weights_Sum_Fields>;
  var_pop?: Maybe<Assignment_Type_Weights_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Type_Weights_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Type_Weights_Variance_Fields>;
};


/** aggregate fields of "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate_Order_By = {
  avg?: InputMaybe<Assignment_Type_Weights_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Type_Weights_Max_Order_By>;
  min?: InputMaybe<Assignment_Type_Weights_Min_Order_By>;
  stddev?: InputMaybe<Assignment_Type_Weights_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignment_Type_Weights_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignment_Type_Weights_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignment_Type_Weights_Sum_Order_By>;
  var_pop?: InputMaybe<Assignment_Type_Weights_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignment_Type_Weights_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignment_Type_Weights_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignment_type_weights" */
export type Assignment_Type_Weights_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Type_Weights_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Type_Weights_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignment_Type_Weights_Avg_Fields = {
  __typename?: 'assignment_type_weights_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Avg_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignment_type_weights". All fields are combined with a logical 'AND'. */
export type Assignment_Type_Weights_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Type_Weights_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Type_Weights_Bool_Exp>>;
  assignmentType?: InputMaybe<Assignment_Type_Enum_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  course_id?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
  customAssignmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_type_weights" */
export enum Assignment_Type_Weights_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentTypeWeightsPkey = 'assignment_type_weights_pkey'
}

/** input type for incrementing numeric columns in table "assignment_type_weights" */
export type Assignment_Type_Weights_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "assignment_type_weights" */
export type Assignment_Type_Weights_Insert_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Obj_Rel_Insert_Input>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Assignment_Type_Weights_Max_Fields = {
  __typename?: 'assignment_type_weights_max_fields';
  course_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Type_Weights_Min_Fields = {
  __typename?: 'assignment_type_weights_min_fields';
  course_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment_type_weights" */
export type Assignment_Type_Weights_Mutation_Response = {
  __typename?: 'assignment_type_weights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Type_Weights>;
};

/** on_conflict condition type for table "assignment_type_weights" */
export type Assignment_Type_Weights_On_Conflict = {
  constraint: Assignment_Type_Weights_Constraint;
  update_columns?: Array<Assignment_Type_Weights_Update_Column>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_type_weights". */
export type Assignment_Type_Weights_Order_By = {
  assignmentType?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_type_weights */
export type Assignment_Type_Weights_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assignment_type_weights" */
export enum Assignment_Type_Weights_Select_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  Updated = 'updated',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "assignment_type_weights" */
export type Assignment_Type_Weights_Set_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  course_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Assignment_Type_Weights_Stddev_Fields = {
  __typename?: 'assignment_type_weights_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Stddev_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Type_Weights_Stddev_Pop_Fields = {
  __typename?: 'assignment_type_weights_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Stddev_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Type_Weights_Stddev_Samp_Fields = {
  __typename?: 'assignment_type_weights_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Stddev_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignment_type_weights" */
export type Assignment_Type_Weights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Type_Weights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Type_Weights_Stream_Cursor_Value_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  course_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Assignment_Type_Weights_Sum_Fields = {
  __typename?: 'assignment_type_weights_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Sum_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "assignment_type_weights" */
export enum Assignment_Type_Weights_Update_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  Updated = 'updated',
  /** column name */
  Weight = 'weight'
}

export type Assignment_Type_Weights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Type_Weights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Type_Weights_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Type_Weights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Type_Weights_Var_Pop_Fields = {
  __typename?: 'assignment_type_weights_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Var_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignment_Type_Weights_Var_Samp_Fields = {
  __typename?: 'assignment_type_weights_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Var_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignment_Type_Weights_Variance_Fields = {
  __typename?: 'assignment_type_weights_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Variance_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "assignments" */
export type Assignments = {
  __typename?: 'assignments';
  assignmentType?: Maybe<Assignment_Type_Enum>;
  /** An array relationship */
  attachments: Array<Files>;
  /** An aggregate relationship */
  attachments_aggregate: Files_Aggregate;
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customAssignmentType?: Maybe<Custom_Assignment_Types>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  graded: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parrotRequest?: Maybe<Parrot_Requests>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  studentAssignments: Array<Student_Assignments>;
  /** An aggregate relationship */
  studentAssignments_aggregate: Student_Assignments_Aggregate;
  teachersNote?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  visible: Scalars['Boolean']['output'];
  week?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "assignments" */
export type AssignmentsAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "assignments" */
export type AssignmentsAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "assignments" */
export type AssignmentsStudentAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "assignments" */
export type AssignmentsStudentAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};

/** aggregated selection of "assignments" */
export type Assignments_Aggregate = {
  __typename?: 'assignments_aggregate';
  aggregate?: Maybe<Assignments_Aggregate_Fields>;
  nodes: Array<Assignments>;
};

export type Assignments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assignments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assignments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assignments_Aggregate_Bool_Exp_Count>;
};

export type Assignments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignments" */
export type Assignments_Aggregate_Fields = {
  __typename?: 'assignments_aggregate_fields';
  avg?: Maybe<Assignments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assignments_Max_Fields>;
  min?: Maybe<Assignments_Min_Fields>;
  stddev?: Maybe<Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Assignments_Sum_Fields>;
  var_pop?: Maybe<Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Assignments_Var_Samp_Fields>;
  variance?: Maybe<Assignments_Variance_Fields>;
};


/** aggregate fields of "assignments" */
export type Assignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assignments" */
export type Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignments_Max_Order_By>;
  min?: InputMaybe<Assignments_Min_Order_By>;
  stddev?: InputMaybe<Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignments" */
export type Assignments_Arr_Rel_Insert_Input = {
  data: Array<Assignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignments_Avg_Fields = {
  __typename?: 'assignments_avg_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "assignments" */
export type Assignments_Avg_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export type Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Assignments_Bool_Exp>>;
  _not?: InputMaybe<Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Assignments_Bool_Exp>>;
  assignmentType?: InputMaybe<Assignment_Type_Enum_Comparison_Exp>;
  attachments?: InputMaybe<Files_Bool_Exp>;
  attachments_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
  customAssignmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  day?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  graded?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parrotRequest?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  studentAssignments?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp>;
  teachersNote?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
  week?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignments" */
export enum Assignments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentsPkey = 'assignments_pkey'
}

/** input type for incrementing numeric columns in table "assignments" */
export type Assignments_Inc_Input = {
  day?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "assignments" */
export type Assignments_Insert_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  attachments?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Obj_Rel_Insert_Input>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parrotRequest?: InputMaybe<Parrot_Requests_Obj_Rel_Insert_Input>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  studentAssignments?: InputMaybe<Student_Assignments_Arr_Rel_Insert_Input>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Assignments_Max_Fields = {
  __typename?: 'assignments_max_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  teachersNote?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "assignments" */
export type Assignments_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  teachersNote?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignments_Min_Fields = {
  __typename?: 'assignments_min_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  teachersNote?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "assignments" */
export type Assignments_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  teachersNote?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignments" */
export type Assignments_Mutation_Response = {
  __typename?: 'assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignments>;
};

/** input type for inserting object relation for remote table "assignments" */
export type Assignments_Obj_Rel_Insert_Input = {
  data: Assignments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};

/** on_conflict condition type for table "assignments" */
export type Assignments_On_Conflict = {
  constraint: Assignments_Constraint;
  update_columns?: Array<Assignments_Update_Column>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "assignments". */
export type Assignments_Order_By = {
  assignmentType?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  graded?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parrotRequest?: InputMaybe<Parrot_Requests_Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Order_By>;
  teachersNote?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignments */
export type Assignments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assignments" */
export enum Assignments_Select_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  Graded = 'graded',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  TeachersNote = 'teachersNote',
  /** column name */
  Updated = 'updated',
  /** column name */
  Visible = 'visible',
  /** column name */
  Week = 'week'
}

/** select "assignments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assignments" */
export enum Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Graded = 'graded',
  /** column name */
  Visible = 'visible'
}

/** select "assignments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assignments" */
export enum Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Graded = 'graded',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "assignments" */
export type Assignments_Set_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Assignments_Stddev_Fields = {
  __typename?: 'assignments_stddev_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "assignments" */
export type Assignments_Stddev_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignments_Stddev_Pop_Fields = {
  __typename?: 'assignments_stddev_pop_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "assignments" */
export type Assignments_Stddev_Pop_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignments_Stddev_Samp_Fields = {
  __typename?: 'assignments_stddev_samp_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "assignments" */
export type Assignments_Stddev_Samp_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignments" */
export type Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignments_Stream_Cursor_Value_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Assignments_Sum_Fields = {
  __typename?: 'assignments_sum_fields';
  day?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "assignments" */
export type Assignments_Sum_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** update columns of table "assignments" */
export enum Assignments_Update_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  Graded = 'graded',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  TeachersNote = 'teachersNote',
  /** column name */
  Updated = 'updated',
  /** column name */
  Visible = 'visible',
  /** column name */
  Week = 'week'
}

export type Assignments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignments_Var_Pop_Fields = {
  __typename?: 'assignments_var_pop_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "assignments" */
export type Assignments_Var_Pop_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignments_Var_Samp_Fields = {
  __typename?: 'assignments_var_samp_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "assignments" */
export type Assignments_Var_Samp_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignments_Variance_Fields = {
  __typename?: 'assignments_variance_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "assignments" */
export type Assignments_Variance_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "comments" */
export type Comments = {
  __typename?: 'comments';
  content: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  studentAccount?: Maybe<Student_Accounts>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  studentAssignment?: Maybe<Student_Assignments>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate';
  aggregate?: Maybe<Comments_Aggregate_Fields>;
  nodes: Array<Comments>;
};

export type Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Comments_Aggregate_Bool_Exp_Count>;
};

export type Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Comments_Max_Fields>;
  min?: Maybe<Comments_Min_Fields>;
};


/** aggregate fields of "comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  studentAccount?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAccountId?: InputMaybe<String_Comparison_Exp>;
  studentAssignment?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey'
}

/** input type for inserting data into table "comments" */
export type Comments_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentAccount?: InputMaybe<Student_Accounts_Obj_Rel_Insert_Input>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  studentAssignment?: InputMaybe<Student_Assignments_Obj_Rel_Insert_Input>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments>;
};

/** on_conflict condition type for table "comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint;
  update_columns?: Array<Comments_Update_Column>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  content?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentAccount?: InputMaybe<Student_Accounts_Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  studentAssignment?: InputMaybe<Student_Assignments_Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "comments" */
export type Comments_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "comments" */
export type Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "comments" */
export enum Comments_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comments_Bool_Exp;
};

/** columns and relationships of "course_share_links" */
export type Course_Share_Links = {
  __typename?: 'course_share_links';
  code: Scalars['String']['output'];
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label?: Maybe<Scalars['String']['output']>;
  maxUses?: Maybe<Scalars['Int']['output']>;
  public: Scalars['Boolean']['output'];
  remainingUses?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "course_share_links" */
export type Course_Share_Links_Aggregate = {
  __typename?: 'course_share_links_aggregate';
  aggregate?: Maybe<Course_Share_Links_Aggregate_Fields>;
  nodes: Array<Course_Share_Links>;
};

/** aggregate fields of "course_share_links" */
export type Course_Share_Links_Aggregate_Fields = {
  __typename?: 'course_share_links_aggregate_fields';
  avg?: Maybe<Course_Share_Links_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Course_Share_Links_Max_Fields>;
  min?: Maybe<Course_Share_Links_Min_Fields>;
  stddev?: Maybe<Course_Share_Links_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Share_Links_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Share_Links_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Share_Links_Sum_Fields>;
  var_pop?: Maybe<Course_Share_Links_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Share_Links_Var_Samp_Fields>;
  variance?: Maybe<Course_Share_Links_Variance_Fields>;
};


/** aggregate fields of "course_share_links" */
export type Course_Share_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Share_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Course_Share_Links_Avg_Fields = {
  __typename?: 'course_share_links_avg_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "course_share_links". All fields are combined with a logical 'AND'. */
export type Course_Share_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Share_Links_Bool_Exp>>;
  _not?: InputMaybe<Course_Share_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Share_Links_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  maxUses?: InputMaybe<Int_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  remainingUses?: InputMaybe<Int_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_share_links" */
export enum Course_Share_Links_Constraint {
  /** unique or primary key constraint on columns "code" */
  CourseShareLinksCodeKey = 'course_share_links_code_key',
  /** unique or primary key constraint on columns "id" */
  CourseShareLinksPkey = 'course_share_links_pkey'
}

/** input type for incrementing numeric columns in table "course_share_links" */
export type Course_Share_Links_Inc_Input = {
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  remainingUses?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "course_share_links" */
export type Course_Share_Links_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  remainingUses?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Course_Share_Links_Max_Fields = {
  __typename?: 'course_share_links_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxUses?: Maybe<Scalars['Int']['output']>;
  remainingUses?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Course_Share_Links_Min_Fields = {
  __typename?: 'course_share_links_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxUses?: Maybe<Scalars['Int']['output']>;
  remainingUses?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "course_share_links" */
export type Course_Share_Links_Mutation_Response = {
  __typename?: 'course_share_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Share_Links>;
};

/** on_conflict condition type for table "course_share_links" */
export type Course_Share_Links_On_Conflict = {
  constraint: Course_Share_Links_Constraint;
  update_columns?: Array<Course_Share_Links_Update_Column>;
  where?: InputMaybe<Course_Share_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "course_share_links". */
export type Course_Share_Links_Order_By = {
  code?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  maxUses?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  remainingUses?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_share_links */
export type Course_Share_Links_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "course_share_links" */
export enum Course_Share_Links_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MaxUses = 'maxUses',
  /** column name */
  Public = 'public',
  /** column name */
  RemainingUses = 'remainingUses',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "course_share_links" */
export type Course_Share_Links_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  remainingUses?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Course_Share_Links_Stddev_Fields = {
  __typename?: 'course_share_links_stddev_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Course_Share_Links_Stddev_Pop_Fields = {
  __typename?: 'course_share_links_stddev_pop_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Course_Share_Links_Stddev_Samp_Fields = {
  __typename?: 'course_share_links_stddev_samp_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "course_share_links" */
export type Course_Share_Links_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Share_Links_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Share_Links_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  remainingUses?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Course_Share_Links_Sum_Fields = {
  __typename?: 'course_share_links_sum_fields';
  maxUses?: Maybe<Scalars['Int']['output']>;
  remainingUses?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "course_share_links" */
export enum Course_Share_Links_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MaxUses = 'maxUses',
  /** column name */
  Public = 'public',
  /** column name */
  RemainingUses = 'remainingUses',
  /** column name */
  Updated = 'updated'
}

export type Course_Share_Links_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Share_Links_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Share_Links_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Share_Links_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Share_Links_Var_Pop_Fields = {
  __typename?: 'course_share_links_var_pop_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Course_Share_Links_Var_Samp_Fields = {
  __typename?: 'course_share_links_var_samp_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Course_Share_Links_Variance_Fields = {
  __typename?: 'course_share_links_variance_fields';
  maxUses?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "courses" */
export type Courses = {
  __typename?: 'courses';
  archived: Scalars['Boolean']['output'];
  /** An array relationship */
  assignmentTypeWeights: Array<Assignment_Type_Weights>;
  /** An aggregate relationship */
  assignmentTypeWeights_aggregate: Assignment_Type_Weights_Aggregate;
  /** An array relationship */
  assignments: Array<Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Assignments_Aggregate;
  color: Scalars['String']['output'];
  copiedFromCourseId?: Maybe<Scalars['uuid']['output']>;
  created: Scalars['timestamptz']['output'];
  credits?: Maybe<Scalars['numeric']['output']>;
  defaultDaysOfTheWeek?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradeYears?: Maybe<Scalars['jsonb']['output']>;
  gradingStyle: Grading_Style_Enum;
  id: Scalars['uuid']['output'];
  importedFromOrganizationId?: Maybe<Scalars['uuid']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  numberOfDaysPerWeek: Scalars['Int']['output'];
  numberOfWeeks: Scalars['Int']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  /** An array relationship */
  organizationCourseGroups: Array<Organization_Course_Groups_Courses>;
  /** An aggregate relationship */
  organizationCourseGroups_aggregate: Organization_Course_Groups_Courses_Aggregate;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  parrotRequests: Array<Parrot_Requests>;
  /** An aggregate relationship */
  parrotRequests_aggregate: Parrot_Requests_Aggregate;
  picture?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  studentCourses: Array<Student_Courses>;
  /** An aggregate relationship */
  studentCourses_aggregate: Student_Courses_Aggregate;
  subject?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  useAssignmentTypeWeights?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "courses" */
export type CoursesAssignmentTypeWeightsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesAssignmentTypeWeights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesDefaultDaysOfTheWeekArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "courses" */
export type CoursesGradeYearsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "courses" */
export type CoursesLabelsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "courses" */
export type CoursesOrganizationCourseGroupsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesOrganizationCourseGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesParrotRequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesParrotRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesStudentCoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesStudentCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesSubjectsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "courses" */
export type Courses_Aggregate = {
  __typename?: 'courses_aggregate';
  aggregate?: Maybe<Courses_Aggregate_Fields>;
  nodes: Array<Courses>;
};

export type Courses_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Courses_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Courses_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Courses_Aggregate_Bool_Exp_Count>;
};

export type Courses_Aggregate_Bool_Exp_Bool_And = {
  arguments: Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Courses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Courses_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Courses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "courses" */
export type Courses_Aggregate_Fields = {
  __typename?: 'courses_aggregate_fields';
  avg?: Maybe<Courses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Courses_Max_Fields>;
  min?: Maybe<Courses_Min_Fields>;
  stddev?: Maybe<Courses_Stddev_Fields>;
  stddev_pop?: Maybe<Courses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Courses_Stddev_Samp_Fields>;
  sum?: Maybe<Courses_Sum_Fields>;
  var_pop?: Maybe<Courses_Var_Pop_Fields>;
  var_samp?: Maybe<Courses_Var_Samp_Fields>;
  variance?: Maybe<Courses_Variance_Fields>;
};


/** aggregate fields of "courses" */
export type Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "courses" */
export type Courses_Aggregate_Order_By = {
  avg?: InputMaybe<Courses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Courses_Max_Order_By>;
  min?: InputMaybe<Courses_Min_Order_By>;
  stddev?: InputMaybe<Courses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Courses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Courses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Courses_Sum_Order_By>;
  var_pop?: InputMaybe<Courses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Courses_Var_Samp_Order_By>;
  variance?: InputMaybe<Courses_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Courses_Append_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "courses" */
export type Courses_Arr_Rel_Insert_Input = {
  data: Array<Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};

/** aggregate avg on columns */
export type Courses_Avg_Fields = {
  __typename?: 'courses_avg_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "courses" */
export type Courses_Avg_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export type Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Courses_Bool_Exp>>;
  _not?: InputMaybe<Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Courses_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  assignmentTypeWeights?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
  assignmentTypeWeights_aggregate?: InputMaybe<Assignment_Type_Weights_Aggregate_Bool_Exp>;
  assignments?: InputMaybe<Assignments_Bool_Exp>;
  assignments_aggregate?: InputMaybe<Assignments_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  copiedFromCourseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Numeric_Comparison_Exp>;
  defaultDaysOfTheWeek?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  gradeYears?: InputMaybe<Jsonb_Comparison_Exp>;
  gradingStyle?: InputMaybe<Grading_Style_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importedFromOrganizationId?: InputMaybe<Uuid_Comparison_Exp>;
  introduction?: InputMaybe<String_Comparison_Exp>;
  labels?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfDaysPerWeek?: InputMaybe<Int_Comparison_Exp>;
  numberOfWeeks?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationCourseGroups?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
  organizationCourseGroups_aggregate?: InputMaybe<Organization_Course_Groups_Courses_Aggregate_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  parrotRequests?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Bool_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  studentCourses?: InputMaybe<Student_Courses_Bool_Exp>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subjects?: InputMaybe<Jsonb_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  useAssignmentTypeWeights?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "courses" */
export enum Courses_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursesPkey = 'courses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Courses_Delete_At_Path_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Array<Scalars['String']['input']>>;
  gradeYears?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  subjects?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Courses_Delete_Elem_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['Int']['input']>;
  gradeYears?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Scalars['Int']['input']>;
  subjects?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Courses_Delete_Key_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "courses" */
export type Courses_Inc_Input = {
  credits?: InputMaybe<Scalars['numeric']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "courses" */
export type Courses_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentTypeWeights?: InputMaybe<Assignment_Type_Weights_Arr_Rel_Insert_Input>;
  assignments?: InputMaybe<Assignments_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  copiedFromCourseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  gradingStyle?: InputMaybe<Grading_Style_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importedFromOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationCourseGroups?: InputMaybe<Organization_Course_Groups_Courses_Arr_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequests?: InputMaybe<Parrot_Requests_Arr_Rel_Insert_Input>;
  picture?: InputMaybe<Scalars['String']['input']>;
  studentCourses?: InputMaybe<Student_Courses_Arr_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Courses_Max_Fields = {
  __typename?: 'courses_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  copiedFromCourseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  credits?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importedFromOrganizationId?: Maybe<Scalars['uuid']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "courses" */
export type Courses_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  copiedFromCourseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importedFromOrganizationId?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Courses_Min_Fields = {
  __typename?: 'courses_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  copiedFromCourseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  credits?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importedFromOrganizationId?: Maybe<Scalars['uuid']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "courses" */
export type Courses_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  copiedFromCourseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importedFromOrganizationId?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "courses" */
export type Courses_Mutation_Response = {
  __typename?: 'courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Courses>;
};

/** input type for inserting object relation for remote table "courses" */
export type Courses_Obj_Rel_Insert_Input = {
  data: Courses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};

/** on_conflict condition type for table "courses" */
export type Courses_On_Conflict = {
  constraint: Courses_Constraint;
  update_columns?: Array<Courses_Update_Column>;
  where?: InputMaybe<Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "courses". */
export type Courses_Order_By = {
  archived?: InputMaybe<Order_By>;
  assignmentTypeWeights_aggregate?: InputMaybe<Assignment_Type_Weights_Aggregate_Order_By>;
  assignments_aggregate?: InputMaybe<Assignments_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  copiedFromCourseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  defaultDaysOfTheWeek?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gradeYears?: InputMaybe<Order_By>;
  gradingStyle?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importedFromOrganizationId?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  labels?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationCourseGroups_aggregate?: InputMaybe<Organization_Course_Groups_Courses_Aggregate_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Order_By>;
  picture?: InputMaybe<Order_By>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Order_By>;
  subject?: InputMaybe<Order_By>;
  subjects?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  useAssignmentTypeWeights?: InputMaybe<Order_By>;
};

/** primary key columns input for table: courses */
export type Courses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Courses_Prepend_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "courses" */
export enum Courses_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Color = 'color',
  /** column name */
  CopiedFromCourseId = 'copiedFromCourseId',
  /** column name */
  Created = 'created',
  /** column name */
  Credits = 'credits',
  /** column name */
  DefaultDaysOfTheWeek = 'defaultDaysOfTheWeek',
  /** column name */
  Description = 'description',
  /** column name */
  GradeYears = 'gradeYears',
  /** column name */
  GradingStyle = 'gradingStyle',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedFromOrganizationId = 'importedFromOrganizationId',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  Labels = 'labels',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfDaysPerWeek = 'numberOfDaysPerWeek',
  /** column name */
  NumberOfWeeks = 'numberOfWeeks',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Subject = 'subject',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

/** select "courses_aggregate_bool_exp_bool_and_arguments_columns" columns of table "courses" */
export enum Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

/** select "courses_aggregate_bool_exp_bool_or_arguments_columns" columns of table "courses" */
export enum Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

/** input type for updating data in table "courses" */
export type Courses_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  copiedFromCourseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  gradingStyle?: InputMaybe<Grading_Style_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importedFromOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Courses_Stddev_Fields = {
  __typename?: 'courses_stddev_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "courses" */
export type Courses_Stddev_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Courses_Stddev_Pop_Fields = {
  __typename?: 'courses_stddev_pop_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "courses" */
export type Courses_Stddev_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Courses_Stddev_Samp_Fields = {
  __typename?: 'courses_stddev_samp_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "courses" */
export type Courses_Stddev_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "courses" */
export type Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Courses_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  copiedFromCourseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  gradingStyle?: InputMaybe<Grading_Style_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importedFromOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Courses_Sum_Fields = {
  __typename?: 'courses_sum_fields';
  credits?: Maybe<Scalars['numeric']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "courses" */
export type Courses_Sum_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** update columns of table "courses" */
export enum Courses_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Color = 'color',
  /** column name */
  CopiedFromCourseId = 'copiedFromCourseId',
  /** column name */
  Created = 'created',
  /** column name */
  Credits = 'credits',
  /** column name */
  DefaultDaysOfTheWeek = 'defaultDaysOfTheWeek',
  /** column name */
  Description = 'description',
  /** column name */
  GradeYears = 'gradeYears',
  /** column name */
  GradingStyle = 'gradingStyle',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedFromOrganizationId = 'importedFromOrganizationId',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  Labels = 'labels',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfDaysPerWeek = 'numberOfDaysPerWeek',
  /** column name */
  NumberOfWeeks = 'numberOfWeeks',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Subject = 'subject',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

export type Courses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Courses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Courses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Courses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Courses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Courses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Courses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Courses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Courses_Var_Pop_Fields = {
  __typename?: 'courses_var_pop_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "courses" */
export type Courses_Var_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Courses_Var_Samp_Fields = {
  __typename?: 'courses_var_samp_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "courses" */
export type Courses_Var_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Courses_Variance_Fields = {
  __typename?: 'courses_variance_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "courses" */
export type Courses_Variance_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "custom_assignment_types" */
export type Custom_Assignment_Types = {
  __typename?: 'custom_assignment_types';
  color: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "custom_assignment_types" */
export type Custom_Assignment_Types_Aggregate = {
  __typename?: 'custom_assignment_types_aggregate';
  aggregate?: Maybe<Custom_Assignment_Types_Aggregate_Fields>;
  nodes: Array<Custom_Assignment_Types>;
};

/** aggregate fields of "custom_assignment_types" */
export type Custom_Assignment_Types_Aggregate_Fields = {
  __typename?: 'custom_assignment_types_aggregate_fields';
  avg?: Maybe<Custom_Assignment_Types_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Assignment_Types_Max_Fields>;
  min?: Maybe<Custom_Assignment_Types_Min_Fields>;
  stddev?: Maybe<Custom_Assignment_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Custom_Assignment_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Custom_Assignment_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Custom_Assignment_Types_Sum_Fields>;
  var_pop?: Maybe<Custom_Assignment_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Custom_Assignment_Types_Var_Samp_Fields>;
  variance?: Maybe<Custom_Assignment_Types_Variance_Fields>;
};


/** aggregate fields of "custom_assignment_types" */
export type Custom_Assignment_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Custom_Assignment_Types_Avg_Fields = {
  __typename?: 'custom_assignment_types_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "custom_assignment_types". All fields are combined with a logical 'AND'. */
export type Custom_Assignment_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Assignment_Types_Bool_Exp>>;
  _not?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Assignment_Types_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_assignment_types" */
export enum Custom_Assignment_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentTypesPkey = 'assignment_types_pkey'
}

/** input type for incrementing numeric columns in table "custom_assignment_types" */
export type Custom_Assignment_Types_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "custom_assignment_types" */
export type Custom_Assignment_Types_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Custom_Assignment_Types_Max_Fields = {
  __typename?: 'custom_assignment_types_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Custom_Assignment_Types_Min_Fields = {
  __typename?: 'custom_assignment_types_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "custom_assignment_types" */
export type Custom_Assignment_Types_Mutation_Response = {
  __typename?: 'custom_assignment_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Assignment_Types>;
};

/** input type for inserting object relation for remote table "custom_assignment_types" */
export type Custom_Assignment_Types_Obj_Rel_Insert_Input = {
  data: Custom_Assignment_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Assignment_Types_On_Conflict>;
};

/** on_conflict condition type for table "custom_assignment_types" */
export type Custom_Assignment_Types_On_Conflict = {
  constraint: Custom_Assignment_Types_Constraint;
  update_columns?: Array<Custom_Assignment_Types_Update_Column>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_assignment_types". */
export type Custom_Assignment_Types_Order_By = {
  color?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_assignment_types */
export type Custom_Assignment_Types_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_assignment_types" */
export enum Custom_Assignment_Types_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Created = 'created',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "custom_assignment_types" */
export type Custom_Assignment_Types_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Custom_Assignment_Types_Stddev_Fields = {
  __typename?: 'custom_assignment_types_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Custom_Assignment_Types_Stddev_Pop_Fields = {
  __typename?: 'custom_assignment_types_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Custom_Assignment_Types_Stddev_Samp_Fields = {
  __typename?: 'custom_assignment_types_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "custom_assignment_types" */
export type Custom_Assignment_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Assignment_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Assignment_Types_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Custom_Assignment_Types_Sum_Fields = {
  __typename?: 'custom_assignment_types_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "custom_assignment_types" */
export enum Custom_Assignment_Types_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Created = 'created',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Custom_Assignment_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Custom_Assignment_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Assignment_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Assignment_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Custom_Assignment_Types_Var_Pop_Fields = {
  __typename?: 'custom_assignment_types_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Custom_Assignment_Types_Var_Samp_Fields = {
  __typename?: 'custom_assignment_types_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Custom_Assignment_Types_Variance_Fields = {
  __typename?: 'custom_assignment_types_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "customers" */
export type Customers = {
  __typename?: 'customers';
  created: Scalars['timestamptz']['output'];
  extendedTrial: Scalars['Boolean']['output'];
  freeTrialEnd: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  organizationSubscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  parrotCredits: Scalars['Int']['output'];
  planTier: Plan_Tier_Enum;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "customers" */
export type Customers_Aggregate = {
  __typename?: 'customers_aggregate';
  aggregate?: Maybe<Customers_Aggregate_Fields>;
  nodes: Array<Customers>;
};

/** aggregate fields of "customers" */
export type Customers_Aggregate_Fields = {
  __typename?: 'customers_aggregate_fields';
  avg?: Maybe<Customers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customers_Max_Fields>;
  min?: Maybe<Customers_Min_Fields>;
  stddev?: Maybe<Customers_Stddev_Fields>;
  stddev_pop?: Maybe<Customers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customers_Stddev_Samp_Fields>;
  sum?: Maybe<Customers_Sum_Fields>;
  var_pop?: Maybe<Customers_Var_Pop_Fields>;
  var_samp?: Maybe<Customers_Var_Samp_Fields>;
  variance?: Maybe<Customers_Variance_Fields>;
};


/** aggregate fields of "customers" */
export type Customers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Customers_Avg_Fields = {
  __typename?: 'customers_avg_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "customers". All fields are combined with a logical 'AND'. */
export type Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Customers_Bool_Exp>>;
  _not?: InputMaybe<Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Customers_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  extendedTrial?: InputMaybe<Boolean_Comparison_Exp>;
  freeTrialEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  organizationSubscriptionExpiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  parrotCredits?: InputMaybe<Int_Comparison_Exp>;
  planTier?: InputMaybe<Plan_Tier_Enum_Comparison_Exp>;
  subscriptionStatus?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "customers" */
export enum Customers_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomersPkey = 'customers_pkey',
  /** unique or primary key constraint on columns "teacher_id" */
  CustomersTeacherIdKey = 'customers_teacher_id_key'
}

/** input type for incrementing numeric columns in table "customers" */
export type Customers_Inc_Input = {
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "customers" */
export type Customers_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  extendedTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationSubscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
  planTier?: InputMaybe<Plan_Tier_Enum>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Customers_Max_Fields = {
  __typename?: 'customers_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  freeTrialEnd?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationSubscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  parrotCredits?: Maybe<Scalars['Int']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Customers_Min_Fields = {
  __typename?: 'customers_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  freeTrialEnd?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationSubscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  parrotCredits?: Maybe<Scalars['Int']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "customers" */
export type Customers_Mutation_Response = {
  __typename?: 'customers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customers>;
};

/** input type for inserting object relation for remote table "customers" */
export type Customers_Obj_Rel_Insert_Input = {
  data: Customers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};

/** on_conflict condition type for table "customers" */
export type Customers_On_Conflict = {
  constraint: Customers_Constraint;
  update_columns?: Array<Customers_Update_Column>;
  where?: InputMaybe<Customers_Bool_Exp>;
};

/** Ordering options when selecting data from "customers". */
export type Customers_Order_By = {
  created?: InputMaybe<Order_By>;
  extendedTrial?: InputMaybe<Order_By>;
  freeTrialEnd?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationSubscriptionExpiration?: InputMaybe<Order_By>;
  parrotCredits?: InputMaybe<Order_By>;
  planTier?: InputMaybe<Order_By>;
  subscriptionStatus?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customers */
export type Customers_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "customers" */
export enum Customers_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  ExtendedTrial = 'extendedTrial',
  /** column name */
  FreeTrialEnd = 'freeTrialEnd',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationSubscriptionExpiration = 'organizationSubscriptionExpiration',
  /** column name */
  ParrotCredits = 'parrotCredits',
  /** column name */
  PlanTier = 'planTier',
  /** column name */
  SubscriptionStatus = 'subscriptionStatus',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "customers" */
export type Customers_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  extendedTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationSubscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
  planTier?: InputMaybe<Plan_Tier_Enum>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Customers_Stddev_Fields = {
  __typename?: 'customers_stddev_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Customers_Stddev_Pop_Fields = {
  __typename?: 'customers_stddev_pop_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Customers_Stddev_Samp_Fields = {
  __typename?: 'customers_stddev_samp_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "customers" */
export type Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customers_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  extendedTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationSubscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
  planTier?: InputMaybe<Plan_Tier_Enum>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Customers_Sum_Fields = {
  __typename?: 'customers_sum_fields';
  parrotCredits?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "customers" */
export enum Customers_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  ExtendedTrial = 'extendedTrial',
  /** column name */
  FreeTrialEnd = 'freeTrialEnd',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationSubscriptionExpiration = 'organizationSubscriptionExpiration',
  /** column name */
  ParrotCredits = 'parrotCredits',
  /** column name */
  PlanTier = 'planTier',
  /** column name */
  SubscriptionStatus = 'subscriptionStatus',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Customers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customers_Var_Pop_Fields = {
  __typename?: 'customers_var_pop_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Customers_Var_Samp_Fields = {
  __typename?: 'customers_var_samp_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Customers_Variance_Fields = {
  __typename?: 'customers_variance_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "event_ignored_courses" */
export type Event_Ignored_Courses = {
  __typename?: 'event_ignored_courses';
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid']['output'];
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "event_ignored_courses" */
export type Event_Ignored_Courses_Aggregate = {
  __typename?: 'event_ignored_courses_aggregate';
  aggregate?: Maybe<Event_Ignored_Courses_Aggregate_Fields>;
  nodes: Array<Event_Ignored_Courses>;
};

export type Event_Ignored_Courses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Event_Ignored_Courses_Aggregate_Bool_Exp_Count>;
};

export type Event_Ignored_Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "event_ignored_courses" */
export type Event_Ignored_Courses_Aggregate_Fields = {
  __typename?: 'event_ignored_courses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Event_Ignored_Courses_Max_Fields>;
  min?: Maybe<Event_Ignored_Courses_Min_Fields>;
};


/** aggregate fields of "event_ignored_courses" */
export type Event_Ignored_Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "event_ignored_courses" */
export type Event_Ignored_Courses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Event_Ignored_Courses_Max_Order_By>;
  min?: InputMaybe<Event_Ignored_Courses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "event_ignored_courses" */
export type Event_Ignored_Courses_Arr_Rel_Insert_Input = {
  data: Array<Event_Ignored_Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Ignored_Courses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "event_ignored_courses". All fields are combined with a logical 'AND'. */
export type Event_Ignored_Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Ignored_Courses_Bool_Exp>>;
  _not?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Ignored_Courses_Bool_Exp>>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_ignored_courses" */
export enum Event_Ignored_Courses_Constraint {
  /** unique or primary key constraint on columns "course_id", "event_id" */
  EventIgnoredCoursesPkey = 'event_ignored_courses_pkey'
}

/** input type for inserting data into table "event_ignored_courses" */
export type Event_Ignored_Courses_Insert_Input = {
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Event_Ignored_Courses_Max_Fields = {
  __typename?: 'event_ignored_courses_max_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "event_ignored_courses" */
export type Event_Ignored_Courses_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Ignored_Courses_Min_Fields = {
  __typename?: 'event_ignored_courses_min_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "event_ignored_courses" */
export type Event_Ignored_Courses_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "event_ignored_courses" */
export type Event_Ignored_Courses_Mutation_Response = {
  __typename?: 'event_ignored_courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Ignored_Courses>;
};

/** on_conflict condition type for table "event_ignored_courses" */
export type Event_Ignored_Courses_On_Conflict = {
  constraint: Event_Ignored_Courses_Constraint;
  update_columns?: Array<Event_Ignored_Courses_Update_Column>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "event_ignored_courses". */
export type Event_Ignored_Courses_Order_By = {
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_ignored_courses */
export type Event_Ignored_Courses_Pk_Columns_Input = {
  courseId: Scalars['uuid']['input'];
  eventId: Scalars['uuid']['input'];
};

/** select columns of table "event_ignored_courses" */
export enum Event_Ignored_Courses_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "event_ignored_courses" */
export type Event_Ignored_Courses_Set_Input = {
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "event_ignored_courses" */
export type Event_Ignored_Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Ignored_Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Ignored_Courses_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "event_ignored_courses" */
export enum Event_Ignored_Courses_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Updated = 'updated'
}

export type Event_Ignored_Courses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Ignored_Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Event_Ignored_Courses_Bool_Exp;
};

/** columns and relationships of "event_t" */
export type Event_T = {
  __typename?: 'event_t';
  value: Scalars['String']['output'];
};

/** aggregated selection of "event_t" */
export type Event_T_Aggregate = {
  __typename?: 'event_t_aggregate';
  aggregate?: Maybe<Event_T_Aggregate_Fields>;
  nodes: Array<Event_T>;
};

/** aggregate fields of "event_t" */
export type Event_T_Aggregate_Fields = {
  __typename?: 'event_t_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Event_T_Max_Fields>;
  min?: Maybe<Event_T_Min_Fields>;
};


/** aggregate fields of "event_t" */
export type Event_T_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_T_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "event_t". All fields are combined with a logical 'AND'. */
export type Event_T_Bool_Exp = {
  _and?: InputMaybe<Array<Event_T_Bool_Exp>>;
  _not?: InputMaybe<Event_T_Bool_Exp>;
  _or?: InputMaybe<Array<Event_T_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_t" */
export enum Event_T_Constraint {
  /** unique or primary key constraint on columns "value" */
  EventTypePkey = 'event_type_pkey'
}

export enum Event_T_Enum {
  Other = 'OTHER',
  Vacation = 'VACATION'
}

/** Boolean expression to compare columns of type "event_t_enum". All fields are combined with logical 'AND'. */
export type Event_T_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Event_T_Enum>;
  _in?: InputMaybe<Array<Event_T_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Event_T_Enum>;
  _nin?: InputMaybe<Array<Event_T_Enum>>;
};

/** input type for inserting data into table "event_t" */
export type Event_T_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Event_T_Max_Fields = {
  __typename?: 'event_t_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Event_T_Min_Fields = {
  __typename?: 'event_t_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "event_t" */
export type Event_T_Mutation_Response = {
  __typename?: 'event_t_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_T>;
};

/** on_conflict condition type for table "event_t" */
export type Event_T_On_Conflict = {
  constraint: Event_T_Constraint;
  update_columns?: Array<Event_T_Update_Column>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};

/** Ordering options when selecting data from "event_t". */
export type Event_T_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_t */
export type Event_T_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "event_t" */
export enum Event_T_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_t" */
export type Event_T_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "event_t" */
export type Event_T_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_T_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_T_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "event_t" */
export enum Event_T_Update_Column {
  /** column name */
  Value = 'value'
}

export type Event_T_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_T_Set_Input>;
  /** filter the rows which have to be updated */
  where: Event_T_Bool_Exp;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  created: Scalars['timestamptz']['output'];
  end: Scalars['date']['output'];
  eventType: Event_T_Enum;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  ignoredCourses: Array<Event_Ignored_Courses>;
  /** An aggregate relationship */
  ignoredCourses_aggregate: Event_Ignored_Courses_Aggregate;
  name?: Maybe<Scalars['String']['output']>;
  start: Scalars['date']['output'];
  /** An array relationship */
  studentEvents: Array<Student_Events>;
  /** An aggregate relationship */
  studentEvents_aggregate: Student_Events_Aggregate;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "events" */
export type EventsIgnoredCoursesArgs = {
  distinct_on?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Ignored_Courses_Order_By>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsIgnoredCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Ignored_Courses_Order_By>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsStudentEventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsStudentEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

export type Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Events_Aggregate_Bool_Exp_Count>;
};

export type Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "events" */
export type Events_Arr_Rel_Insert_Input = {
  data: Array<Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  eventType?: InputMaybe<Event_T_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ignoredCourses?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
  ignoredCourses_aggregate?: InputMaybe<Event_Ignored_Courses_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  studentEvents?: InputMaybe<Student_Events_Bool_Exp>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Bool_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  VacationsPkey = 'vacations_pkey'
}

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<Event_T_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredCourses?: InputMaybe<Event_Ignored_Courses_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  studentEvents?: InputMaybe<Student_Events_Arr_Rel_Insert_Input>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type Events_Obj_Rel_Insert_Input = {
  data: Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  eventType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredCourses_aggregate?: InputMaybe<Event_Ignored_Courses_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  End = 'end',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Start = 'start',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<Event_T_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<Event_T_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  End = 'end',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Start = 'start',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp;
};

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  assignment?: Maybe<Assignments>;
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  parrotRequest?: Maybe<Parrot_Requests>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  printingJob?: Maybe<Printing_Jobs>;
  printingJobId?: Maybe<Scalars['uuid']['output']>;
  size: Scalars['bigint']['output'];
  /** An object relationship */
  studentAssignment?: Maybe<Student_Assignments>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  assignment?: InputMaybe<Assignments_Bool_Exp>;
  assignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parrotRequest?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  printingJob?: InputMaybe<Printing_Jobs_Bool_Exp>;
  printingJobId?: InputMaybe<Uuid_Comparison_Exp>;
  size?: InputMaybe<Bigint_Comparison_Exp>;
  studentAssignment?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey',
  /** unique or primary key constraint on columns "printing_job_id" */
  FilesPrintingJobIdKey = 'files_printing_job_id_key'
}

/** input type for incrementing numeric columns in table "files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  assignment?: InputMaybe<Assignments_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequest?: InputMaybe<Parrot_Requests_Obj_Rel_Insert_Input>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  printingJob?: InputMaybe<Printing_Jobs_Obj_Rel_Insert_Input>;
  printingJobId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  studentAssignment?: InputMaybe<Student_Assignments_Obj_Rel_Insert_Input>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  printingJobId?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "files" */
export type Files_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  printingJobId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  printingJobId?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "files" */
export type Files_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  printingJobId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  assignment?: InputMaybe<Assignments_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parrotRequest?: InputMaybe<Parrot_Requests_Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  printingJob?: InputMaybe<Printing_Jobs_Order_By>;
  printingJobId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  studentAssignment?: InputMaybe<Student_Assignments_Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  PrintingJobId = 'printingJobId',
  /** column name */
  Size = 'size',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  Updated = 'updated',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  printingJobId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  printingJobId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  PrintingJobId = 'printingJobId',
  /** column name */
  Size = 'size',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  Updated = 'updated',
  /** column name */
  Url = 'url'
}

export type Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "grading_style" */
export type Grading_Style = {
  __typename?: 'grading_style';
  value: Scalars['String']['output'];
};

/** aggregated selection of "grading_style" */
export type Grading_Style_Aggregate = {
  __typename?: 'grading_style_aggregate';
  aggregate?: Maybe<Grading_Style_Aggregate_Fields>;
  nodes: Array<Grading_Style>;
};

/** aggregate fields of "grading_style" */
export type Grading_Style_Aggregate_Fields = {
  __typename?: 'grading_style_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Grading_Style_Max_Fields>;
  min?: Maybe<Grading_Style_Min_Fields>;
};


/** aggregate fields of "grading_style" */
export type Grading_Style_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grading_Style_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "grading_style". All fields are combined with a logical 'AND'. */
export type Grading_Style_Bool_Exp = {
  _and?: InputMaybe<Array<Grading_Style_Bool_Exp>>;
  _not?: InputMaybe<Grading_Style_Bool_Exp>;
  _or?: InputMaybe<Array<Grading_Style_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "grading_style" */
export enum Grading_Style_Constraint {
  /** unique or primary key constraint on columns "value" */
  GradingStylePkey = 'grading_style_pkey'
}

export enum Grading_Style_Enum {
  Percent = 'PERCENT',
  Point = 'POINT',
  Ungraded = 'UNGRADED'
}

/** Boolean expression to compare columns of type "grading_style_enum". All fields are combined with logical 'AND'. */
export type Grading_Style_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Grading_Style_Enum>;
  _in?: InputMaybe<Array<Grading_Style_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Grading_Style_Enum>;
  _nin?: InputMaybe<Array<Grading_Style_Enum>>;
};

/** input type for inserting data into table "grading_style" */
export type Grading_Style_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Grading_Style_Max_Fields = {
  __typename?: 'grading_style_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Grading_Style_Min_Fields = {
  __typename?: 'grading_style_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "grading_style" */
export type Grading_Style_Mutation_Response = {
  __typename?: 'grading_style_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Grading_Style>;
};

/** on_conflict condition type for table "grading_style" */
export type Grading_Style_On_Conflict = {
  constraint: Grading_Style_Constraint;
  update_columns?: Array<Grading_Style_Update_Column>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};

/** Ordering options when selecting data from "grading_style". */
export type Grading_Style_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grading_style */
export type Grading_Style_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "grading_style" */
export enum Grading_Style_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grading_style" */
export type Grading_Style_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "grading_style" */
export type Grading_Style_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grading_Style_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grading_Style_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "grading_style" */
export enum Grading_Style_Update_Column {
  /** column name */
  Value = 'value'
}

export type Grading_Style_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grading_Style_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grading_Style_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "assignments" */
  delete_assignment?: Maybe<Assignments>;
  /** delete data from the table: "assignment_type" */
  delete_assignment_type?: Maybe<Assignment_Type_Mutation_Response>;
  /** delete single row from the table: "assignment_type" */
  delete_assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** delete single row from the table: "assignment_type_weights" */
  delete_assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** delete data from the table: "assignment_type_weights" */
  delete_assignment_type_weights?: Maybe<Assignment_Type_Weights_Mutation_Response>;
  /** delete data from the table: "assignments" */
  delete_assignments?: Maybe<Assignments_Mutation_Response>;
  /** delete single row from the table: "comments" */
  delete_comment?: Maybe<Comments>;
  /** delete data from the table: "comments" */
  delete_comments?: Maybe<Comments_Mutation_Response>;
  /** delete single row from the table: "courses" */
  delete_course?: Maybe<Courses>;
  /** delete single row from the table: "course_share_links" */
  delete_course_share_link?: Maybe<Course_Share_Links>;
  /** delete data from the table: "course_share_links" */
  delete_course_share_links?: Maybe<Course_Share_Links_Mutation_Response>;
  /** delete data from the table: "courses" */
  delete_courses?: Maybe<Courses_Mutation_Response>;
  /** delete single row from the table: "custom_assignment_types" */
  delete_custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** delete data from the table: "custom_assignment_types" */
  delete_custom_assignment_types?: Maybe<Custom_Assignment_Types_Mutation_Response>;
  /** delete single row from the table: "customers" */
  delete_customer?: Maybe<Customers>;
  /** delete data from the table: "customers" */
  delete_customers?: Maybe<Customers_Mutation_Response>;
  /** delete single row from the table: "events" */
  delete_event?: Maybe<Events>;
  /** delete data from the table: "event_ignored_courses" */
  delete_event_ignored_courses?: Maybe<Event_Ignored_Courses_Mutation_Response>;
  /** delete single row from the table: "event_ignored_courses" */
  delete_event_ignored_courses_by_pk?: Maybe<Event_Ignored_Courses>;
  /** delete data from the table: "event_t" */
  delete_event_t?: Maybe<Event_T_Mutation_Response>;
  /** delete single row from the table: "event_t" */
  delete_event_type?: Maybe<Event_T>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_file?: Maybe<Files>;
  /** delete data from the table: "files" */
  delete_files?: Maybe<Files_Mutation_Response>;
  /** delete data from the table: "grading_style" */
  delete_grading_style?: Maybe<Grading_Style_Mutation_Response>;
  /** delete single row from the table: "grading_style" */
  delete_grading_style_by_pk?: Maybe<Grading_Style>;
  /** delete single row from the table: "organizations" */
  delete_organization?: Maybe<Organizations>;
  /** delete single row from the table: "organization_admins" */
  delete_organization_admin?: Maybe<Organization_Admins>;
  /** delete data from the table: "organization_admins" */
  delete_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** delete single row from the table: "organization_codes" */
  delete_organization_code?: Maybe<Organization_Codes>;
  /** delete data from the table: "organization_codes" */
  delete_organization_codes?: Maybe<Organization_Codes_Mutation_Response>;
  /** delete single row from the table: "organization_course_groups" */
  delete_organization_course_group?: Maybe<Organization_Course_Groups>;
  /** delete data from the table: "organization_course_groups" */
  delete_organization_course_groups?: Maybe<Organization_Course_Groups_Mutation_Response>;
  /** delete data from the table: "organization_course_groups_courses" */
  delete_organization_course_groups_courses?: Maybe<Organization_Course_Groups_Courses_Mutation_Response>;
  /** delete single row from the table: "organization_course_groups_courses" */
  delete_organization_course_groups_courses_by_pk?: Maybe<Organization_Course_Groups_Courses>;
  /** delete data from the table: "organization_course_groups_organization_codes" */
  delete_organization_course_groups_organization_codes?: Maybe<Organization_Course_Groups_Organization_Codes_Mutation_Response>;
  /** delete single row from the table: "organization_course_groups_organization_codes" */
  delete_organization_course_groups_organization_codes_by_pk?: Maybe<Organization_Course_Groups_Organization_Codes>;
  /** delete data from the table: "organization_course_groups_teachers" */
  delete_organization_course_groups_teachers?: Maybe<Organization_Course_Groups_Teachers_Mutation_Response>;
  /** delete single row from the table: "organization_course_groups_teachers" */
  delete_organization_course_groups_teachers_by_pk?: Maybe<Organization_Course_Groups_Teachers>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<Organizations_Mutation_Response>;
  /** delete single row from the table: "parrot_requests" */
  delete_parrot_request?: Maybe<Parrot_Requests>;
  /** delete data from the table: "parrot_request_status" */
  delete_parrot_request_status?: Maybe<Parrot_Request_Status_Mutation_Response>;
  /** delete single row from the table: "parrot_request_status" */
  delete_parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** delete data from the table: "parrot_requests" */
  delete_parrot_requests?: Maybe<Parrot_Requests_Mutation_Response>;
  /** delete data from the table: "plan_tier" */
  delete_plan_tier?: Maybe<Plan_Tier_Mutation_Response>;
  /** delete single row from the table: "plan_tier" */
  delete_plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** delete single row from the table: "printing_jobs" */
  delete_printing_job?: Maybe<Printing_Jobs>;
  /** delete data from the table: "printing_job_status" */
  delete_printing_job_status?: Maybe<Printing_Job_Status_Mutation_Response>;
  /** delete single row from the table: "printing_job_status" */
  delete_printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** delete data from the table: "printing_job_type" */
  delete_printing_job_type?: Maybe<Printing_Job_Type_Mutation_Response>;
  /** delete single row from the table: "printing_job_type" */
  delete_printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** delete data from the table: "printing_jobs" */
  delete_printing_jobs?: Maybe<Printing_Jobs_Mutation_Response>;
  /** delete single row from the table: "reschedule_actions" */
  delete_reschedule_action?: Maybe<Reschedule_Actions>;
  /** delete data from the table: "reschedule_action_statuses" */
  delete_reschedule_action_statuses?: Maybe<Reschedule_Action_Statuses_Mutation_Response>;
  /** delete single row from the table: "reschedule_action_statuses" */
  delete_reschedule_action_statuses_by_pk?: Maybe<Reschedule_Action_Statuses>;
  /** delete data from the table: "reschedule_action_types" */
  delete_reschedule_action_types?: Maybe<Reschedule_Action_Types_Mutation_Response>;
  /** delete single row from the table: "reschedule_action_types" */
  delete_reschedule_action_types_by_pk?: Maybe<Reschedule_Action_Types>;
  /** delete data from the table: "reschedule_actions" */
  delete_reschedule_actions?: Maybe<Reschedule_Actions_Mutation_Response>;
  /** delete data from the table: "school_year" */
  delete_school_year?: Maybe<School_Year_Mutation_Response>;
  /** delete single row from the table: "school_year" */
  delete_school_year_by_pk?: Maybe<School_Year>;
  /** delete single row from the table: "students" */
  delete_student?: Maybe<Students>;
  /** delete single row from the table: "student_accounts" */
  delete_student_account?: Maybe<Student_Accounts>;
  /** delete data from the table: "student_accounts" */
  delete_student_accounts?: Maybe<Student_Accounts_Mutation_Response>;
  /** delete single row from the table: "student_assignments" */
  delete_student_assignment?: Maybe<Student_Assignments>;
  /** delete data from the table: "student_assignment_status" */
  delete_student_assignment_status?: Maybe<Student_Assignment_Status_Mutation_Response>;
  /** delete single row from the table: "student_assignment_status" */
  delete_student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** delete data from the table: "student_assignments" */
  delete_student_assignments?: Maybe<Student_Assignments_Mutation_Response>;
  /** delete single row from the table: "student_courses" */
  delete_student_course?: Maybe<Student_Courses>;
  /** delete data from the table: "student_course_status" */
  delete_student_course_status?: Maybe<Student_Course_Status_Mutation_Response>;
  /** delete single row from the table: "student_course_status" */
  delete_student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** delete data from the table: "student_courses" */
  delete_student_courses?: Maybe<Student_Courses_Mutation_Response>;
  /** delete single row from the table: "student_events" */
  delete_student_event?: Maybe<Student_Events>;
  /** delete data from the table: "student_events" */
  delete_student_events?: Maybe<Student_Events_Mutation_Response>;
  /** delete data from the table: "students" */
  delete_students?: Maybe<Students_Mutation_Response>;
  /** delete single row from the table: "teachers" */
  delete_teacher?: Maybe<Teachers>;
  /** delete data from the table: "teachers" */
  delete_teachers?: Maybe<Teachers_Mutation_Response>;
  /** delete data from the table: "teachers_students" */
  delete_teachers_students?: Maybe<Teachers_Students_Mutation_Response>;
  /** delete single row from the table: "teachers_students" */
  delete_teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** delete data from the table: "themes" */
  delete_themes?: Maybe<Themes_Mutation_Response>;
  /** delete single row from the table: "themes" */
  delete_themes_by_pk?: Maybe<Themes>;
  /** delete single row from the table: "transcript_drafts" */
  delete_transcript_draft?: Maybe<Transcript_Drafts>;
  /** delete data from the table: "transcript_drafts" */
  delete_transcript_drafts?: Maybe<Transcript_Drafts_Mutation_Response>;
  /** delete data from the table: "user_settings" */
  delete_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** delete single row from the table: "user_settings" */
  delete_user_settings_by_pk?: Maybe<User_Settings>;
  /** insert a single row into the table: "assignments" */
  insert_assignment?: Maybe<Assignments>;
  /** insert data into the table: "assignment_type" */
  insert_assignment_type?: Maybe<Assignment_Type_Mutation_Response>;
  /** insert a single row into the table: "assignment_type" */
  insert_assignment_type_one?: Maybe<Assignment_Type>;
  /** insert a single row into the table: "assignment_type_weights" */
  insert_assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** insert data into the table: "assignment_type_weights" */
  insert_assignment_type_weights?: Maybe<Assignment_Type_Weights_Mutation_Response>;
  /** insert data into the table: "assignments" */
  insert_assignments?: Maybe<Assignments_Mutation_Response>;
  /** insert a single row into the table: "comments" */
  insert_comment?: Maybe<Comments>;
  /** insert data into the table: "comments" */
  insert_comments?: Maybe<Comments_Mutation_Response>;
  /** insert a single row into the table: "courses" */
  insert_course?: Maybe<Courses>;
  /** insert a single row into the table: "course_share_links" */
  insert_course_share_link?: Maybe<Course_Share_Links>;
  /** insert data into the table: "course_share_links" */
  insert_course_share_links?: Maybe<Course_Share_Links_Mutation_Response>;
  /** insert data into the table: "courses" */
  insert_courses?: Maybe<Courses_Mutation_Response>;
  /** insert a single row into the table: "custom_assignment_types" */
  insert_custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** insert data into the table: "custom_assignment_types" */
  insert_custom_assignment_types?: Maybe<Custom_Assignment_Types_Mutation_Response>;
  /** insert a single row into the table: "customers" */
  insert_customer?: Maybe<Customers>;
  /** insert data into the table: "customers" */
  insert_customers?: Maybe<Customers_Mutation_Response>;
  /** insert a single row into the table: "events" */
  insert_event?: Maybe<Events>;
  /** insert data into the table: "event_ignored_courses" */
  insert_event_ignored_courses?: Maybe<Event_Ignored_Courses_Mutation_Response>;
  /** insert a single row into the table: "event_ignored_courses" */
  insert_event_ignored_courses_one?: Maybe<Event_Ignored_Courses>;
  /** insert data into the table: "event_t" */
  insert_event_t?: Maybe<Event_T_Mutation_Response>;
  /** insert a single row into the table: "event_t" */
  insert_event_type?: Maybe<Event_T>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_file?: Maybe<Files>;
  /** insert data into the table: "files" */
  insert_files?: Maybe<Files_Mutation_Response>;
  /** insert data into the table: "grading_style" */
  insert_grading_style?: Maybe<Grading_Style_Mutation_Response>;
  /** insert a single row into the table: "grading_style" */
  insert_grading_style_one?: Maybe<Grading_Style>;
  /** insert a single row into the table: "organizations" */
  insert_organization?: Maybe<Organizations>;
  /** insert a single row into the table: "organization_admins" */
  insert_organization_admin?: Maybe<Organization_Admins>;
  /** insert data into the table: "organization_admins" */
  insert_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** insert a single row into the table: "organization_codes" */
  insert_organization_code?: Maybe<Organization_Codes>;
  /** insert data into the table: "organization_codes" */
  insert_organization_codes?: Maybe<Organization_Codes_Mutation_Response>;
  /** insert a single row into the table: "organization_course_groups" */
  insert_organization_course_group?: Maybe<Organization_Course_Groups>;
  /** insert data into the table: "organization_course_groups" */
  insert_organization_course_groups?: Maybe<Organization_Course_Groups_Mutation_Response>;
  /** insert data into the table: "organization_course_groups_courses" */
  insert_organization_course_groups_courses?: Maybe<Organization_Course_Groups_Courses_Mutation_Response>;
  /** insert a single row into the table: "organization_course_groups_courses" */
  insert_organization_course_groups_courses_one?: Maybe<Organization_Course_Groups_Courses>;
  /** insert data into the table: "organization_course_groups_organization_codes" */
  insert_organization_course_groups_organization_codes?: Maybe<Organization_Course_Groups_Organization_Codes_Mutation_Response>;
  /** insert a single row into the table: "organization_course_groups_organization_codes" */
  insert_organization_course_groups_organization_codes_one?: Maybe<Organization_Course_Groups_Organization_Codes>;
  /** insert data into the table: "organization_course_groups_teachers" */
  insert_organization_course_groups_teachers?: Maybe<Organization_Course_Groups_Teachers_Mutation_Response>;
  /** insert a single row into the table: "organization_course_groups_teachers" */
  insert_organization_course_groups_teachers_one?: Maybe<Organization_Course_Groups_Teachers>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<Organizations_Mutation_Response>;
  /** insert a single row into the table: "parrot_requests" */
  insert_parrot_request?: Maybe<Parrot_Requests>;
  /** insert data into the table: "parrot_request_status" */
  insert_parrot_request_status?: Maybe<Parrot_Request_Status_Mutation_Response>;
  /** insert a single row into the table: "parrot_request_status" */
  insert_parrot_request_status_one?: Maybe<Parrot_Request_Status>;
  /** insert data into the table: "parrot_requests" */
  insert_parrot_requests?: Maybe<Parrot_Requests_Mutation_Response>;
  /** insert data into the table: "plan_tier" */
  insert_plan_tier?: Maybe<Plan_Tier_Mutation_Response>;
  /** insert a single row into the table: "plan_tier" */
  insert_plan_tier_one?: Maybe<Plan_Tier>;
  /** insert a single row into the table: "printing_jobs" */
  insert_printing_job?: Maybe<Printing_Jobs>;
  /** insert data into the table: "printing_job_status" */
  insert_printing_job_status?: Maybe<Printing_Job_Status_Mutation_Response>;
  /** insert a single row into the table: "printing_job_status" */
  insert_printing_job_status_one?: Maybe<Printing_Job_Status>;
  /** insert data into the table: "printing_job_type" */
  insert_printing_job_type?: Maybe<Printing_Job_Type_Mutation_Response>;
  /** insert a single row into the table: "printing_job_type" */
  insert_printing_job_type_one?: Maybe<Printing_Job_Type>;
  /** insert data into the table: "printing_jobs" */
  insert_printing_jobs?: Maybe<Printing_Jobs_Mutation_Response>;
  /** insert a single row into the table: "reschedule_actions" */
  insert_reschedule_action?: Maybe<Reschedule_Actions>;
  /** insert data into the table: "reschedule_action_statuses" */
  insert_reschedule_action_statuses?: Maybe<Reschedule_Action_Statuses_Mutation_Response>;
  /** insert a single row into the table: "reschedule_action_statuses" */
  insert_reschedule_action_statuses_one?: Maybe<Reschedule_Action_Statuses>;
  /** insert data into the table: "reschedule_action_types" */
  insert_reschedule_action_types?: Maybe<Reschedule_Action_Types_Mutation_Response>;
  /** insert a single row into the table: "reschedule_action_types" */
  insert_reschedule_action_types_one?: Maybe<Reschedule_Action_Types>;
  /** insert data into the table: "reschedule_actions" */
  insert_reschedule_actions?: Maybe<Reschedule_Actions_Mutation_Response>;
  /** insert data into the table: "school_year" */
  insert_school_year?: Maybe<School_Year_Mutation_Response>;
  /** insert a single row into the table: "school_year" */
  insert_school_year_one?: Maybe<School_Year>;
  /** insert a single row into the table: "students" */
  insert_student?: Maybe<Students>;
  /** insert a single row into the table: "student_accounts" */
  insert_student_account?: Maybe<Student_Accounts>;
  /** insert data into the table: "student_accounts" */
  insert_student_accounts?: Maybe<Student_Accounts_Mutation_Response>;
  /** insert a single row into the table: "student_assignments" */
  insert_student_assignment?: Maybe<Student_Assignments>;
  /** insert data into the table: "student_assignment_status" */
  insert_student_assignment_status?: Maybe<Student_Assignment_Status_Mutation_Response>;
  /** insert a single row into the table: "student_assignment_status" */
  insert_student_assignment_status_one?: Maybe<Student_Assignment_Status>;
  /** insert data into the table: "student_assignments" */
  insert_student_assignments?: Maybe<Student_Assignments_Mutation_Response>;
  /** insert a single row into the table: "student_courses" */
  insert_student_course?: Maybe<Student_Courses>;
  /** insert data into the table: "student_course_status" */
  insert_student_course_status?: Maybe<Student_Course_Status_Mutation_Response>;
  /** insert a single row into the table: "student_course_status" */
  insert_student_course_status_one?: Maybe<Student_Course_Status>;
  /** insert data into the table: "student_courses" */
  insert_student_courses?: Maybe<Student_Courses_Mutation_Response>;
  /** insert a single row into the table: "student_events" */
  insert_student_event?: Maybe<Student_Events>;
  /** insert data into the table: "student_events" */
  insert_student_events?: Maybe<Student_Events_Mutation_Response>;
  /** insert data into the table: "students" */
  insert_students?: Maybe<Students_Mutation_Response>;
  /** insert a single row into the table: "teachers" */
  insert_teacher?: Maybe<Teachers>;
  /** insert data into the table: "teachers" */
  insert_teachers?: Maybe<Teachers_Mutation_Response>;
  /** insert data into the table: "teachers_students" */
  insert_teachers_students?: Maybe<Teachers_Students_Mutation_Response>;
  /** insert a single row into the table: "teachers_students" */
  insert_teachers_students_one?: Maybe<Teachers_Students>;
  /** insert data into the table: "themes" */
  insert_themes?: Maybe<Themes_Mutation_Response>;
  /** insert a single row into the table: "themes" */
  insert_themes_one?: Maybe<Themes>;
  /** insert a single row into the table: "transcript_drafts" */
  insert_transcript_draft?: Maybe<Transcript_Drafts>;
  /** insert data into the table: "transcript_drafts" */
  insert_transcript_drafts?: Maybe<Transcript_Drafts_Mutation_Response>;
  /** insert data into the table: "user_settings" */
  insert_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** insert a single row into the table: "user_settings" */
  insert_user_settings_one?: Maybe<User_Settings>;
  /** update single row of the table: "assignments" */
  update_assignment?: Maybe<Assignments>;
  /** update data of the table: "assignment_type" */
  update_assignment_type?: Maybe<Assignment_Type_Mutation_Response>;
  /** update single row of the table: "assignment_type" */
  update_assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** update multiples rows of table: "assignment_type" */
  update_assignment_type_many?: Maybe<Array<Maybe<Assignment_Type_Mutation_Response>>>;
  /** update single row of the table: "assignment_type_weights" */
  update_assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** update data of the table: "assignment_type_weights" */
  update_assignment_type_weights?: Maybe<Assignment_Type_Weights_Mutation_Response>;
  /** update multiples rows of table: "assignment_type_weights" */
  update_assignment_type_weights_many?: Maybe<Array<Maybe<Assignment_Type_Weights_Mutation_Response>>>;
  /** update data of the table: "assignments" */
  update_assignments?: Maybe<Assignments_Mutation_Response>;
  /** update multiples rows of table: "assignments" */
  update_assignments_many?: Maybe<Array<Maybe<Assignments_Mutation_Response>>>;
  /** update single row of the table: "comments" */
  update_comment?: Maybe<Comments>;
  /** update data of the table: "comments" */
  update_comments?: Maybe<Comments_Mutation_Response>;
  /** update multiples rows of table: "comments" */
  update_comments_many?: Maybe<Array<Maybe<Comments_Mutation_Response>>>;
  /** update single row of the table: "courses" */
  update_course?: Maybe<Courses>;
  /** update single row of the table: "course_share_links" */
  update_course_share_link?: Maybe<Course_Share_Links>;
  /** update data of the table: "course_share_links" */
  update_course_share_links?: Maybe<Course_Share_Links_Mutation_Response>;
  /** update multiples rows of table: "course_share_links" */
  update_course_share_links_many?: Maybe<Array<Maybe<Course_Share_Links_Mutation_Response>>>;
  /** update data of the table: "courses" */
  update_courses?: Maybe<Courses_Mutation_Response>;
  /** update multiples rows of table: "courses" */
  update_courses_many?: Maybe<Array<Maybe<Courses_Mutation_Response>>>;
  /** update single row of the table: "custom_assignment_types" */
  update_custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** update data of the table: "custom_assignment_types" */
  update_custom_assignment_types?: Maybe<Custom_Assignment_Types_Mutation_Response>;
  /** update multiples rows of table: "custom_assignment_types" */
  update_custom_assignment_types_many?: Maybe<Array<Maybe<Custom_Assignment_Types_Mutation_Response>>>;
  /** update single row of the table: "customers" */
  update_customer?: Maybe<Customers>;
  /** update data of the table: "customers" */
  update_customers?: Maybe<Customers_Mutation_Response>;
  /** update multiples rows of table: "customers" */
  update_customers_many?: Maybe<Array<Maybe<Customers_Mutation_Response>>>;
  /** update single row of the table: "events" */
  update_event?: Maybe<Events>;
  /** update data of the table: "event_ignored_courses" */
  update_event_ignored_courses?: Maybe<Event_Ignored_Courses_Mutation_Response>;
  /** update single row of the table: "event_ignored_courses" */
  update_event_ignored_courses_by_pk?: Maybe<Event_Ignored_Courses>;
  /** update multiples rows of table: "event_ignored_courses" */
  update_event_ignored_courses_many?: Maybe<Array<Maybe<Event_Ignored_Courses_Mutation_Response>>>;
  /** update data of the table: "event_t" */
  update_event_t?: Maybe<Event_T_Mutation_Response>;
  /** update multiples rows of table: "event_t" */
  update_event_t_many?: Maybe<Array<Maybe<Event_T_Mutation_Response>>>;
  /** update single row of the table: "event_t" */
  update_event_type?: Maybe<Event_T>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_Response>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  /** update single row of the table: "files" */
  update_file?: Maybe<Files>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "grading_style" */
  update_grading_style?: Maybe<Grading_Style_Mutation_Response>;
  /** update single row of the table: "grading_style" */
  update_grading_style_by_pk?: Maybe<Grading_Style>;
  /** update multiples rows of table: "grading_style" */
  update_grading_style_many?: Maybe<Array<Maybe<Grading_Style_Mutation_Response>>>;
  /** update single row of the table: "organizations" */
  update_organization?: Maybe<Organizations>;
  /** update single row of the table: "organization_admins" */
  update_organization_admin?: Maybe<Organization_Admins>;
  /** update data of the table: "organization_admins" */
  update_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** update multiples rows of table: "organization_admins" */
  update_organization_admins_many?: Maybe<Array<Maybe<Organization_Admins_Mutation_Response>>>;
  /** update single row of the table: "organization_codes" */
  update_organization_code?: Maybe<Organization_Codes>;
  /** update data of the table: "organization_codes" */
  update_organization_codes?: Maybe<Organization_Codes_Mutation_Response>;
  /** update multiples rows of table: "organization_codes" */
  update_organization_codes_many?: Maybe<Array<Maybe<Organization_Codes_Mutation_Response>>>;
  /** update single row of the table: "organization_course_groups" */
  update_organization_course_group?: Maybe<Organization_Course_Groups>;
  /** update data of the table: "organization_course_groups" */
  update_organization_course_groups?: Maybe<Organization_Course_Groups_Mutation_Response>;
  /** update data of the table: "organization_course_groups_courses" */
  update_organization_course_groups_courses?: Maybe<Organization_Course_Groups_Courses_Mutation_Response>;
  /** update single row of the table: "organization_course_groups_courses" */
  update_organization_course_groups_courses_by_pk?: Maybe<Organization_Course_Groups_Courses>;
  /** update multiples rows of table: "organization_course_groups_courses" */
  update_organization_course_groups_courses_many?: Maybe<Array<Maybe<Organization_Course_Groups_Courses_Mutation_Response>>>;
  /** update multiples rows of table: "organization_course_groups" */
  update_organization_course_groups_many?: Maybe<Array<Maybe<Organization_Course_Groups_Mutation_Response>>>;
  /** update data of the table: "organization_course_groups_organization_codes" */
  update_organization_course_groups_organization_codes?: Maybe<Organization_Course_Groups_Organization_Codes_Mutation_Response>;
  /** update single row of the table: "organization_course_groups_organization_codes" */
  update_organization_course_groups_organization_codes_by_pk?: Maybe<Organization_Course_Groups_Organization_Codes>;
  /** update multiples rows of table: "organization_course_groups_organization_codes" */
  update_organization_course_groups_organization_codes_many?: Maybe<Array<Maybe<Organization_Course_Groups_Organization_Codes_Mutation_Response>>>;
  /** update data of the table: "organization_course_groups_teachers" */
  update_organization_course_groups_teachers?: Maybe<Organization_Course_Groups_Teachers_Mutation_Response>;
  /** update single row of the table: "organization_course_groups_teachers" */
  update_organization_course_groups_teachers_by_pk?: Maybe<Organization_Course_Groups_Teachers>;
  /** update multiples rows of table: "organization_course_groups_teachers" */
  update_organization_course_groups_teachers_many?: Maybe<Array<Maybe<Organization_Course_Groups_Teachers_Mutation_Response>>>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<Organizations_Mutation_Response>>>;
  /** update single row of the table: "parrot_requests" */
  update_parrot_request?: Maybe<Parrot_Requests>;
  /** update data of the table: "parrot_request_status" */
  update_parrot_request_status?: Maybe<Parrot_Request_Status_Mutation_Response>;
  /** update single row of the table: "parrot_request_status" */
  update_parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** update multiples rows of table: "parrot_request_status" */
  update_parrot_request_status_many?: Maybe<Array<Maybe<Parrot_Request_Status_Mutation_Response>>>;
  /** update data of the table: "parrot_requests" */
  update_parrot_requests?: Maybe<Parrot_Requests_Mutation_Response>;
  /** update multiples rows of table: "parrot_requests" */
  update_parrot_requests_many?: Maybe<Array<Maybe<Parrot_Requests_Mutation_Response>>>;
  /** update data of the table: "plan_tier" */
  update_plan_tier?: Maybe<Plan_Tier_Mutation_Response>;
  /** update single row of the table: "plan_tier" */
  update_plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** update multiples rows of table: "plan_tier" */
  update_plan_tier_many?: Maybe<Array<Maybe<Plan_Tier_Mutation_Response>>>;
  /** update single row of the table: "printing_jobs" */
  update_printing_job?: Maybe<Printing_Jobs>;
  /** update data of the table: "printing_job_status" */
  update_printing_job_status?: Maybe<Printing_Job_Status_Mutation_Response>;
  /** update single row of the table: "printing_job_status" */
  update_printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** update multiples rows of table: "printing_job_status" */
  update_printing_job_status_many?: Maybe<Array<Maybe<Printing_Job_Status_Mutation_Response>>>;
  /** update data of the table: "printing_job_type" */
  update_printing_job_type?: Maybe<Printing_Job_Type_Mutation_Response>;
  /** update single row of the table: "printing_job_type" */
  update_printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** update multiples rows of table: "printing_job_type" */
  update_printing_job_type_many?: Maybe<Array<Maybe<Printing_Job_Type_Mutation_Response>>>;
  /** update data of the table: "printing_jobs" */
  update_printing_jobs?: Maybe<Printing_Jobs_Mutation_Response>;
  /** update multiples rows of table: "printing_jobs" */
  update_printing_jobs_many?: Maybe<Array<Maybe<Printing_Jobs_Mutation_Response>>>;
  /** update single row of the table: "reschedule_actions" */
  update_reschedule_action?: Maybe<Reschedule_Actions>;
  /** update data of the table: "reschedule_action_statuses" */
  update_reschedule_action_statuses?: Maybe<Reschedule_Action_Statuses_Mutation_Response>;
  /** update single row of the table: "reschedule_action_statuses" */
  update_reschedule_action_statuses_by_pk?: Maybe<Reschedule_Action_Statuses>;
  /** update multiples rows of table: "reschedule_action_statuses" */
  update_reschedule_action_statuses_many?: Maybe<Array<Maybe<Reschedule_Action_Statuses_Mutation_Response>>>;
  /** update data of the table: "reschedule_action_types" */
  update_reschedule_action_types?: Maybe<Reschedule_Action_Types_Mutation_Response>;
  /** update single row of the table: "reschedule_action_types" */
  update_reschedule_action_types_by_pk?: Maybe<Reschedule_Action_Types>;
  /** update multiples rows of table: "reschedule_action_types" */
  update_reschedule_action_types_many?: Maybe<Array<Maybe<Reschedule_Action_Types_Mutation_Response>>>;
  /** update data of the table: "reschedule_actions" */
  update_reschedule_actions?: Maybe<Reschedule_Actions_Mutation_Response>;
  /** update multiples rows of table: "reschedule_actions" */
  update_reschedule_actions_many?: Maybe<Array<Maybe<Reschedule_Actions_Mutation_Response>>>;
  /** update data of the table: "school_year" */
  update_school_year?: Maybe<School_Year_Mutation_Response>;
  /** update single row of the table: "school_year" */
  update_school_year_by_pk?: Maybe<School_Year>;
  /** update multiples rows of table: "school_year" */
  update_school_year_many?: Maybe<Array<Maybe<School_Year_Mutation_Response>>>;
  /** update single row of the table: "students" */
  update_student?: Maybe<Students>;
  /** update single row of the table: "student_accounts" */
  update_student_account?: Maybe<Student_Accounts>;
  /** update data of the table: "student_accounts" */
  update_student_accounts?: Maybe<Student_Accounts_Mutation_Response>;
  /** update multiples rows of table: "student_accounts" */
  update_student_accounts_many?: Maybe<Array<Maybe<Student_Accounts_Mutation_Response>>>;
  /** update single row of the table: "student_assignments" */
  update_student_assignment?: Maybe<Student_Assignments>;
  /** update data of the table: "student_assignment_status" */
  update_student_assignment_status?: Maybe<Student_Assignment_Status_Mutation_Response>;
  /** update single row of the table: "student_assignment_status" */
  update_student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** update multiples rows of table: "student_assignment_status" */
  update_student_assignment_status_many?: Maybe<Array<Maybe<Student_Assignment_Status_Mutation_Response>>>;
  /** update data of the table: "student_assignments" */
  update_student_assignments?: Maybe<Student_Assignments_Mutation_Response>;
  /** update multiples rows of table: "student_assignments" */
  update_student_assignments_many?: Maybe<Array<Maybe<Student_Assignments_Mutation_Response>>>;
  /** update single row of the table: "student_courses" */
  update_student_course?: Maybe<Student_Courses>;
  /** update data of the table: "student_course_status" */
  update_student_course_status?: Maybe<Student_Course_Status_Mutation_Response>;
  /** update single row of the table: "student_course_status" */
  update_student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** update multiples rows of table: "student_course_status" */
  update_student_course_status_many?: Maybe<Array<Maybe<Student_Course_Status_Mutation_Response>>>;
  /** update data of the table: "student_courses" */
  update_student_courses?: Maybe<Student_Courses_Mutation_Response>;
  /** update multiples rows of table: "student_courses" */
  update_student_courses_many?: Maybe<Array<Maybe<Student_Courses_Mutation_Response>>>;
  /** update single row of the table: "student_events" */
  update_student_event?: Maybe<Student_Events>;
  /** update data of the table: "student_events" */
  update_student_events?: Maybe<Student_Events_Mutation_Response>;
  /** update multiples rows of table: "student_events" */
  update_student_events_many?: Maybe<Array<Maybe<Student_Events_Mutation_Response>>>;
  /** update data of the table: "students" */
  update_students?: Maybe<Students_Mutation_Response>;
  /** update multiples rows of table: "students" */
  update_students_many?: Maybe<Array<Maybe<Students_Mutation_Response>>>;
  /** update single row of the table: "teachers" */
  update_teacher?: Maybe<Teachers>;
  /** update data of the table: "teachers" */
  update_teachers?: Maybe<Teachers_Mutation_Response>;
  /** update multiples rows of table: "teachers" */
  update_teachers_many?: Maybe<Array<Maybe<Teachers_Mutation_Response>>>;
  /** update data of the table: "teachers_students" */
  update_teachers_students?: Maybe<Teachers_Students_Mutation_Response>;
  /** update single row of the table: "teachers_students" */
  update_teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** update multiples rows of table: "teachers_students" */
  update_teachers_students_many?: Maybe<Array<Maybe<Teachers_Students_Mutation_Response>>>;
  /** update data of the table: "themes" */
  update_themes?: Maybe<Themes_Mutation_Response>;
  /** update single row of the table: "themes" */
  update_themes_by_pk?: Maybe<Themes>;
  /** update multiples rows of table: "themes" */
  update_themes_many?: Maybe<Array<Maybe<Themes_Mutation_Response>>>;
  /** update single row of the table: "transcript_drafts" */
  update_transcript_draft?: Maybe<Transcript_Drafts>;
  /** update data of the table: "transcript_drafts" */
  update_transcript_drafts?: Maybe<Transcript_Drafts_Mutation_Response>;
  /** update multiples rows of table: "transcript_drafts" */
  update_transcript_drafts_many?: Maybe<Array<Maybe<Transcript_Drafts_Mutation_Response>>>;
  /** update data of the table: "user_settings" */
  update_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** update single row of the table: "user_settings" */
  update_user_settings_by_pk?: Maybe<User_Settings>;
  /** update multiples rows of table: "user_settings" */
  update_user_settings_many?: Maybe<Array<Maybe<User_Settings_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_TypeArgs = {
  where: Assignment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Type_WeightArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Type_WeightsArgs = {
  where: Assignment_Type_Weights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AssignmentsArgs = {
  where: Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CommentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CommentsArgs = {
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CourseArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Share_LinkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Share_LinksArgs = {
  where: Course_Share_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CoursesArgs = {
  where: Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Assignment_TypeArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Assignment_TypesArgs = {
  where: Custom_Assignment_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CustomerArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CustomersArgs = {
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Event_Ignored_CoursesArgs = {
  where: Event_Ignored_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Ignored_Courses_By_PkArgs = {
  courseId: Scalars['uuid']['input'];
  eventId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TArgs = {
  where: Event_T_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_TypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grading_StyleArgs = {
  where: Grading_Style_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grading_Style_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_AdminArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_AdminsArgs = {
  where: Organization_Admins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_CodeArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_CodesArgs = {
  where: Organization_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_GroupArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_GroupsArgs = {
  where: Organization_Course_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_Groups_CoursesArgs = {
  where: Organization_Course_Groups_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_Groups_Courses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_Groups_Organization_CodesArgs = {
  where: Organization_Course_Groups_Organization_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_Groups_Organization_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_Groups_TeachersArgs = {
  where: Organization_Course_Groups_Teachers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Course_Groups_Teachers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationsArgs = {
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parrot_RequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parrot_Request_StatusArgs = {
  where: Parrot_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parrot_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parrot_RequestsArgs = {
  where: Parrot_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_TierArgs = {
  where: Plan_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_JobArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_StatusArgs = {
  where: Printing_Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_TypeArgs = {
  where: Printing_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_JobsArgs = {
  where: Printing_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reschedule_ActionArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reschedule_Action_StatusesArgs = {
  where: Reschedule_Action_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reschedule_Action_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reschedule_Action_TypesArgs = {
  where: Reschedule_Action_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reschedule_Action_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reschedule_ActionsArgs = {
  where: Reschedule_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_YearArgs = {
  where: School_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_Year_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StudentArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_AccountArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_AccountsArgs = {
  where: Student_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_Assignment_StatusArgs = {
  where: Student_Assignment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_AssignmentsArgs = {
  where: Student_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_CourseArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_Course_StatusArgs = {
  where: Student_Course_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_Course_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_CoursesArgs = {
  where: Student_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_EventArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_EventsArgs = {
  where: Student_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StudentsArgs = {
  where: Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TeacherArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TeachersArgs = {
  where: Teachers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teachers_StudentsArgs = {
  where: Teachers_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teachers_Students_By_PkArgs = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ThemesArgs = {
  where: Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Themes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_DraftArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_DraftsArgs = {
  where: Transcript_Drafts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_SettingsArgs = {
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AssignmentArgs = {
  object: Assignments_Insert_Input;
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_TypeArgs = {
  objects: Array<Assignment_Type_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Type_OneArgs = {
  object: Assignment_Type_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Type_WeightArgs = {
  object: Assignment_Type_Weights_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Type_Weights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Type_WeightsArgs = {
  objects: Array<Assignment_Type_Weights_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Type_Weights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssignmentsArgs = {
  objects: Array<Assignments_Insert_Input>;
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentArgs = {
  object: Comments_Insert_Input;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentsArgs = {
  objects: Array<Comments_Insert_Input>;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CourseArgs = {
  object: Courses_Insert_Input;
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Share_LinkArgs = {
  object: Course_Share_Links_Insert_Input;
  on_conflict?: InputMaybe<Course_Share_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Share_LinksArgs = {
  objects: Array<Course_Share_Links_Insert_Input>;
  on_conflict?: InputMaybe<Course_Share_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CoursesArgs = {
  objects: Array<Courses_Insert_Input>;
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Assignment_TypeArgs = {
  object: Custom_Assignment_Types_Insert_Input;
  on_conflict?: InputMaybe<Custom_Assignment_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Assignment_TypesArgs = {
  objects: Array<Custom_Assignment_Types_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Assignment_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomerArgs = {
  object: Customers_Insert_Input;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomersArgs = {
  objects: Array<Customers_Insert_Input>;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Ignored_CoursesArgs = {
  objects: Array<Event_Ignored_Courses_Insert_Input>;
  on_conflict?: InputMaybe<Event_Ignored_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Ignored_Courses_OneArgs = {
  object: Event_Ignored_Courses_Insert_Input;
  on_conflict?: InputMaybe<Event_Ignored_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TArgs = {
  objects: Array<Event_T_Insert_Input>;
  on_conflict?: InputMaybe<Event_T_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TypeArgs = {
  object: Event_T_Insert_Input;
  on_conflict?: InputMaybe<Event_T_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grading_StyleArgs = {
  objects: Array<Grading_Style_Insert_Input>;
  on_conflict?: InputMaybe<Grading_Style_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grading_Style_OneArgs = {
  object: Grading_Style_Insert_Input;
  on_conflict?: InputMaybe<Grading_Style_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  object: Organizations_Insert_Input;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_AdminArgs = {
  object: Organization_Admins_Insert_Input;
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_AdminsArgs = {
  objects: Array<Organization_Admins_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_CodeArgs = {
  object: Organization_Codes_Insert_Input;
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_CodesArgs = {
  objects: Array<Organization_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_GroupArgs = {
  object: Organization_Course_Groups_Insert_Input;
  on_conflict?: InputMaybe<Organization_Course_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_GroupsArgs = {
  objects: Array<Organization_Course_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Course_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_Groups_CoursesArgs = {
  objects: Array<Organization_Course_Groups_Courses_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Course_Groups_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_Groups_Courses_OneArgs = {
  object: Organization_Course_Groups_Courses_Insert_Input;
  on_conflict?: InputMaybe<Organization_Course_Groups_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_Groups_Organization_CodesArgs = {
  objects: Array<Organization_Course_Groups_Organization_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Course_Groups_Organization_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_Groups_Organization_Codes_OneArgs = {
  object: Organization_Course_Groups_Organization_Codes_Insert_Input;
  on_conflict?: InputMaybe<Organization_Course_Groups_Organization_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_Groups_TeachersArgs = {
  objects: Array<Organization_Course_Groups_Teachers_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Course_Groups_Teachers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Course_Groups_Teachers_OneArgs = {
  object: Organization_Course_Groups_Teachers_Insert_Input;
  on_conflict?: InputMaybe<Organization_Course_Groups_Teachers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationsArgs = {
  objects: Array<Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_RequestArgs = {
  object: Parrot_Requests_Insert_Input;
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_Request_StatusArgs = {
  objects: Array<Parrot_Request_Status_Insert_Input>;
  on_conflict?: InputMaybe<Parrot_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_Request_Status_OneArgs = {
  object: Parrot_Request_Status_Insert_Input;
  on_conflict?: InputMaybe<Parrot_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_RequestsArgs = {
  objects: Array<Parrot_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_TierArgs = {
  objects: Array<Plan_Tier_Insert_Input>;
  on_conflict?: InputMaybe<Plan_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_Tier_OneArgs = {
  object: Plan_Tier_Insert_Input;
  on_conflict?: InputMaybe<Plan_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_JobArgs = {
  object: Printing_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Printing_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_StatusArgs = {
  objects: Array<Printing_Job_Status_Insert_Input>;
  on_conflict?: InputMaybe<Printing_Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_Status_OneArgs = {
  object: Printing_Job_Status_Insert_Input;
  on_conflict?: InputMaybe<Printing_Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_TypeArgs = {
  objects: Array<Printing_Job_Type_Insert_Input>;
  on_conflict?: InputMaybe<Printing_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_Type_OneArgs = {
  object: Printing_Job_Type_Insert_Input;
  on_conflict?: InputMaybe<Printing_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_JobsArgs = {
  objects: Array<Printing_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Printing_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reschedule_ActionArgs = {
  object: Reschedule_Actions_Insert_Input;
  on_conflict?: InputMaybe<Reschedule_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reschedule_Action_StatusesArgs = {
  objects: Array<Reschedule_Action_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Reschedule_Action_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reschedule_Action_Statuses_OneArgs = {
  object: Reschedule_Action_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Reschedule_Action_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reschedule_Action_TypesArgs = {
  objects: Array<Reschedule_Action_Types_Insert_Input>;
  on_conflict?: InputMaybe<Reschedule_Action_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reschedule_Action_Types_OneArgs = {
  object: Reschedule_Action_Types_Insert_Input;
  on_conflict?: InputMaybe<Reschedule_Action_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reschedule_ActionsArgs = {
  objects: Array<Reschedule_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Reschedule_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_YearArgs = {
  objects: Array<School_Year_Insert_Input>;
  on_conflict?: InputMaybe<School_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_Year_OneArgs = {
  object: School_Year_Insert_Input;
  on_conflict?: InputMaybe<School_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StudentArgs = {
  object: Students_Insert_Input;
  on_conflict?: InputMaybe<Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AccountArgs = {
  object: Student_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AccountsArgs = {
  objects: Array<Student_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AssignmentArgs = {
  object: Student_Assignments_Insert_Input;
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Assignment_StatusArgs = {
  objects: Array<Student_Assignment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Student_Assignment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Assignment_Status_OneArgs = {
  object: Student_Assignment_Status_Insert_Input;
  on_conflict?: InputMaybe<Student_Assignment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AssignmentsArgs = {
  objects: Array<Student_Assignments_Insert_Input>;
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_CourseArgs = {
  object: Student_Courses_Insert_Input;
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Course_StatusArgs = {
  objects: Array<Student_Course_Status_Insert_Input>;
  on_conflict?: InputMaybe<Student_Course_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Course_Status_OneArgs = {
  object: Student_Course_Status_Insert_Input;
  on_conflict?: InputMaybe<Student_Course_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_CoursesArgs = {
  objects: Array<Student_Courses_Insert_Input>;
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_EventArgs = {
  object: Student_Events_Insert_Input;
  on_conflict?: InputMaybe<Student_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_EventsArgs = {
  objects: Array<Student_Events_Insert_Input>;
  on_conflict?: InputMaybe<Student_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StudentsArgs = {
  objects: Array<Students_Insert_Input>;
  on_conflict?: InputMaybe<Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeacherArgs = {
  object: Teachers_Insert_Input;
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeachersArgs = {
  objects: Array<Teachers_Insert_Input>;
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teachers_StudentsArgs = {
  objects: Array<Teachers_Students_Insert_Input>;
  on_conflict?: InputMaybe<Teachers_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teachers_Students_OneArgs = {
  object: Teachers_Students_Insert_Input;
  on_conflict?: InputMaybe<Teachers_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ThemesArgs = {
  objects: Array<Themes_Insert_Input>;
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Themes_OneArgs = {
  object: Themes_Insert_Input;
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_DraftArgs = {
  object: Transcript_Drafts_Insert_Input;
  on_conflict?: InputMaybe<Transcript_Drafts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_DraftsArgs = {
  objects: Array<Transcript_Drafts_Insert_Input>;
  on_conflict?: InputMaybe<Transcript_Drafts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SettingsArgs = {
  objects: Array<User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_OneArgs = {
  object: User_Settings_Insert_Input;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentArgs = {
  _inc?: InputMaybe<Assignments_Inc_Input>;
  _set?: InputMaybe<Assignments_Set_Input>;
  pk_columns: Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_TypeArgs = {
  _set?: InputMaybe<Assignment_Type_Set_Input>;
  where: Assignment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_By_PkArgs = {
  _set?: InputMaybe<Assignment_Type_Set_Input>;
  pk_columns: Assignment_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_ManyArgs = {
  updates: Array<Assignment_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_WeightArgs = {
  _inc?: InputMaybe<Assignment_Type_Weights_Inc_Input>;
  _set?: InputMaybe<Assignment_Type_Weights_Set_Input>;
  pk_columns: Assignment_Type_Weights_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_WeightsArgs = {
  _inc?: InputMaybe<Assignment_Type_Weights_Inc_Input>;
  _set?: InputMaybe<Assignment_Type_Weights_Set_Input>;
  where: Assignment_Type_Weights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_Weights_ManyArgs = {
  updates: Array<Assignment_Type_Weights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentsArgs = {
  _inc?: InputMaybe<Assignments_Inc_Input>;
  _set?: InputMaybe<Assignments_Set_Input>;
  where: Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignments_ManyArgs = {
  updates: Array<Assignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  pk_columns: Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CommentsArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CourseArgs = {
  _append?: InputMaybe<Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Courses_Delete_Key_Input>;
  _inc?: InputMaybe<Courses_Inc_Input>;
  _prepend?: InputMaybe<Courses_Prepend_Input>;
  _set?: InputMaybe<Courses_Set_Input>;
  pk_columns: Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Share_LinkArgs = {
  _inc?: InputMaybe<Course_Share_Links_Inc_Input>;
  _set?: InputMaybe<Course_Share_Links_Set_Input>;
  pk_columns: Course_Share_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Share_LinksArgs = {
  _inc?: InputMaybe<Course_Share_Links_Inc_Input>;
  _set?: InputMaybe<Course_Share_Links_Set_Input>;
  where: Course_Share_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Share_Links_ManyArgs = {
  updates: Array<Course_Share_Links_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CoursesArgs = {
  _append?: InputMaybe<Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Courses_Delete_Key_Input>;
  _inc?: InputMaybe<Courses_Inc_Input>;
  _prepend?: InputMaybe<Courses_Prepend_Input>;
  _set?: InputMaybe<Courses_Set_Input>;
  where: Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Courses_ManyArgs = {
  updates: Array<Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Assignment_TypeArgs = {
  _inc?: InputMaybe<Custom_Assignment_Types_Inc_Input>;
  _set?: InputMaybe<Custom_Assignment_Types_Set_Input>;
  pk_columns: Custom_Assignment_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Assignment_TypesArgs = {
  _inc?: InputMaybe<Custom_Assignment_Types_Inc_Input>;
  _set?: InputMaybe<Custom_Assignment_Types_Set_Input>;
  where: Custom_Assignment_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Assignment_Types_ManyArgs = {
  updates: Array<Custom_Assignment_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomerArgs = {
  _inc?: InputMaybe<Customers_Inc_Input>;
  _set?: InputMaybe<Customers_Set_Input>;
  pk_columns: Customers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CustomersArgs = {
  _inc?: InputMaybe<Customers_Inc_Input>;
  _set?: InputMaybe<Customers_Set_Input>;
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customers_ManyArgs = {
  updates: Array<Customers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventArgs = {
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Ignored_CoursesArgs = {
  _set?: InputMaybe<Event_Ignored_Courses_Set_Input>;
  where: Event_Ignored_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Ignored_Courses_By_PkArgs = {
  _set?: InputMaybe<Event_Ignored_Courses_Set_Input>;
  pk_columns: Event_Ignored_Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Ignored_Courses_ManyArgs = {
  updates: Array<Event_Ignored_Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TArgs = {
  _set?: InputMaybe<Event_T_Set_Input>;
  where: Event_T_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_T_ManyArgs = {
  updates: Array<Event_T_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TypeArgs = {
  _set?: InputMaybe<Event_T_Set_Input>;
  pk_columns: Event_T_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgs = {
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grading_StyleArgs = {
  _set?: InputMaybe<Grading_Style_Set_Input>;
  where: Grading_Style_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grading_Style_By_PkArgs = {
  _set?: InputMaybe<Grading_Style_Set_Input>;
  pk_columns: Grading_Style_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grading_Style_ManyArgs = {
  updates: Array<Grading_Style_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _inc?: InputMaybe<Organizations_Inc_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_AdminArgs = {
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  pk_columns: Organization_Admins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_AdminsArgs = {
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  where: Organization_Admins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Admins_ManyArgs = {
  updates: Array<Organization_Admins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_CodeArgs = {
  _set?: InputMaybe<Organization_Codes_Set_Input>;
  pk_columns: Organization_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_CodesArgs = {
  _set?: InputMaybe<Organization_Codes_Set_Input>;
  where: Organization_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Codes_ManyArgs = {
  updates: Array<Organization_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_GroupArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Set_Input>;
  pk_columns: Organization_Course_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_GroupsArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Set_Input>;
  where: Organization_Course_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_CoursesArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Courses_Set_Input>;
  where: Organization_Course_Groups_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Courses_By_PkArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Courses_Set_Input>;
  pk_columns: Organization_Course_Groups_Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Courses_ManyArgs = {
  updates: Array<Organization_Course_Groups_Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_ManyArgs = {
  updates: Array<Organization_Course_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Organization_CodesArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Organization_Codes_Set_Input>;
  where: Organization_Course_Groups_Organization_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Organization_Codes_By_PkArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Organization_Codes_Set_Input>;
  pk_columns: Organization_Course_Groups_Organization_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Organization_Codes_ManyArgs = {
  updates: Array<Organization_Course_Groups_Organization_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_TeachersArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Teachers_Set_Input>;
  where: Organization_Course_Groups_Teachers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Teachers_By_PkArgs = {
  _set?: InputMaybe<Organization_Course_Groups_Teachers_Set_Input>;
  pk_columns: Organization_Course_Groups_Teachers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Course_Groups_Teachers_ManyArgs = {
  updates: Array<Organization_Course_Groups_Teachers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _inc?: InputMaybe<Organizations_Inc_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_ManyArgs = {
  updates: Array<Organizations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_RequestArgs = {
  _inc?: InputMaybe<Parrot_Requests_Inc_Input>;
  _set?: InputMaybe<Parrot_Requests_Set_Input>;
  pk_columns: Parrot_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Request_StatusArgs = {
  _set?: InputMaybe<Parrot_Request_Status_Set_Input>;
  where: Parrot_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Request_Status_By_PkArgs = {
  _set?: InputMaybe<Parrot_Request_Status_Set_Input>;
  pk_columns: Parrot_Request_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Request_Status_ManyArgs = {
  updates: Array<Parrot_Request_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_RequestsArgs = {
  _inc?: InputMaybe<Parrot_Requests_Inc_Input>;
  _set?: InputMaybe<Parrot_Requests_Set_Input>;
  where: Parrot_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Requests_ManyArgs = {
  updates: Array<Parrot_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_TierArgs = {
  _set?: InputMaybe<Plan_Tier_Set_Input>;
  where: Plan_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Tier_By_PkArgs = {
  _set?: InputMaybe<Plan_Tier_Set_Input>;
  pk_columns: Plan_Tier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Tier_ManyArgs = {
  updates: Array<Plan_Tier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_JobArgs = {
  _append?: InputMaybe<Printing_Jobs_Append_Input>;
  _delete_at_path?: InputMaybe<Printing_Jobs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Printing_Jobs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Printing_Jobs_Delete_Key_Input>;
  _prepend?: InputMaybe<Printing_Jobs_Prepend_Input>;
  _set?: InputMaybe<Printing_Jobs_Set_Input>;
  pk_columns: Printing_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_StatusArgs = {
  _set?: InputMaybe<Printing_Job_Status_Set_Input>;
  where: Printing_Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Status_By_PkArgs = {
  _set?: InputMaybe<Printing_Job_Status_Set_Input>;
  pk_columns: Printing_Job_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Status_ManyArgs = {
  updates: Array<Printing_Job_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_TypeArgs = {
  _set?: InputMaybe<Printing_Job_Type_Set_Input>;
  where: Printing_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Type_By_PkArgs = {
  _set?: InputMaybe<Printing_Job_Type_Set_Input>;
  pk_columns: Printing_Job_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Type_ManyArgs = {
  updates: Array<Printing_Job_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_JobsArgs = {
  _append?: InputMaybe<Printing_Jobs_Append_Input>;
  _delete_at_path?: InputMaybe<Printing_Jobs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Printing_Jobs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Printing_Jobs_Delete_Key_Input>;
  _prepend?: InputMaybe<Printing_Jobs_Prepend_Input>;
  _set?: InputMaybe<Printing_Jobs_Set_Input>;
  where: Printing_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Jobs_ManyArgs = {
  updates: Array<Printing_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_ActionArgs = {
  _append?: InputMaybe<Reschedule_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Reschedule_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reschedule_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reschedule_Actions_Delete_Key_Input>;
  _prepend?: InputMaybe<Reschedule_Actions_Prepend_Input>;
  _set?: InputMaybe<Reschedule_Actions_Set_Input>;
  pk_columns: Reschedule_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Action_StatusesArgs = {
  _set?: InputMaybe<Reschedule_Action_Statuses_Set_Input>;
  where: Reschedule_Action_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Action_Statuses_By_PkArgs = {
  _set?: InputMaybe<Reschedule_Action_Statuses_Set_Input>;
  pk_columns: Reschedule_Action_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Action_Statuses_ManyArgs = {
  updates: Array<Reschedule_Action_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Action_TypesArgs = {
  _set?: InputMaybe<Reschedule_Action_Types_Set_Input>;
  where: Reschedule_Action_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Action_Types_By_PkArgs = {
  _set?: InputMaybe<Reschedule_Action_Types_Set_Input>;
  pk_columns: Reschedule_Action_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Action_Types_ManyArgs = {
  updates: Array<Reschedule_Action_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_ActionsArgs = {
  _append?: InputMaybe<Reschedule_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Reschedule_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reschedule_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reschedule_Actions_Delete_Key_Input>;
  _prepend?: InputMaybe<Reschedule_Actions_Prepend_Input>;
  _set?: InputMaybe<Reschedule_Actions_Set_Input>;
  where: Reschedule_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reschedule_Actions_ManyArgs = {
  updates: Array<Reschedule_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_School_YearArgs = {
  _set?: InputMaybe<School_Year_Set_Input>;
  where: School_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_School_Year_By_PkArgs = {
  _set?: InputMaybe<School_Year_Set_Input>;
  pk_columns: School_Year_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_School_Year_ManyArgs = {
  updates: Array<School_Year_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StudentArgs = {
  _set?: InputMaybe<Students_Set_Input>;
  pk_columns: Students_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AccountArgs = {
  _set?: InputMaybe<Student_Accounts_Set_Input>;
  pk_columns: Student_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AccountsArgs = {
  _set?: InputMaybe<Student_Accounts_Set_Input>;
  where: Student_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Accounts_ManyArgs = {
  updates: Array<Student_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AssignmentArgs = {
  _inc?: InputMaybe<Student_Assignments_Inc_Input>;
  _set?: InputMaybe<Student_Assignments_Set_Input>;
  pk_columns: Student_Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignment_StatusArgs = {
  _set?: InputMaybe<Student_Assignment_Status_Set_Input>;
  where: Student_Assignment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignment_Status_By_PkArgs = {
  _set?: InputMaybe<Student_Assignment_Status_Set_Input>;
  pk_columns: Student_Assignment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignment_Status_ManyArgs = {
  updates: Array<Student_Assignment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AssignmentsArgs = {
  _inc?: InputMaybe<Student_Assignments_Inc_Input>;
  _set?: InputMaybe<Student_Assignments_Set_Input>;
  where: Student_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignments_ManyArgs = {
  updates: Array<Student_Assignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_CourseArgs = {
  _append?: InputMaybe<Student_Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Student_Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Student_Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Student_Courses_Delete_Key_Input>;
  _prepend?: InputMaybe<Student_Courses_Prepend_Input>;
  _set?: InputMaybe<Student_Courses_Set_Input>;
  pk_columns: Student_Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Course_StatusArgs = {
  _set?: InputMaybe<Student_Course_Status_Set_Input>;
  where: Student_Course_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Course_Status_By_PkArgs = {
  _set?: InputMaybe<Student_Course_Status_Set_Input>;
  pk_columns: Student_Course_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Course_Status_ManyArgs = {
  updates: Array<Student_Course_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_CoursesArgs = {
  _append?: InputMaybe<Student_Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Student_Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Student_Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Student_Courses_Delete_Key_Input>;
  _prepend?: InputMaybe<Student_Courses_Prepend_Input>;
  _set?: InputMaybe<Student_Courses_Set_Input>;
  where: Student_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Courses_ManyArgs = {
  updates: Array<Student_Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_EventArgs = {
  _set?: InputMaybe<Student_Events_Set_Input>;
  pk_columns: Student_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_EventsArgs = {
  _set?: InputMaybe<Student_Events_Set_Input>;
  where: Student_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Events_ManyArgs = {
  updates: Array<Student_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StudentsArgs = {
  _set?: InputMaybe<Students_Set_Input>;
  where: Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Students_ManyArgs = {
  updates: Array<Students_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeacherArgs = {
  _set?: InputMaybe<Teachers_Set_Input>;
  pk_columns: Teachers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TeachersArgs = {
  _set?: InputMaybe<Teachers_Set_Input>;
  where: Teachers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_ManyArgs = {
  updates: Array<Teachers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_StudentsArgs = {
  _set?: InputMaybe<Teachers_Students_Set_Input>;
  where: Teachers_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_Students_By_PkArgs = {
  _set?: InputMaybe<Teachers_Students_Set_Input>;
  pk_columns: Teachers_Students_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_Students_ManyArgs = {
  updates: Array<Teachers_Students_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ThemesArgs = {
  _append?: InputMaybe<Themes_Append_Input>;
  _delete_at_path?: InputMaybe<Themes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Themes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Themes_Delete_Key_Input>;
  _inc?: InputMaybe<Themes_Inc_Input>;
  _prepend?: InputMaybe<Themes_Prepend_Input>;
  _set?: InputMaybe<Themes_Set_Input>;
  where: Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Themes_By_PkArgs = {
  _append?: InputMaybe<Themes_Append_Input>;
  _delete_at_path?: InputMaybe<Themes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Themes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Themes_Delete_Key_Input>;
  _inc?: InputMaybe<Themes_Inc_Input>;
  _prepend?: InputMaybe<Themes_Prepend_Input>;
  _set?: InputMaybe<Themes_Set_Input>;
  pk_columns: Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Themes_ManyArgs = {
  updates: Array<Themes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_DraftArgs = {
  _append?: InputMaybe<Transcript_Drafts_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Drafts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Drafts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Drafts_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Drafts_Prepend_Input>;
  _set?: InputMaybe<Transcript_Drafts_Set_Input>;
  pk_columns: Transcript_Drafts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_DraftsArgs = {
  _append?: InputMaybe<Transcript_Drafts_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Drafts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Drafts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Drafts_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Drafts_Prepend_Input>;
  _set?: InputMaybe<Transcript_Drafts_Set_Input>;
  where: Transcript_Drafts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Drafts_ManyArgs = {
  updates: Array<Transcript_Drafts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SettingsArgs = {
  _inc?: InputMaybe<User_Settings_Inc_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_By_PkArgs = {
  _inc?: InputMaybe<User_Settings_Inc_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  pk_columns: User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_ManyArgs = {
  updates: Array<User_Settings_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organization_admins" */
export type Organization_Admins = {
  __typename?: 'organization_admins';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organizationId: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_admins" */
export type Organization_Admins_Aggregate = {
  __typename?: 'organization_admins_aggregate';
  aggregate?: Maybe<Organization_Admins_Aggregate_Fields>;
  nodes: Array<Organization_Admins>;
};

export type Organization_Admins_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp_Count>;
};

export type Organization_Admins_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Admins_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_admins" */
export type Organization_Admins_Aggregate_Fields = {
  __typename?: 'organization_admins_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Admins_Max_Fields>;
  min?: Maybe<Organization_Admins_Min_Fields>;
};


/** aggregate fields of "organization_admins" */
export type Organization_Admins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_admins" */
export type Organization_Admins_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Admins_Max_Order_By>;
  min?: InputMaybe<Organization_Admins_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_admins" */
export type Organization_Admins_Arr_Rel_Insert_Input = {
  data: Array<Organization_Admins_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_admins". All fields are combined with a logical 'AND'. */
export type Organization_Admins_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Admins_Bool_Exp>>;
  _not?: InputMaybe<Organization_Admins_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Admins_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_admins" */
export enum Organization_Admins_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationAdminsPkey = 'organization_admins_pkey'
}

/** input type for inserting data into table "organization_admins" */
export type Organization_Admins_Insert_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Admins_Max_Fields = {
  __typename?: 'organization_admins_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_admins" */
export type Organization_Admins_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Admins_Min_Fields = {
  __typename?: 'organization_admins_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_admins" */
export type Organization_Admins_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_admins" */
export type Organization_Admins_Mutation_Response = {
  __typename?: 'organization_admins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Admins>;
};

/** on_conflict condition type for table "organization_admins" */
export type Organization_Admins_On_Conflict = {
  constraint: Organization_Admins_Constraint;
  update_columns?: Array<Organization_Admins_Update_Column>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_admins". */
export type Organization_Admins_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_admins */
export type Organization_Admins_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "organization_admins" */
export enum Organization_Admins_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId'
}

/** input type for updating data in table "organization_admins" */
export type Organization_Admins_Set_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_admins" */
export type Organization_Admins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Admins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Admins_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_admins" */
export enum Organization_Admins_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId'
}

export type Organization_Admins_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Admins_Bool_Exp;
};

/** columns and relationships of "organization_codes" */
export type Organization_Codes = {
  __typename?: 'organization_codes';
  code: Scalars['String']['output'];
  created?: Maybe<Scalars['timestamptz']['output']>;
  externalUserIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization: Organizations;
  /** An array relationship */
  organizationCourseGroups: Array<Organization_Course_Groups_Organization_Codes>;
  /** An aggregate relationship */
  organizationCourseGroups_aggregate: Organization_Course_Groups_Organization_Codes_Aggregate;
  organizationId: Scalars['uuid']['output'];
  originalUserEmail?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "organization_codes" */
export type Organization_CodesOrganizationCourseGroupsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organization_codes" */
export type Organization_CodesOrganizationCourseGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};

/** aggregated selection of "organization_codes" */
export type Organization_Codes_Aggregate = {
  __typename?: 'organization_codes_aggregate';
  aggregate?: Maybe<Organization_Codes_Aggregate_Fields>;
  nodes: Array<Organization_Codes>;
};

export type Organization_Codes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Codes_Aggregate_Bool_Exp_Count>;
};

export type Organization_Codes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_codes" */
export type Organization_Codes_Aggregate_Fields = {
  __typename?: 'organization_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Codes_Max_Fields>;
  min?: Maybe<Organization_Codes_Min_Fields>;
};


/** aggregate fields of "organization_codes" */
export type Organization_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_codes" */
export type Organization_Codes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Codes_Max_Order_By>;
  min?: InputMaybe<Organization_Codes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_codes" */
export type Organization_Codes_Arr_Rel_Insert_Input = {
  data: Array<Organization_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_codes". All fields are combined with a logical 'AND'. */
export type Organization_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Codes_Bool_Exp>>;
  _not?: InputMaybe<Organization_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalUserIdentifier?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationCourseGroups?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
  organizationCourseGroups_aggregate?: InputMaybe<Organization_Course_Groups_Organization_Codes_Aggregate_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  originalUserEmail?: InputMaybe<String_Comparison_Exp>;
  subscriptionExpiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_codes" */
export enum Organization_Codes_Constraint {
  /** unique or primary key constraint on columns "code" */
  OrganizationCodesCodeKey = 'organization_codes_code_key',
  /** unique or primary key constraint on columns "external_user_identifier" */
  OrganizationCodesExternalUserIdentifierKey = 'organization_codes_external_user_identifier_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationCodesPkey = 'organization_codes_pkey'
}

/** input type for inserting data into table "organization_codes" */
export type Organization_Codes_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  externalUserIdentifier?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationCourseGroups?: InputMaybe<Organization_Course_Groups_Organization_Codes_Arr_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  originalUserEmail?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Codes_Max_Fields = {
  __typename?: 'organization_codes_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  externalUserIdentifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  originalUserEmail?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_codes" */
export type Organization_Codes_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  externalUserIdentifier?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  originalUserEmail?: InputMaybe<Order_By>;
  subscriptionExpiration?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Codes_Min_Fields = {
  __typename?: 'organization_codes_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  externalUserIdentifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  originalUserEmail?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_codes" */
export type Organization_Codes_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  externalUserIdentifier?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  originalUserEmail?: InputMaybe<Order_By>;
  subscriptionExpiration?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_codes" */
export type Organization_Codes_Mutation_Response = {
  __typename?: 'organization_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Codes>;
};

/** input type for inserting object relation for remote table "organization_codes" */
export type Organization_Codes_Obj_Rel_Insert_Input = {
  data: Organization_Codes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};

/** on_conflict condition type for table "organization_codes" */
export type Organization_Codes_On_Conflict = {
  constraint: Organization_Codes_Constraint;
  update_columns?: Array<Organization_Codes_Update_Column>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_codes". */
export type Organization_Codes_Order_By = {
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  externalUserIdentifier?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationCourseGroups_aggregate?: InputMaybe<Organization_Course_Groups_Organization_Codes_Aggregate_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  originalUserEmail?: InputMaybe<Order_By>;
  subscriptionExpiration?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_codes */
export type Organization_Codes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_codes" */
export enum Organization_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Created = 'created',
  /** column name */
  ExternalUserIdentifier = 'externalUserIdentifier',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  OriginalUserEmail = 'originalUserEmail',
  /** column name */
  SubscriptionExpiration = 'subscriptionExpiration',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "organization_codes" */
export type Organization_Codes_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  externalUserIdentifier?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  originalUserEmail?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_codes" */
export type Organization_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  externalUserIdentifier?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  originalUserEmail?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_codes" */
export enum Organization_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Created = 'created',
  /** column name */
  ExternalUserIdentifier = 'externalUserIdentifier',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  OriginalUserEmail = 'originalUserEmail',
  /** column name */
  SubscriptionExpiration = 'subscriptionExpiration',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Organization_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Codes_Bool_Exp;
};

/** columns and relationships of "organization_course_groups" */
export type Organization_Course_Groups = {
  __typename?: 'organization_course_groups';
  /** An array relationship */
  courses: Array<Organization_Course_Groups_Courses>;
  /** An aggregate relationship */
  courses_aggregate: Organization_Course_Groups_Courses_Aggregate;
  created: Scalars['timestamptz']['output'];
  default: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  /** An array relationship */
  organizationCodes: Array<Organization_Course_Groups_Organization_Codes>;
  /** An aggregate relationship */
  organizationCodes_aggregate: Organization_Course_Groups_Organization_Codes_Aggregate;
  organizationId: Scalars['uuid']['output'];
  public: Scalars['Boolean']['output'];
  releaseDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  teachers: Array<Organization_Course_Groups_Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Organization_Course_Groups_Teachers_Aggregate;
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "organization_course_groups" */
export type Organization_Course_GroupsCoursesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


/** columns and relationships of "organization_course_groups" */
export type Organization_Course_GroupsCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


/** columns and relationships of "organization_course_groups" */
export type Organization_Course_GroupsOrganizationCodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organization_course_groups" */
export type Organization_Course_GroupsOrganizationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organization_course_groups" */
export type Organization_Course_GroupsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


/** columns and relationships of "organization_course_groups" */
export type Organization_Course_GroupsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};

/** aggregated selection of "organization_course_groups" */
export type Organization_Course_Groups_Aggregate = {
  __typename?: 'organization_course_groups_aggregate';
  aggregate?: Maybe<Organization_Course_Groups_Aggregate_Fields>;
  nodes: Array<Organization_Course_Groups>;
};

/** aggregate fields of "organization_course_groups" */
export type Organization_Course_Groups_Aggregate_Fields = {
  __typename?: 'organization_course_groups_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Course_Groups_Max_Fields>;
  min?: Maybe<Organization_Course_Groups_Min_Fields>;
};


/** aggregate fields of "organization_course_groups" */
export type Organization_Course_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Course_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_course_groups". All fields are combined with a logical 'AND'. */
export type Organization_Course_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Course_Groups_Bool_Exp>>;
  _not?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Course_Groups_Bool_Exp>>;
  courses?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
  courses_aggregate?: InputMaybe<Organization_Course_Groups_Courses_Aggregate_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  default?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expirationDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationCodes?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
  organizationCodes_aggregate?: InputMaybe<Organization_Course_Groups_Organization_Codes_Aggregate_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  releaseDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  teachers?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Organization_Course_Groups_Teachers_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_course_groups" */
export enum Organization_Course_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationCourseGroupsPkey = 'organization_course_groups_pkey'
}

/** columns and relationships of "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses = {
  __typename?: 'organization_course_groups_courses';
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationCourseGroup: Organization_Course_Groups;
  organizationCourseGroupId: Scalars['uuid']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Aggregate = {
  __typename?: 'organization_course_groups_courses_aggregate';
  aggregate?: Maybe<Organization_Course_Groups_Courses_Aggregate_Fields>;
  nodes: Array<Organization_Course_Groups_Courses>;
};

export type Organization_Course_Groups_Courses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Course_Groups_Courses_Aggregate_Bool_Exp_Count>;
};

export type Organization_Course_Groups_Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Aggregate_Fields = {
  __typename?: 'organization_course_groups_courses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Course_Groups_Courses_Max_Fields>;
  min?: Maybe<Organization_Course_Groups_Courses_Min_Fields>;
};


/** aggregate fields of "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Course_Groups_Courses_Max_Order_By>;
  min?: InputMaybe<Organization_Course_Groups_Courses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Arr_Rel_Insert_Input = {
  data: Array<Organization_Course_Groups_Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Course_Groups_Courses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_course_groups_courses". All fields are combined with a logical 'AND'. */
export type Organization_Course_Groups_Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Course_Groups_Courses_Bool_Exp>>;
  _not?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Course_Groups_Courses_Bool_Exp>>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
  organizationCourseGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_course_groups_courses" */
export enum Organization_Course_Groups_Courses_Constraint {
  /** unique or primary key constraint on columns "course_id", "organization_course_group_id" */
  OrganizationCourseGroupsCoursesCourseIdOrganizationCours = 'organization_course_groups_courses_course_id_organization_cours',
  /** unique or primary key constraint on columns "id" */
  OrganizationCourseGroupsCoursesPkey = 'organization_course_groups_courses_pkey'
}

/** input type for inserting data into table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Insert_Input = {
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Obj_Rel_Insert_Input>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Course_Groups_Courses_Max_Fields = {
  __typename?: 'organization_course_groups_courses_max_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationCourseGroupId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Course_Groups_Courses_Min_Fields = {
  __typename?: 'organization_course_groups_courses_min_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationCourseGroupId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Mutation_Response = {
  __typename?: 'organization_course_groups_courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Course_Groups_Courses>;
};

/** on_conflict condition type for table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_On_Conflict = {
  constraint: Organization_Course_Groups_Courses_Constraint;
  update_columns?: Array<Organization_Course_Groups_Courses_Update_Column>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_course_groups_courses". */
export type Organization_Course_Groups_Courses_Order_By = {
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_course_groups_courses */
export type Organization_Course_Groups_Courses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_course_groups_courses" */
export enum Organization_Course_Groups_Courses_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationCourseGroupId = 'organizationCourseGroupId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Set_Input = {
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_course_groups_courses" */
export type Organization_Course_Groups_Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Course_Groups_Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Course_Groups_Courses_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_course_groups_courses" */
export enum Organization_Course_Groups_Courses_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationCourseGroupId = 'organizationCourseGroupId',
  /** column name */
  Updated = 'updated'
}

export type Organization_Course_Groups_Courses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Course_Groups_Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Course_Groups_Courses_Bool_Exp;
};

/** input type for inserting data into table "organization_course_groups" */
export type Organization_Course_Groups_Insert_Input = {
  courses?: InputMaybe<Organization_Course_Groups_Courses_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationCodes?: InputMaybe<Organization_Course_Groups_Organization_Codes_Arr_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  releaseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  teachers?: InputMaybe<Organization_Course_Groups_Teachers_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Course_Groups_Max_Fields = {
  __typename?: 'organization_course_groups_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  releaseDate?: Maybe<Scalars['timestamptz']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Organization_Course_Groups_Min_Fields = {
  __typename?: 'organization_course_groups_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  releaseDate?: Maybe<Scalars['timestamptz']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organization_course_groups" */
export type Organization_Course_Groups_Mutation_Response = {
  __typename?: 'organization_course_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Course_Groups>;
};

/** input type for inserting object relation for remote table "organization_course_groups" */
export type Organization_Course_Groups_Obj_Rel_Insert_Input = {
  data: Organization_Course_Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Course_Groups_On_Conflict>;
};

/** on_conflict condition type for table "organization_course_groups" */
export type Organization_Course_Groups_On_Conflict = {
  constraint: Organization_Course_Groups_Constraint;
  update_columns?: Array<Organization_Course_Groups_Update_Column>;
  where?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_course_groups". */
export type Organization_Course_Groups_Order_By = {
  courses_aggregate?: InputMaybe<Organization_Course_Groups_Courses_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  default?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationCodes_aggregate?: InputMaybe<Organization_Course_Groups_Organization_Codes_Aggregate_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  releaseDate?: InputMaybe<Order_By>;
  teachers_aggregate?: InputMaybe<Organization_Course_Groups_Teachers_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes = {
  __typename?: 'organization_course_groups_organization_codes';
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationCode: Organization_Codes;
  organizationCodeId: Scalars['uuid']['output'];
  /** An object relationship */
  organizationCourseGroup: Organization_Course_Groups;
  organizationCourseGroupId: Scalars['uuid']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Aggregate = {
  __typename?: 'organization_course_groups_organization_codes_aggregate';
  aggregate?: Maybe<Organization_Course_Groups_Organization_Codes_Aggregate_Fields>;
  nodes: Array<Organization_Course_Groups_Organization_Codes>;
};

export type Organization_Course_Groups_Organization_Codes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Course_Groups_Organization_Codes_Aggregate_Bool_Exp_Count>;
};

export type Organization_Course_Groups_Organization_Codes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Aggregate_Fields = {
  __typename?: 'organization_course_groups_organization_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Course_Groups_Organization_Codes_Max_Fields>;
  min?: Maybe<Organization_Course_Groups_Organization_Codes_Min_Fields>;
};


/** aggregate fields of "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Course_Groups_Organization_Codes_Max_Order_By>;
  min?: InputMaybe<Organization_Course_Groups_Organization_Codes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Arr_Rel_Insert_Input = {
  data: Array<Organization_Course_Groups_Organization_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Course_Groups_Organization_Codes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_course_groups_organization_codes". All fields are combined with a logical 'AND'. */
export type Organization_Course_Groups_Organization_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Bool_Exp>>;
  _not?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organizationCode?: InputMaybe<Organization_Codes_Bool_Exp>;
  organizationCodeId?: InputMaybe<Uuid_Comparison_Exp>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
  organizationCourseGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_course_groups_organization_codes" */
export enum Organization_Course_Groups_Organization_Codes_Constraint {
  /** unique or primary key constraint on columns "organization_course_group_id", "organization_code_id" */
  OrganizationCourseGroupsOrganizationCodesOrganizationCour = 'organization_course_groups_organization_codes_organization_cour',
  /** unique or primary key constraint on columns "id" */
  OrganizationCourseGroupsOrganizationCodesPkey = 'organization_course_groups_organization_codes_pkey'
}

/** input type for inserting data into table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCode?: InputMaybe<Organization_Codes_Obj_Rel_Insert_Input>;
  organizationCodeId?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Obj_Rel_Insert_Input>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Course_Groups_Organization_Codes_Max_Fields = {
  __typename?: 'organization_course_groups_organization_codes_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationCodeId?: Maybe<Scalars['uuid']['output']>;
  organizationCourseGroupId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCodeId?: InputMaybe<Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Course_Groups_Organization_Codes_Min_Fields = {
  __typename?: 'organization_course_groups_organization_codes_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationCodeId?: Maybe<Scalars['uuid']['output']>;
  organizationCourseGroupId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCodeId?: InputMaybe<Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Mutation_Response = {
  __typename?: 'organization_course_groups_organization_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Course_Groups_Organization_Codes>;
};

/** on_conflict condition type for table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_On_Conflict = {
  constraint: Organization_Course_Groups_Organization_Codes_Constraint;
  update_columns?: Array<Organization_Course_Groups_Organization_Codes_Update_Column>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_course_groups_organization_codes". */
export type Organization_Course_Groups_Organization_Codes_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCode?: InputMaybe<Organization_Codes_Order_By>;
  organizationCodeId?: InputMaybe<Order_By>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_course_groups_organization_codes */
export type Organization_Course_Groups_Organization_Codes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_course_groups_organization_codes" */
export enum Organization_Course_Groups_Organization_Codes_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationCodeId = 'organizationCodeId',
  /** column name */
  OrganizationCourseGroupId = 'organizationCourseGroupId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCodeId?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_course_groups_organization_codes" */
export type Organization_Course_Groups_Organization_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Course_Groups_Organization_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Course_Groups_Organization_Codes_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCodeId?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_course_groups_organization_codes" */
export enum Organization_Course_Groups_Organization_Codes_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationCodeId = 'organizationCodeId',
  /** column name */
  OrganizationCourseGroupId = 'organizationCourseGroupId',
  /** column name */
  Updated = 'updated'
}

export type Organization_Course_Groups_Organization_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Course_Groups_Organization_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Course_Groups_Organization_Codes_Bool_Exp;
};

/** primary key columns input for table: organization_course_groups */
export type Organization_Course_Groups_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_course_groups" */
export enum Organization_Course_Groups_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Default = 'default',
  /** column name */
  Description = 'description',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Public = 'public',
  /** column name */
  ReleaseDate = 'releaseDate',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "organization_course_groups" */
export type Organization_Course_Groups_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  releaseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_course_groups" */
export type Organization_Course_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Course_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Course_Groups_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  releaseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers = {
  __typename?: 'organization_course_groups_teachers';
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationCourseGroup: Organization_Course_Groups;
  organizationCourseGroupId: Scalars['uuid']['output'];
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Aggregate = {
  __typename?: 'organization_course_groups_teachers_aggregate';
  aggregate?: Maybe<Organization_Course_Groups_Teachers_Aggregate_Fields>;
  nodes: Array<Organization_Course_Groups_Teachers>;
};

export type Organization_Course_Groups_Teachers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Course_Groups_Teachers_Aggregate_Bool_Exp_Count>;
};

export type Organization_Course_Groups_Teachers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Aggregate_Fields = {
  __typename?: 'organization_course_groups_teachers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Course_Groups_Teachers_Max_Fields>;
  min?: Maybe<Organization_Course_Groups_Teachers_Min_Fields>;
};


/** aggregate fields of "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Course_Groups_Teachers_Max_Order_By>;
  min?: InputMaybe<Organization_Course_Groups_Teachers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Arr_Rel_Insert_Input = {
  data: Array<Organization_Course_Groups_Teachers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Course_Groups_Teachers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_course_groups_teachers". All fields are combined with a logical 'AND'. */
export type Organization_Course_Groups_Teachers_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Course_Groups_Teachers_Bool_Exp>>;
  _not?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Course_Groups_Teachers_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
  organizationCourseGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_course_groups_teachers" */
export enum Organization_Course_Groups_Teachers_Constraint {
  /** unique or primary key constraint on columns "teacher_id", "organization_course_group_id" */
  OrganizationCourseGroupsTeachersOrganizationCourseGroupI = 'organization_course_groups_teachers_organization_course_group_i',
  /** unique or primary key constraint on columns "id" */
  OrganizationCourseGroupsTeachersPkey = 'organization_course_groups_teachers_pkey'
}

/** input type for inserting data into table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Obj_Rel_Insert_Input>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Course_Groups_Teachers_Max_Fields = {
  __typename?: 'organization_course_groups_teachers_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationCourseGroupId?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Course_Groups_Teachers_Min_Fields = {
  __typename?: 'organization_course_groups_teachers_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationCourseGroupId?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Mutation_Response = {
  __typename?: 'organization_course_groups_teachers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Course_Groups_Teachers>;
};

/** on_conflict condition type for table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_On_Conflict = {
  constraint: Organization_Course_Groups_Teachers_Constraint;
  update_columns?: Array<Organization_Course_Groups_Teachers_Update_Column>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_course_groups_teachers". */
export type Organization_Course_Groups_Teachers_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationCourseGroup?: InputMaybe<Organization_Course_Groups_Order_By>;
  organizationCourseGroupId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_course_groups_teachers */
export type Organization_Course_Groups_Teachers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_course_groups_teachers" */
export enum Organization_Course_Groups_Teachers_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationCourseGroupId = 'organizationCourseGroupId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_course_groups_teachers" */
export type Organization_Course_Groups_Teachers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Course_Groups_Teachers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Course_Groups_Teachers_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationCourseGroupId?: InputMaybe<Scalars['uuid']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_course_groups_teachers" */
export enum Organization_Course_Groups_Teachers_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationCourseGroupId = 'organizationCourseGroupId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Organization_Course_Groups_Teachers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Course_Groups_Teachers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Course_Groups_Teachers_Bool_Exp;
};

/** update columns of table "organization_course_groups" */
export enum Organization_Course_Groups_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Default = 'default',
  /** column name */
  Description = 'description',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Public = 'public',
  /** column name */
  ReleaseDate = 'releaseDate',
  /** column name */
  Updated = 'updated'
}

export type Organization_Course_Groups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Course_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Course_Groups_Bool_Exp;
};

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  allowDefaultSyllabirdThemes: Scalars['Boolean']['output'];
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  freeEmails?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ignoredEmails?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  organizationAdmins: Array<Organization_Admins>;
  /** An aggregate relationship */
  organizationAdmins_aggregate: Organization_Admins_Aggregate;
  /** An array relationship */
  organizationCodes: Array<Organization_Codes>;
  /** An aggregate relationship */
  organizationCodes_aggregate: Organization_Codes_Aggregate;
  supportLink?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  /** An object relationship */
  theme?: Maybe<Themes>;
  themeId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  themes: Array<Themes>;
  /** An aggregate relationship */
  themes_aggregate: Themes_Aggregate;
  webhookSecret?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationAdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationAdmins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationCodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};

/** aggregated selection of "organizations" */
export type Organizations_Aggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<Organizations_Aggregate_Fields>;
  nodes: Array<Organizations>;
};

export type Organizations_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organizations_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organizations_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organizations_Aggregate_Bool_Exp_Count>;
};

export type Organizations_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organizations_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organizations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organizations" */
export type Organizations_Aggregate_Fields = {
  __typename?: 'organizations_aggregate_fields';
  avg?: Maybe<Organizations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organizations_Max_Fields>;
  min?: Maybe<Organizations_Min_Fields>;
  stddev?: Maybe<Organizations_Stddev_Fields>;
  stddev_pop?: Maybe<Organizations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organizations_Stddev_Samp_Fields>;
  sum?: Maybe<Organizations_Sum_Fields>;
  var_pop?: Maybe<Organizations_Var_Pop_Fields>;
  var_samp?: Maybe<Organizations_Var_Samp_Fields>;
  variance?: Maybe<Organizations_Variance_Fields>;
};


/** aggregate fields of "organizations" */
export type Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organizations" */
export type Organizations_Aggregate_Order_By = {
  avg?: InputMaybe<Organizations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organizations_Max_Order_By>;
  min?: InputMaybe<Organizations_Min_Order_By>;
  stddev?: InputMaybe<Organizations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organizations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organizations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organizations_Sum_Order_By>;
  var_pop?: InputMaybe<Organizations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organizations_Var_Samp_Order_By>;
  variance?: InputMaybe<Organizations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organizations" */
export type Organizations_Arr_Rel_Insert_Input = {
  data: Array<Organizations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** aggregate avg on columns */
export type Organizations_Avg_Fields = {
  __typename?: 'organizations_avg_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organizations" */
export type Organizations_Avg_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  allowDefaultSyllabirdThemes?: InputMaybe<Boolean_Comparison_Exp>;
  courses?: InputMaybe<Courses_Bool_Exp>;
  courses_aggregate?: InputMaybe<Courses_Aggregate_Bool_Exp>;
  freeEmails?: InputMaybe<String_Array_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ignoredEmails?: InputMaybe<String_Array_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfSeatsAvailable?: InputMaybe<Int_Comparison_Exp>;
  organizationAdmins?: InputMaybe<Organization_Admins_Bool_Exp>;
  organizationAdmins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp>;
  organizationCodes?: InputMaybe<Organization_Codes_Bool_Exp>;
  organizationCodes_aggregate?: InputMaybe<Organization_Codes_Aggregate_Bool_Exp>;
  supportLink?: InputMaybe<String_Comparison_Exp>;
  teachers?: InputMaybe<Teachers_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Bool_Exp>;
  theme?: InputMaybe<Themes_Bool_Exp>;
  themeId?: InputMaybe<Uuid_Comparison_Exp>;
  themes?: InputMaybe<Themes_Bool_Exp>;
  themes_aggregate?: InputMaybe<Themes_Aggregate_Bool_Exp>;
  webhookSecret?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey = 'organizations_pkey',
  /** unique or primary key constraint on columns "webhook_secret" */
  OrganizationsWebhookSecret = 'organizations_webhook_secret',
  /** unique or primary key constraint on columns "webhook_secret" */
  OrganizationsWebhookSecretKey = 'organizations_webhook_secret_key'
}

/** input type for incrementing numeric columns in table "organizations" */
export type Organizations_Inc_Input = {
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organizations" */
export type Organizations_Insert_Input = {
  allowDefaultSyllabirdThemes?: InputMaybe<Scalars['Boolean']['input']>;
  courses?: InputMaybe<Courses_Arr_Rel_Insert_Input>;
  freeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
  organizationAdmins?: InputMaybe<Organization_Admins_Arr_Rel_Insert_Input>;
  organizationCodes?: InputMaybe<Organization_Codes_Arr_Rel_Insert_Input>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  teachers?: InputMaybe<Teachers_Arr_Rel_Insert_Input>;
  theme?: InputMaybe<Themes_Obj_Rel_Insert_Input>;
  themeId?: InputMaybe<Scalars['uuid']['input']>;
  themes?: InputMaybe<Themes_Arr_Rel_Insert_Input>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organizations_Max_Fields = {
  __typename?: 'organizations_max_fields';
  freeEmails?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ignoredEmails?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['uuid']['output']>;
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organizations" */
export type Organizations_Max_Order_By = {
  freeEmails?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredEmails?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
  supportLink?: InputMaybe<Order_By>;
  themeId?: InputMaybe<Order_By>;
  webhookSecret?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organizations_Min_Fields = {
  __typename?: 'organizations_min_fields';
  freeEmails?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ignoredEmails?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['uuid']['output']>;
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organizations" */
export type Organizations_Min_Order_By = {
  freeEmails?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredEmails?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
  supportLink?: InputMaybe<Order_By>;
  themeId?: InputMaybe<Order_By>;
  webhookSecret?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type Organizations_Obj_Rel_Insert_Input = {
  data: Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** on_conflict condition type for table "organizations" */
export type Organizations_On_Conflict = {
  constraint: Organizations_Constraint;
  update_columns?: Array<Organizations_Update_Column>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations". */
export type Organizations_Order_By = {
  allowDefaultSyllabirdThemes?: InputMaybe<Order_By>;
  courses_aggregate?: InputMaybe<Courses_Aggregate_Order_By>;
  freeEmails?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredEmails?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
  organizationAdmins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Order_By>;
  organizationCodes_aggregate?: InputMaybe<Organization_Codes_Aggregate_Order_By>;
  supportLink?: InputMaybe<Order_By>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Order_By>;
  theme?: InputMaybe<Themes_Order_By>;
  themeId?: InputMaybe<Order_By>;
  themes_aggregate?: InputMaybe<Themes_Aggregate_Order_By>;
  webhookSecret?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations */
export type Organizations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  AllowDefaultSyllabirdThemes = 'allowDefaultSyllabirdThemes',
  /** column name */
  FreeEmails = 'freeEmails',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoredEmails = 'ignoredEmails',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSeatsAvailable = 'numberOfSeatsAvailable',
  /** column name */
  SupportLink = 'supportLink',
  /** column name */
  ThemeId = 'themeId',
  /** column name */
  WebhookSecret = 'webhookSecret'
}

/** select "organizations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organizations" */
export enum Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowDefaultSyllabirdThemes = 'allowDefaultSyllabirdThemes'
}

/** select "organizations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organizations" */
export enum Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowDefaultSyllabirdThemes = 'allowDefaultSyllabirdThemes'
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  allowDefaultSyllabirdThemes?: InputMaybe<Scalars['Boolean']['input']>;
  freeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  themeId?: InputMaybe<Scalars['uuid']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Organizations_Stddev_Fields = {
  __typename?: 'organizations_stddev_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organizations" */
export type Organizations_Stddev_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organizations_Stddev_Pop_Fields = {
  __typename?: 'organizations_stddev_pop_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organizations" */
export type Organizations_Stddev_Pop_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organizations_Stddev_Samp_Fields = {
  __typename?: 'organizations_stddev_samp_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organizations" */
export type Organizations_Stddev_Samp_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organizations" */
export type Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Stream_Cursor_Value_Input = {
  allowDefaultSyllabirdThemes?: InputMaybe<Scalars['Boolean']['input']>;
  freeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  themeId?: InputMaybe<Scalars['uuid']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organizations_Sum_Fields = {
  __typename?: 'organizations_sum_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organizations" */
export type Organizations_Sum_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  AllowDefaultSyllabirdThemes = 'allowDefaultSyllabirdThemes',
  /** column name */
  FreeEmails = 'freeEmails',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoredEmails = 'ignoredEmails',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSeatsAvailable = 'numberOfSeatsAvailable',
  /** column name */
  SupportLink = 'supportLink',
  /** column name */
  ThemeId = 'themeId',
  /** column name */
  WebhookSecret = 'webhookSecret'
}

export type Organizations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organizations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organizations_Var_Pop_Fields = {
  __typename?: 'organizations_var_pop_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organizations" */
export type Organizations_Var_Pop_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organizations_Var_Samp_Fields = {
  __typename?: 'organizations_var_samp_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organizations" */
export type Organizations_Var_Samp_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organizations_Variance_Fields = {
  __typename?: 'organizations_variance_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organizations" */
export type Organizations_Variance_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** columns and relationships of "parrot_request_status" */
export type Parrot_Request_Status = {
  __typename?: 'parrot_request_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "parrot_request_status" */
export type Parrot_Request_Status_Aggregate = {
  __typename?: 'parrot_request_status_aggregate';
  aggregate?: Maybe<Parrot_Request_Status_Aggregate_Fields>;
  nodes: Array<Parrot_Request_Status>;
};

/** aggregate fields of "parrot_request_status" */
export type Parrot_Request_Status_Aggregate_Fields = {
  __typename?: 'parrot_request_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Parrot_Request_Status_Max_Fields>;
  min?: Maybe<Parrot_Request_Status_Min_Fields>;
};


/** aggregate fields of "parrot_request_status" */
export type Parrot_Request_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "parrot_request_status". All fields are combined with a logical 'AND'. */
export type Parrot_Request_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Parrot_Request_Status_Bool_Exp>>;
  _not?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Parrot_Request_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "parrot_request_status" */
export enum Parrot_Request_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ParrotRequestStatusPkey = 'parrot_request_status_pkey'
}

export enum Parrot_Request_Status_Enum {
  Blocked = 'BLOCKED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "parrot_request_status_enum". All fields are combined with logical 'AND'. */
export type Parrot_Request_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Parrot_Request_Status_Enum>;
  _in?: InputMaybe<Array<Parrot_Request_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Parrot_Request_Status_Enum>;
  _nin?: InputMaybe<Array<Parrot_Request_Status_Enum>>;
};

/** input type for inserting data into table "parrot_request_status" */
export type Parrot_Request_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Parrot_Request_Status_Max_Fields = {
  __typename?: 'parrot_request_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Parrot_Request_Status_Min_Fields = {
  __typename?: 'parrot_request_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "parrot_request_status" */
export type Parrot_Request_Status_Mutation_Response = {
  __typename?: 'parrot_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parrot_Request_Status>;
};

/** on_conflict condition type for table "parrot_request_status" */
export type Parrot_Request_Status_On_Conflict = {
  constraint: Parrot_Request_Status_Constraint;
  update_columns?: Array<Parrot_Request_Status_Update_Column>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "parrot_request_status". */
export type Parrot_Request_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parrot_request_status */
export type Parrot_Request_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "parrot_request_status" */
export enum Parrot_Request_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "parrot_request_status" */
export type Parrot_Request_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "parrot_request_status" */
export type Parrot_Request_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parrot_Request_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parrot_Request_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "parrot_request_status" */
export enum Parrot_Request_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Parrot_Request_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parrot_Request_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parrot_Request_Status_Bool_Exp;
};

/** columns and relationships of "parrot_requests" */
export type Parrot_Requests = {
  __typename?: 'parrot_requests';
  claimerId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  endWeek: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['uuid']['output'];
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek: Scalars['Int']['output'];
  status: Parrot_Request_Status_Enum;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
  userNotes?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "parrot_requests" */
export type Parrot_RequestsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "parrot_requests" */
export type Parrot_RequestsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "parrot_requests" */
export type Parrot_Requests_Aggregate = {
  __typename?: 'parrot_requests_aggregate';
  aggregate?: Maybe<Parrot_Requests_Aggregate_Fields>;
  nodes: Array<Parrot_Requests>;
};

export type Parrot_Requests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parrot_Requests_Aggregate_Bool_Exp_Count>;
};

export type Parrot_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parrot_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parrot_requests" */
export type Parrot_Requests_Aggregate_Fields = {
  __typename?: 'parrot_requests_aggregate_fields';
  avg?: Maybe<Parrot_Requests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parrot_Requests_Max_Fields>;
  min?: Maybe<Parrot_Requests_Min_Fields>;
  stddev?: Maybe<Parrot_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Parrot_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parrot_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Parrot_Requests_Sum_Fields>;
  var_pop?: Maybe<Parrot_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Parrot_Requests_Var_Samp_Fields>;
  variance?: Maybe<Parrot_Requests_Variance_Fields>;
};


/** aggregate fields of "parrot_requests" */
export type Parrot_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parrot_requests" */
export type Parrot_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<Parrot_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parrot_Requests_Max_Order_By>;
  min?: InputMaybe<Parrot_Requests_Min_Order_By>;
  stddev?: InputMaybe<Parrot_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parrot_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parrot_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parrot_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<Parrot_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parrot_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<Parrot_Requests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parrot_requests" */
export type Parrot_Requests_Arr_Rel_Insert_Input = {
  data: Array<Parrot_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Parrot_Requests_Avg_Fields = {
  __typename?: 'parrot_requests_avg_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parrot_requests" */
export type Parrot_Requests_Avg_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parrot_requests". All fields are combined with a logical 'AND'. */
export type Parrot_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Parrot_Requests_Bool_Exp>>;
  _not?: InputMaybe<Parrot_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Parrot_Requests_Bool_Exp>>;
  claimerId?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  endWeek?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  queuePosition?: InputMaybe<Int_Comparison_Exp>;
  startWeek?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Parrot_Request_Status_Enum_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  userNotes?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "parrot_requests" */
export enum Parrot_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParrotRequestsPkey = 'parrot_requests_pkey'
}

/** input type for incrementing numeric columns in table "parrot_requests" */
export type Parrot_Requests_Inc_Input = {
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parrot_requests" */
export type Parrot_Requests_Insert_Input = {
  claimerId?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Parrot_Request_Status_Enum>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Parrot_Requests_Max_Fields = {
  __typename?: 'parrot_requests_max_fields';
  claimerId?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  endWeek?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  userNotes?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "parrot_requests" */
export type Parrot_Requests_Max_Order_By = {
  claimerId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  endWeek?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userNotes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parrot_Requests_Min_Fields = {
  __typename?: 'parrot_requests_min_fields';
  claimerId?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  endWeek?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  userNotes?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "parrot_requests" */
export type Parrot_Requests_Min_Order_By = {
  claimerId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  endWeek?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userNotes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parrot_requests" */
export type Parrot_Requests_Mutation_Response = {
  __typename?: 'parrot_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parrot_Requests>;
};

/** input type for inserting object relation for remote table "parrot_requests" */
export type Parrot_Requests_Obj_Rel_Insert_Input = {
  data: Parrot_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};

/** on_conflict condition type for table "parrot_requests" */
export type Parrot_Requests_On_Conflict = {
  constraint: Parrot_Requests_Constraint;
  update_columns?: Array<Parrot_Requests_Update_Column>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "parrot_requests". */
export type Parrot_Requests_Order_By = {
  claimerId?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  endWeek?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userNotes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parrot_requests */
export type Parrot_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "parrot_requests" */
export enum Parrot_Requests_Select_Column {
  /** column name */
  ClaimerId = 'claimerId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  EndWeek = 'endWeek',
  /** column name */
  Id = 'id',
  /** column name */
  QueuePosition = 'queuePosition',
  /** column name */
  StartWeek = 'startWeek',
  /** column name */
  Status = 'status',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserNotes = 'userNotes'
}

/** input type for updating data in table "parrot_requests" */
export type Parrot_Requests_Set_Input = {
  claimerId?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Parrot_Request_Status_Enum>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Parrot_Requests_Stddev_Fields = {
  __typename?: 'parrot_requests_stddev_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parrot_requests" */
export type Parrot_Requests_Stddev_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parrot_Requests_Stddev_Pop_Fields = {
  __typename?: 'parrot_requests_stddev_pop_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parrot_requests" */
export type Parrot_Requests_Stddev_Pop_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parrot_Requests_Stddev_Samp_Fields = {
  __typename?: 'parrot_requests_stddev_samp_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parrot_requests" */
export type Parrot_Requests_Stddev_Samp_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parrot_requests" */
export type Parrot_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parrot_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parrot_Requests_Stream_Cursor_Value_Input = {
  claimerId?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Parrot_Request_Status_Enum>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Parrot_Requests_Sum_Fields = {
  __typename?: 'parrot_requests_sum_fields';
  endWeek?: Maybe<Scalars['Int']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "parrot_requests" */
export type Parrot_Requests_Sum_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** update columns of table "parrot_requests" */
export enum Parrot_Requests_Update_Column {
  /** column name */
  ClaimerId = 'claimerId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  EndWeek = 'endWeek',
  /** column name */
  Id = 'id',
  /** column name */
  QueuePosition = 'queuePosition',
  /** column name */
  StartWeek = 'startWeek',
  /** column name */
  Status = 'status',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserNotes = 'userNotes'
}

export type Parrot_Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parrot_Requests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parrot_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parrot_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parrot_Requests_Var_Pop_Fields = {
  __typename?: 'parrot_requests_var_pop_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parrot_requests" */
export type Parrot_Requests_Var_Pop_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parrot_Requests_Var_Samp_Fields = {
  __typename?: 'parrot_requests_var_samp_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parrot_requests" */
export type Parrot_Requests_Var_Samp_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parrot_Requests_Variance_Fields = {
  __typename?: 'parrot_requests_variance_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parrot_requests" */
export type Parrot_Requests_Variance_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** columns and relationships of "plan_tier" */
export type Plan_Tier = {
  __typename?: 'plan_tier';
  value: Scalars['String']['output'];
};

/** aggregated selection of "plan_tier" */
export type Plan_Tier_Aggregate = {
  __typename?: 'plan_tier_aggregate';
  aggregate?: Maybe<Plan_Tier_Aggregate_Fields>;
  nodes: Array<Plan_Tier>;
};

/** aggregate fields of "plan_tier" */
export type Plan_Tier_Aggregate_Fields = {
  __typename?: 'plan_tier_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Plan_Tier_Max_Fields>;
  min?: Maybe<Plan_Tier_Min_Fields>;
};


/** aggregate fields of "plan_tier" */
export type Plan_Tier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "plan_tier". All fields are combined with a logical 'AND'. */
export type Plan_Tier_Bool_Exp = {
  _and?: InputMaybe<Array<Plan_Tier_Bool_Exp>>;
  _not?: InputMaybe<Plan_Tier_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Tier_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "plan_tier" */
export enum Plan_Tier_Constraint {
  /** unique or primary key constraint on columns "value" */
  PlanTierPkey = 'plan_tier_pkey'
}

export enum Plan_Tier_Enum {
  Tier1 = 'TIER1',
  Tier2 = 'TIER2',
  Trial = 'TRIAL'
}

/** Boolean expression to compare columns of type "plan_tier_enum". All fields are combined with logical 'AND'. */
export type Plan_Tier_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Plan_Tier_Enum>;
  _in?: InputMaybe<Array<Plan_Tier_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Plan_Tier_Enum>;
  _nin?: InputMaybe<Array<Plan_Tier_Enum>>;
};

/** input type for inserting data into table "plan_tier" */
export type Plan_Tier_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Plan_Tier_Max_Fields = {
  __typename?: 'plan_tier_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Plan_Tier_Min_Fields = {
  __typename?: 'plan_tier_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "plan_tier" */
export type Plan_Tier_Mutation_Response = {
  __typename?: 'plan_tier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan_Tier>;
};

/** on_conflict condition type for table "plan_tier" */
export type Plan_Tier_On_Conflict = {
  constraint: Plan_Tier_Constraint;
  update_columns?: Array<Plan_Tier_Update_Column>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};

/** Ordering options when selecting data from "plan_tier". */
export type Plan_Tier_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plan_tier */
export type Plan_Tier_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "plan_tier" */
export enum Plan_Tier_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "plan_tier" */
export type Plan_Tier_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "plan_tier" */
export type Plan_Tier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Tier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Tier_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "plan_tier" */
export enum Plan_Tier_Update_Column {
  /** column name */
  Value = 'value'
}

export type Plan_Tier_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Tier_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plan_Tier_Bool_Exp;
};

/** columns and relationships of "printing_job_status" */
export type Printing_Job_Status = {
  __typename?: 'printing_job_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "printing_job_status" */
export type Printing_Job_Status_Aggregate = {
  __typename?: 'printing_job_status_aggregate';
  aggregate?: Maybe<Printing_Job_Status_Aggregate_Fields>;
  nodes: Array<Printing_Job_Status>;
};

/** aggregate fields of "printing_job_status" */
export type Printing_Job_Status_Aggregate_Fields = {
  __typename?: 'printing_job_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printing_Job_Status_Max_Fields>;
  min?: Maybe<Printing_Job_Status_Min_Fields>;
};


/** aggregate fields of "printing_job_status" */
export type Printing_Job_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "printing_job_status". All fields are combined with a logical 'AND'. */
export type Printing_Job_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Printing_Job_Status_Bool_Exp>>;
  _not?: InputMaybe<Printing_Job_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Printing_Job_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "printing_job_status" */
export enum Printing_Job_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  PrintingJobStatusPkey = 'printing_job_status_pkey'
}

export enum Printing_Job_Status_Enum {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Generating = 'GENERATING'
}

/** Boolean expression to compare columns of type "printing_job_status_enum". All fields are combined with logical 'AND'. */
export type Printing_Job_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Printing_Job_Status_Enum>;
  _in?: InputMaybe<Array<Printing_Job_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Printing_Job_Status_Enum>;
  _nin?: InputMaybe<Array<Printing_Job_Status_Enum>>;
};

/** input type for inserting data into table "printing_job_status" */
export type Printing_Job_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Printing_Job_Status_Max_Fields = {
  __typename?: 'printing_job_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Printing_Job_Status_Min_Fields = {
  __typename?: 'printing_job_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "printing_job_status" */
export type Printing_Job_Status_Mutation_Response = {
  __typename?: 'printing_job_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printing_Job_Status>;
};

/** on_conflict condition type for table "printing_job_status" */
export type Printing_Job_Status_On_Conflict = {
  constraint: Printing_Job_Status_Constraint;
  update_columns?: Array<Printing_Job_Status_Update_Column>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "printing_job_status". */
export type Printing_Job_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printing_job_status */
export type Printing_Job_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "printing_job_status" */
export enum Printing_Job_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "printing_job_status" */
export type Printing_Job_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "printing_job_status" */
export type Printing_Job_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printing_Job_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printing_Job_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "printing_job_status" */
export enum Printing_Job_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Printing_Job_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printing_Job_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printing_Job_Status_Bool_Exp;
};

/** columns and relationships of "printing_job_type" */
export type Printing_Job_Type = {
  __typename?: 'printing_job_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "printing_job_type" */
export type Printing_Job_Type_Aggregate = {
  __typename?: 'printing_job_type_aggregate';
  aggregate?: Maybe<Printing_Job_Type_Aggregate_Fields>;
  nodes: Array<Printing_Job_Type>;
};

/** aggregate fields of "printing_job_type" */
export type Printing_Job_Type_Aggregate_Fields = {
  __typename?: 'printing_job_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printing_Job_Type_Max_Fields>;
  min?: Maybe<Printing_Job_Type_Min_Fields>;
};


/** aggregate fields of "printing_job_type" */
export type Printing_Job_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "printing_job_type". All fields are combined with a logical 'AND'. */
export type Printing_Job_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Printing_Job_Type_Bool_Exp>>;
  _not?: InputMaybe<Printing_Job_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Printing_Job_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "printing_job_type" */
export enum Printing_Job_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PrintingJobTypePkey = 'printing_job_type_pkey'
}

export enum Printing_Job_Type_Enum {
  Calendar = 'CALENDAR',
  CourseInfo = 'COURSE_INFO',
  StudentCourseInfo = 'STUDENT_COURSE_INFO',
  Transcript = 'TRANSCRIPT'
}

/** Boolean expression to compare columns of type "printing_job_type_enum". All fields are combined with logical 'AND'. */
export type Printing_Job_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Printing_Job_Type_Enum>;
  _in?: InputMaybe<Array<Printing_Job_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Printing_Job_Type_Enum>;
  _nin?: InputMaybe<Array<Printing_Job_Type_Enum>>;
};

/** input type for inserting data into table "printing_job_type" */
export type Printing_Job_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Printing_Job_Type_Max_Fields = {
  __typename?: 'printing_job_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Printing_Job_Type_Min_Fields = {
  __typename?: 'printing_job_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "printing_job_type" */
export type Printing_Job_Type_Mutation_Response = {
  __typename?: 'printing_job_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printing_Job_Type>;
};

/** on_conflict condition type for table "printing_job_type" */
export type Printing_Job_Type_On_Conflict = {
  constraint: Printing_Job_Type_Constraint;
  update_columns?: Array<Printing_Job_Type_Update_Column>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "printing_job_type". */
export type Printing_Job_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printing_job_type */
export type Printing_Job_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "printing_job_type" */
export enum Printing_Job_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "printing_job_type" */
export type Printing_Job_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "printing_job_type" */
export type Printing_Job_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printing_Job_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printing_Job_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "printing_job_type" */
export enum Printing_Job_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Printing_Job_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printing_Job_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printing_Job_Type_Bool_Exp;
};

/** columns and relationships of "printing_jobs" */
export type Printing_Jobs = {
  __typename?: 'printing_jobs';
  created: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  id: Scalars['uuid']['output'];
  status: Printing_Job_Status_Enum;
  /** An object relationship */
  studentAccount?: Maybe<Student_Accounts>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Printing_Job_Type_Enum>;
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "printing_jobs" */
export type Printing_JobsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "printing_jobs" */
export type Printing_Jobs_Aggregate = {
  __typename?: 'printing_jobs_aggregate';
  aggregate?: Maybe<Printing_Jobs_Aggregate_Fields>;
  nodes: Array<Printing_Jobs>;
};

/** aggregate fields of "printing_jobs" */
export type Printing_Jobs_Aggregate_Fields = {
  __typename?: 'printing_jobs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printing_Jobs_Max_Fields>;
  min?: Maybe<Printing_Jobs_Min_Fields>;
};


/** aggregate fields of "printing_jobs" */
export type Printing_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Printing_Jobs_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "printing_jobs". All fields are combined with a logical 'AND'. */
export type Printing_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Printing_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Printing_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Printing_Jobs_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Printing_Job_Status_Enum_Comparison_Exp>;
  studentAccount?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAccountId?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Printing_Job_Type_Enum_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printing_jobs" */
export enum Printing_Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  PrintingJobsPkey = 'printing_jobs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Printing_Jobs_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Printing_Jobs_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Printing_Jobs_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "printing_jobs" */
export type Printing_Jobs_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Printing_Job_Status_Enum>;
  studentAccount?: InputMaybe<Student_Accounts_Obj_Rel_Insert_Input>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Printing_Job_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printing_Jobs_Max_Fields = {
  __typename?: 'printing_jobs_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Printing_Jobs_Min_Fields = {
  __typename?: 'printing_jobs_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "printing_jobs" */
export type Printing_Jobs_Mutation_Response = {
  __typename?: 'printing_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printing_Jobs>;
};

/** input type for inserting object relation for remote table "printing_jobs" */
export type Printing_Jobs_Obj_Rel_Insert_Input = {
  data: Printing_Jobs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Printing_Jobs_On_Conflict>;
};

/** on_conflict condition type for table "printing_jobs" */
export type Printing_Jobs_On_Conflict = {
  constraint: Printing_Jobs_Constraint;
  update_columns?: Array<Printing_Jobs_Update_Column>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "printing_jobs". */
export type Printing_Jobs_Order_By = {
  created?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  studentAccount?: InputMaybe<Student_Accounts_Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printing_jobs */
export type Printing_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Printing_Jobs_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "printing_jobs" */
export enum Printing_Jobs_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "printing_jobs" */
export type Printing_Jobs_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Printing_Job_Status_Enum>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Printing_Job_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "printing_jobs" */
export type Printing_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printing_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printing_Jobs_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Printing_Job_Status_Enum>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Printing_Job_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "printing_jobs" */
export enum Printing_Jobs_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

export type Printing_Jobs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Printing_Jobs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Printing_Jobs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Printing_Jobs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Printing_Jobs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Printing_Jobs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printing_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printing_Jobs_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "assignments" using primary key columns */
  assignment?: Maybe<Assignments>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: Array<Assignment_Type>;
  /** fetch aggregated fields from the table: "assignment_type" */
  assignment_type_aggregate: Assignment_Type_Aggregate;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** fetch data from the table: "assignment_type_weights" using primary key columns */
  assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** fetch data from the table: "assignment_type_weights" */
  assignment_type_weights: Array<Assignment_Type_Weights>;
  /** fetch aggregated fields from the table: "assignment_type_weights" */
  assignment_type_weights_aggregate: Assignment_Type_Weights_Aggregate;
  /** An array relationship */
  assignments: Array<Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Assignments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comment?: Maybe<Comments>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "courses" using primary key columns */
  course?: Maybe<Courses>;
  /** fetch data from the table: "course_share_links" using primary key columns */
  course_share_link?: Maybe<Course_Share_Links>;
  /** fetch data from the table: "course_share_links" */
  course_share_links: Array<Course_Share_Links>;
  /** fetch aggregated fields from the table: "course_share_links" */
  course_share_links_aggregate: Course_Share_Links_Aggregate;
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  /** fetch data from the table: "custom_assignment_types" using primary key columns */
  custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** fetch data from the table: "custom_assignment_types" */
  custom_assignment_types: Array<Custom_Assignment_Types>;
  /** fetch aggregated fields from the table: "custom_assignment_types" */
  custom_assignment_types_aggregate: Custom_Assignment_Types_Aggregate;
  /** fetch data from the table: "customers" using primary key columns */
  customer?: Maybe<Customers>;
  /** fetch data from the table: "customers" */
  customers: Array<Customers>;
  /** fetch aggregated fields from the table: "customers" */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  event?: Maybe<Events>;
  /** fetch data from the table: "event_ignored_courses" */
  event_ignored_courses: Array<Event_Ignored_Courses>;
  /** fetch aggregated fields from the table: "event_ignored_courses" */
  event_ignored_courses_aggregate: Event_Ignored_Courses_Aggregate;
  /** fetch data from the table: "event_ignored_courses" using primary key columns */
  event_ignored_courses_by_pk?: Maybe<Event_Ignored_Courses>;
  /** fetch data from the table: "event_t" */
  event_t: Array<Event_T>;
  /** fetch aggregated fields from the table: "event_t" */
  event_t_aggregate: Event_T_Aggregate;
  /** fetch data from the table: "event_t" using primary key columns */
  event_type?: Maybe<Event_T>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "grading_style" */
  grading_style: Array<Grading_Style>;
  /** fetch aggregated fields from the table: "grading_style" */
  grading_style_aggregate: Grading_Style_Aggregate;
  /** fetch data from the table: "grading_style" using primary key columns */
  grading_style_by_pk?: Maybe<Grading_Style>;
  /** fetch data from the table: "organizations" using primary key columns */
  organization?: Maybe<Organizations>;
  /** Query to get a course from an Organization */
  organizationCourse?: Maybe<OrganizationCourse>;
  /** Query to get courses from an Organization */
  organizationCourses: Array<OrganizationCourse>;
  /** fetch data from the table: "organization_admins" using primary key columns */
  organization_admin?: Maybe<Organization_Admins>;
  /** fetch data from the table: "organization_admins" */
  organization_admins: Array<Organization_Admins>;
  /** fetch aggregated fields from the table: "organization_admins" */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** fetch data from the table: "organization_codes" using primary key columns */
  organization_code?: Maybe<Organization_Codes>;
  /** fetch data from the table: "organization_codes" */
  organization_codes: Array<Organization_Codes>;
  /** fetch aggregated fields from the table: "organization_codes" */
  organization_codes_aggregate: Organization_Codes_Aggregate;
  /** fetch data from the table: "organization_course_groups" using primary key columns */
  organization_course_group?: Maybe<Organization_Course_Groups>;
  /** fetch data from the table: "organization_course_groups" */
  organization_course_groups: Array<Organization_Course_Groups>;
  /** fetch aggregated fields from the table: "organization_course_groups" */
  organization_course_groups_aggregate: Organization_Course_Groups_Aggregate;
  /** fetch data from the table: "organization_course_groups_courses" */
  organization_course_groups_courses: Array<Organization_Course_Groups_Courses>;
  /** fetch aggregated fields from the table: "organization_course_groups_courses" */
  organization_course_groups_courses_aggregate: Organization_Course_Groups_Courses_Aggregate;
  /** fetch data from the table: "organization_course_groups_courses" using primary key columns */
  organization_course_groups_courses_by_pk?: Maybe<Organization_Course_Groups_Courses>;
  /** fetch data from the table: "organization_course_groups_organization_codes" */
  organization_course_groups_organization_codes: Array<Organization_Course_Groups_Organization_Codes>;
  /** fetch aggregated fields from the table: "organization_course_groups_organization_codes" */
  organization_course_groups_organization_codes_aggregate: Organization_Course_Groups_Organization_Codes_Aggregate;
  /** fetch data from the table: "organization_course_groups_organization_codes" using primary key columns */
  organization_course_groups_organization_codes_by_pk?: Maybe<Organization_Course_Groups_Organization_Codes>;
  /** fetch data from the table: "organization_course_groups_teachers" */
  organization_course_groups_teachers: Array<Organization_Course_Groups_Teachers>;
  /** fetch aggregated fields from the table: "organization_course_groups_teachers" */
  organization_course_groups_teachers_aggregate: Organization_Course_Groups_Teachers_Aggregate;
  /** fetch data from the table: "organization_course_groups_teachers" using primary key columns */
  organization_course_groups_teachers_by_pk?: Maybe<Organization_Course_Groups_Teachers>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "parrot_requests" using primary key columns */
  parrot_request?: Maybe<Parrot_Requests>;
  /** fetch data from the table: "parrot_request_status" */
  parrot_request_status: Array<Parrot_Request_Status>;
  /** fetch aggregated fields from the table: "parrot_request_status" */
  parrot_request_status_aggregate: Parrot_Request_Status_Aggregate;
  /** fetch data from the table: "parrot_request_status" using primary key columns */
  parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** fetch data from the table: "parrot_requests" */
  parrot_requests: Array<Parrot_Requests>;
  /** fetch aggregated fields from the table: "parrot_requests" */
  parrot_requests_aggregate: Parrot_Requests_Aggregate;
  /** fetch data from the table: "plan_tier" */
  plan_tier: Array<Plan_Tier>;
  /** fetch aggregated fields from the table: "plan_tier" */
  plan_tier_aggregate: Plan_Tier_Aggregate;
  /** fetch data from the table: "plan_tier" using primary key columns */
  plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** fetch data from the table: "printing_jobs" using primary key columns */
  printing_job?: Maybe<Printing_Jobs>;
  /** fetch data from the table: "printing_job_status" */
  printing_job_status: Array<Printing_Job_Status>;
  /** fetch aggregated fields from the table: "printing_job_status" */
  printing_job_status_aggregate: Printing_Job_Status_Aggregate;
  /** fetch data from the table: "printing_job_status" using primary key columns */
  printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** fetch data from the table: "printing_job_type" */
  printing_job_type: Array<Printing_Job_Type>;
  /** fetch aggregated fields from the table: "printing_job_type" */
  printing_job_type_aggregate: Printing_Job_Type_Aggregate;
  /** fetch data from the table: "printing_job_type" using primary key columns */
  printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** fetch data from the table: "printing_jobs" */
  printing_jobs: Array<Printing_Jobs>;
  /** fetch aggregated fields from the table: "printing_jobs" */
  printing_jobs_aggregate: Printing_Jobs_Aggregate;
  /** fetch data from the table: "reschedule_actions" using primary key columns */
  reschedule_action?: Maybe<Reschedule_Actions>;
  /** fetch data from the table: "reschedule_action_statuses" */
  reschedule_action_statuses: Array<Reschedule_Action_Statuses>;
  /** fetch aggregated fields from the table: "reschedule_action_statuses" */
  reschedule_action_statuses_aggregate: Reschedule_Action_Statuses_Aggregate;
  /** fetch data from the table: "reschedule_action_statuses" using primary key columns */
  reschedule_action_statuses_by_pk?: Maybe<Reschedule_Action_Statuses>;
  /** fetch data from the table: "reschedule_action_types" */
  reschedule_action_types: Array<Reschedule_Action_Types>;
  /** fetch aggregated fields from the table: "reschedule_action_types" */
  reschedule_action_types_aggregate: Reschedule_Action_Types_Aggregate;
  /** fetch data from the table: "reschedule_action_types" using primary key columns */
  reschedule_action_types_by_pk?: Maybe<Reschedule_Action_Types>;
  /** fetch data from the table: "reschedule_actions" */
  reschedule_actions: Array<Reschedule_Actions>;
  /** fetch aggregated fields from the table: "reschedule_actions" */
  reschedule_actions_aggregate: Reschedule_Actions_Aggregate;
  /** fetch data from the table: "school_year" */
  school_year: Array<School_Year>;
  /** fetch aggregated fields from the table: "school_year" */
  school_year_aggregate: School_Year_Aggregate;
  /** fetch data from the table: "school_year" using primary key columns */
  school_year_by_pk?: Maybe<School_Year>;
  /** fetch data from the table: "students" using primary key columns */
  student?: Maybe<Students>;
  /** fetch data from the table: "student_accounts" using primary key columns */
  student_account?: Maybe<Student_Accounts>;
  /** fetch data from the table: "student_accounts" */
  student_accounts: Array<Student_Accounts>;
  /** fetch aggregated fields from the table: "student_accounts" */
  student_accounts_aggregate: Student_Accounts_Aggregate;
  /** fetch data from the table: "student_assignments" using primary key columns */
  student_assignment?: Maybe<Student_Assignments>;
  /** fetch data from the table: "student_assignment_status" */
  student_assignment_status: Array<Student_Assignment_Status>;
  /** fetch aggregated fields from the table: "student_assignment_status" */
  student_assignment_status_aggregate: Student_Assignment_Status_Aggregate;
  /** fetch data from the table: "student_assignment_status" using primary key columns */
  student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** fetch data from the table: "student_assignments" */
  student_assignments: Array<Student_Assignments>;
  /** fetch aggregated fields from the table: "student_assignments" */
  student_assignments_aggregate: Student_Assignments_Aggregate;
  /** fetch data from the table: "student_courses" using primary key columns */
  student_course?: Maybe<Student_Courses>;
  /** fetch data from the table: "student_course_status" */
  student_course_status: Array<Student_Course_Status>;
  /** fetch aggregated fields from the table: "student_course_status" */
  student_course_status_aggregate: Student_Course_Status_Aggregate;
  /** fetch data from the table: "student_course_status" using primary key columns */
  student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** fetch data from the table: "student_courses" */
  student_courses: Array<Student_Courses>;
  /** fetch aggregated fields from the table: "student_courses" */
  student_courses_aggregate: Student_Courses_Aggregate;
  /** fetch data from the table: "student_events" using primary key columns */
  student_event?: Maybe<Student_Events>;
  /** fetch data from the table: "student_events" */
  student_events: Array<Student_Events>;
  /** fetch aggregated fields from the table: "student_events" */
  student_events_aggregate: Student_Events_Aggregate;
  /** fetch data from the table: "students" */
  students: Array<Students>;
  /** fetch aggregated fields from the table: "students" */
  students_aggregate: Students_Aggregate;
  /** fetch data from the table: "teachers" using primary key columns */
  teacher?: Maybe<Teachers>;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  /** fetch data from the table: "teachers_students" */
  teachers_students: Array<Teachers_Students>;
  /** fetch aggregated fields from the table: "teachers_students" */
  teachers_students_aggregate: Teachers_Students_Aggregate;
  /** fetch data from the table: "teachers_students" using primary key columns */
  teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** An array relationship */
  themes: Array<Themes>;
  /** An aggregate relationship */
  themes_aggregate: Themes_Aggregate;
  /** fetch data from the table: "themes" using primary key columns */
  themes_by_pk?: Maybe<Themes>;
  /** fetch data from the table: "transcript_drafts" using primary key columns */
  transcript_draft?: Maybe<Transcript_Drafts>;
  /** fetch data from the table: "transcript_drafts" */
  transcript_drafts: Array<Transcript_Drafts>;
  /** fetch aggregated fields from the table: "transcript_drafts" */
  transcript_drafts_aggregate: Transcript_Drafts_Aggregate;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
};


export type Query_RootAssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssignment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Query_RootAssignment_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Query_RootAssignment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAssignment_Type_WeightArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssignment_Type_WeightsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Query_RootAssignment_Type_Weights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Query_RootAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Query_RootAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Query_RootCommentArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootCourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCourse_Share_LinkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCourse_Share_LinksArgs = {
  distinct_on?: InputMaybe<Array<Course_Share_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Course_Share_Links_Order_By>>;
  where?: InputMaybe<Course_Share_Links_Bool_Exp>;
};


export type Query_RootCourse_Share_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Share_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Course_Share_Links_Order_By>>;
  where?: InputMaybe<Course_Share_Links_Bool_Exp>;
};


export type Query_RootCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Query_RootCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Query_RootCustom_Assignment_TypeArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Assignment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Query_RootCustom_Assignment_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Query_RootCustomerArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootEventArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvent_Ignored_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Ignored_Courses_Order_By>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


export type Query_RootEvent_Ignored_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Ignored_Courses_Order_By>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


export type Query_RootEvent_Ignored_Courses_By_PkArgs = {
  courseId: Scalars['uuid']['input'];
  eventId: Scalars['uuid']['input'];
};


export type Query_RootEvent_TArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Query_RootEvent_T_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Query_RootEvent_TypeArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootGrading_StyleArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Query_RootGrading_Style_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Query_RootGrading_Style_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganizationCourseArgs = {
  courseId: Scalars['uuid']['input'];
  organizationId: Scalars['uuid']['input'];
};


export type Query_RootOrganizationCoursesArgs = {
  organizationId: Scalars['uuid']['input'];
};


export type Query_RootOrganization_AdminArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Query_RootOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Query_RootOrganization_CodeArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_CodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Query_RootOrganization_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Query_RootOrganization_Course_GroupArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Course_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_Courses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Course_Groups_Organization_CodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_Organization_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_Organization_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Course_Groups_TeachersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_Teachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


export type Query_RootOrganization_Course_Groups_Teachers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootParrot_RequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParrot_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Query_RootParrot_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Query_RootParrot_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootParrot_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Query_RootParrot_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Query_RootPlan_TierArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Query_RootPlan_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Query_RootPlan_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPrinting_JobArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrinting_Job_StatusArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Query_RootPrinting_Job_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Query_RootPrinting_Job_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPrinting_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Query_RootPrinting_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Query_RootPrinting_Job_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPrinting_JobsArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Query_RootPrinting_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Query_RootReschedule_ActionArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReschedule_Action_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Statuses_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
};


export type Query_RootReschedule_Action_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Statuses_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
};


export type Query_RootReschedule_Action_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootReschedule_Action_TypesArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Types_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
};


export type Query_RootReschedule_Action_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Types_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
};


export type Query_RootReschedule_Action_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootReschedule_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Actions_Order_By>>;
  where?: InputMaybe<Reschedule_Actions_Bool_Exp>;
};


export type Query_RootReschedule_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Actions_Order_By>>;
  where?: InputMaybe<Reschedule_Actions_Bool_Exp>;
};


export type Query_RootSchool_YearArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Query_RootSchool_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Query_RootSchool_Year_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStudentArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootStudent_AccountArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootStudent_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Query_RootStudent_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Query_RootStudent_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStudent_Assignment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Query_RootStudent_Assignment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Query_RootStudent_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStudent_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Query_RootStudent_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Query_RootStudent_CourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStudent_Course_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Query_RootStudent_Course_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Query_RootStudent_Course_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStudent_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Query_RootStudent_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Query_RootStudent_EventArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStudent_EventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Query_RootStudent_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Query_RootStudentsArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Query_RootStudents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Query_RootTeacherArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Query_RootTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Query_RootTeachers_StudentsArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Query_RootTeachers_Students_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Query_RootTeachers_Students_By_PkArgs = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


export type Query_RootThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Query_RootThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Query_RootThemes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTranscript_DraftArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTranscript_DraftsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Drafts_Order_By>>;
  where?: InputMaybe<Transcript_Drafts_Bool_Exp>;
};


export type Query_RootTranscript_Drafts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Drafts_Order_By>>;
  where?: InputMaybe<Transcript_Drafts_Bool_Exp>;
};


export type Query_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "reschedule_action_statuses" */
export type Reschedule_Action_Statuses = {
  __typename?: 'reschedule_action_statuses';
  value: Scalars['String']['output'];
};

/** aggregated selection of "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Aggregate = {
  __typename?: 'reschedule_action_statuses_aggregate';
  aggregate?: Maybe<Reschedule_Action_Statuses_Aggregate_Fields>;
  nodes: Array<Reschedule_Action_Statuses>;
};

/** aggregate fields of "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Aggregate_Fields = {
  __typename?: 'reschedule_action_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reschedule_Action_Statuses_Max_Fields>;
  min?: Maybe<Reschedule_Action_Statuses_Min_Fields>;
};


/** aggregate fields of "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reschedule_Action_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "reschedule_action_statuses". All fields are combined with a logical 'AND'. */
export type Reschedule_Action_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Reschedule_Action_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Reschedule_Action_Statuses_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reschedule_action_statuses" */
export enum Reschedule_Action_Statuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  RescheduleActionStatusesPkey = 'reschedule_action_statuses_pkey'
}

export enum Reschedule_Action_Statuses_Enum {
  Active = 'ACTIVE',
  Undone = 'UNDONE'
}

/** Boolean expression to compare columns of type "reschedule_action_statuses_enum". All fields are combined with logical 'AND'. */
export type Reschedule_Action_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Reschedule_Action_Statuses_Enum>;
  _in?: InputMaybe<Array<Reschedule_Action_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Reschedule_Action_Statuses_Enum>;
  _nin?: InputMaybe<Array<Reschedule_Action_Statuses_Enum>>;
};

/** input type for inserting data into table "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Reschedule_Action_Statuses_Max_Fields = {
  __typename?: 'reschedule_action_statuses_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Reschedule_Action_Statuses_Min_Fields = {
  __typename?: 'reschedule_action_statuses_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Mutation_Response = {
  __typename?: 'reschedule_action_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reschedule_Action_Statuses>;
};

/** on_conflict condition type for table "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_On_Conflict = {
  constraint: Reschedule_Action_Statuses_Constraint;
  update_columns?: Array<Reschedule_Action_Statuses_Update_Column>;
  where?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "reschedule_action_statuses". */
export type Reschedule_Action_Statuses_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reschedule_action_statuses */
export type Reschedule_Action_Statuses_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "reschedule_action_statuses" */
export enum Reschedule_Action_Statuses_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "reschedule_action_statuses" */
export type Reschedule_Action_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reschedule_Action_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reschedule_Action_Statuses_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "reschedule_action_statuses" */
export enum Reschedule_Action_Statuses_Update_Column {
  /** column name */
  Value = 'value'
}

export type Reschedule_Action_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reschedule_Action_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reschedule_Action_Statuses_Bool_Exp;
};

/** columns and relationships of "reschedule_action_types" */
export type Reschedule_Action_Types = {
  __typename?: 'reschedule_action_types';
  value: Scalars['String']['output'];
};

/** aggregated selection of "reschedule_action_types" */
export type Reschedule_Action_Types_Aggregate = {
  __typename?: 'reschedule_action_types_aggregate';
  aggregate?: Maybe<Reschedule_Action_Types_Aggregate_Fields>;
  nodes: Array<Reschedule_Action_Types>;
};

/** aggregate fields of "reschedule_action_types" */
export type Reschedule_Action_Types_Aggregate_Fields = {
  __typename?: 'reschedule_action_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reschedule_Action_Types_Max_Fields>;
  min?: Maybe<Reschedule_Action_Types_Min_Fields>;
};


/** aggregate fields of "reschedule_action_types" */
export type Reschedule_Action_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reschedule_Action_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "reschedule_action_types". All fields are combined with a logical 'AND'. */
export type Reschedule_Action_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Reschedule_Action_Types_Bool_Exp>>;
  _not?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Reschedule_Action_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reschedule_action_types" */
export enum Reschedule_Action_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  RescheduleActionTypesPkey = 'reschedule_action_types_pkey'
}

export enum Reschedule_Action_Types_Enum {
  Freeform = 'FREEFORM',
  Normal = 'NORMAL',
  SetEnd = 'SET_END',
  Shift = 'SHIFT',
  Vacation = 'VACATION'
}

/** Boolean expression to compare columns of type "reschedule_action_types_enum". All fields are combined with logical 'AND'. */
export type Reschedule_Action_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Reschedule_Action_Types_Enum>;
  _in?: InputMaybe<Array<Reschedule_Action_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Reschedule_Action_Types_Enum>;
  _nin?: InputMaybe<Array<Reschedule_Action_Types_Enum>>;
};

/** input type for inserting data into table "reschedule_action_types" */
export type Reschedule_Action_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Reschedule_Action_Types_Max_Fields = {
  __typename?: 'reschedule_action_types_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Reschedule_Action_Types_Min_Fields = {
  __typename?: 'reschedule_action_types_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "reschedule_action_types" */
export type Reschedule_Action_Types_Mutation_Response = {
  __typename?: 'reschedule_action_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reschedule_Action_Types>;
};

/** on_conflict condition type for table "reschedule_action_types" */
export type Reschedule_Action_Types_On_Conflict = {
  constraint: Reschedule_Action_Types_Constraint;
  update_columns?: Array<Reschedule_Action_Types_Update_Column>;
  where?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "reschedule_action_types". */
export type Reschedule_Action_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reschedule_action_types */
export type Reschedule_Action_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "reschedule_action_types" */
export enum Reschedule_Action_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "reschedule_action_types" */
export type Reschedule_Action_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "reschedule_action_types" */
export type Reschedule_Action_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reschedule_Action_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reschedule_Action_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "reschedule_action_types" */
export enum Reschedule_Action_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Reschedule_Action_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reschedule_Action_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reschedule_Action_Types_Bool_Exp;
};

/** columns and relationships of "reschedule_actions" */
export type Reschedule_Actions = {
  __typename?: 'reschedule_actions';
  created: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  status: Reschedule_Action_Statuses_Enum;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  type: Reschedule_Action_Types_Enum;
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "reschedule_actions" */
export type Reschedule_ActionsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "reschedule_actions" */
export type Reschedule_Actions_Aggregate = {
  __typename?: 'reschedule_actions_aggregate';
  aggregate?: Maybe<Reschedule_Actions_Aggregate_Fields>;
  nodes: Array<Reschedule_Actions>;
};

/** aggregate fields of "reschedule_actions" */
export type Reschedule_Actions_Aggregate_Fields = {
  __typename?: 'reschedule_actions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reschedule_Actions_Max_Fields>;
  min?: Maybe<Reschedule_Actions_Min_Fields>;
};


/** aggregate fields of "reschedule_actions" */
export type Reschedule_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reschedule_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Reschedule_Actions_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "reschedule_actions". All fields are combined with a logical 'AND'. */
export type Reschedule_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Reschedule_Actions_Bool_Exp>>;
  _not?: InputMaybe<Reschedule_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Reschedule_Actions_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Reschedule_Action_Statuses_Enum_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Reschedule_Action_Types_Enum_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reschedule_actions" */
export enum Reschedule_Actions_Constraint {
  /** unique or primary key constraint on columns "id" */
  RescheduleActionsPkey = 'reschedule_actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Reschedule_Actions_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Reschedule_Actions_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Reschedule_Actions_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "reschedule_actions" */
export type Reschedule_Actions_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Reschedule_Action_Statuses_Enum>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Reschedule_Action_Types_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Reschedule_Actions_Max_Fields = {
  __typename?: 'reschedule_actions_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Reschedule_Actions_Min_Fields = {
  __typename?: 'reschedule_actions_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "reschedule_actions" */
export type Reschedule_Actions_Mutation_Response = {
  __typename?: 'reschedule_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reschedule_Actions>;
};

/** on_conflict condition type for table "reschedule_actions" */
export type Reschedule_Actions_On_Conflict = {
  constraint: Reschedule_Actions_Constraint;
  update_columns?: Array<Reschedule_Actions_Update_Column>;
  where?: InputMaybe<Reschedule_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "reschedule_actions". */
export type Reschedule_Actions_Order_By = {
  created?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reschedule_actions */
export type Reschedule_Actions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Reschedule_Actions_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "reschedule_actions" */
export enum Reschedule_Actions_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "reschedule_actions" */
export type Reschedule_Actions_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Reschedule_Action_Statuses_Enum>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Reschedule_Action_Types_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "reschedule_actions" */
export type Reschedule_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reschedule_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reschedule_Actions_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Reschedule_Action_Statuses_Enum>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Reschedule_Action_Types_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "reschedule_actions" */
export enum Reschedule_Actions_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

export type Reschedule_Actions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Reschedule_Actions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Reschedule_Actions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Reschedule_Actions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Reschedule_Actions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Reschedule_Actions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reschedule_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reschedule_Actions_Bool_Exp;
};

/** columns and relationships of "school_year" */
export type School_Year = {
  __typename?: 'school_year';
  value: Scalars['String']['output'];
};

/** aggregated selection of "school_year" */
export type School_Year_Aggregate = {
  __typename?: 'school_year_aggregate';
  aggregate?: Maybe<School_Year_Aggregate_Fields>;
  nodes: Array<School_Year>;
};

/** aggregate fields of "school_year" */
export type School_Year_Aggregate_Fields = {
  __typename?: 'school_year_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<School_Year_Max_Fields>;
  min?: Maybe<School_Year_Min_Fields>;
};


/** aggregate fields of "school_year" */
export type School_Year_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<School_Year_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "school_year". All fields are combined with a logical 'AND'. */
export type School_Year_Bool_Exp = {
  _and?: InputMaybe<Array<School_Year_Bool_Exp>>;
  _not?: InputMaybe<School_Year_Bool_Exp>;
  _or?: InputMaybe<Array<School_Year_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "school_year" */
export enum School_Year_Constraint {
  /** unique or primary key constraint on columns "value" */
  SchoolYearPkey = 'school_year_pkey'
}

export enum School_Year_Enum {
  Eighthgrade = 'EIGHTHGRADE',
  Eleventhgrade = 'ELEVENTHGRADE',
  Fifthgrade = 'FIFTHGRADE',
  Firstgrade = 'FIRSTGRADE',
  Fourthgrade = 'FOURTHGRADE',
  Kindergarten = 'KINDERGARTEN',
  Ninthgrade = 'NINTHGRADE',
  Prekindergarten = 'PREKINDERGARTEN',
  Preschool = 'PRESCHOOL',
  Secondgrade = 'SECONDGRADE',
  Seventhgrade = 'SEVENTHGRADE',
  Sixthgrade = 'SIXTHGRADE',
  Tenthgrade = 'TENTHGRADE',
  Thirdgrade = 'THIRDGRADE',
  Twelfthgrade = 'TWELFTHGRADE'
}

/** Boolean expression to compare columns of type "school_year_enum". All fields are combined with logical 'AND'. */
export type School_Year_Enum_Comparison_Exp = {
  _eq?: InputMaybe<School_Year_Enum>;
  _in?: InputMaybe<Array<School_Year_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<School_Year_Enum>;
  _nin?: InputMaybe<Array<School_Year_Enum>>;
};

/** input type for inserting data into table "school_year" */
export type School_Year_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type School_Year_Max_Fields = {
  __typename?: 'school_year_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type School_Year_Min_Fields = {
  __typename?: 'school_year_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "school_year" */
export type School_Year_Mutation_Response = {
  __typename?: 'school_year_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<School_Year>;
};

/** on_conflict condition type for table "school_year" */
export type School_Year_On_Conflict = {
  constraint: School_Year_Constraint;
  update_columns?: Array<School_Year_Update_Column>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};

/** Ordering options when selecting data from "school_year". */
export type School_Year_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: school_year */
export type School_Year_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "school_year" */
export enum School_Year_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "school_year" */
export type School_Year_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "school_year" */
export type School_Year_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: School_Year_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type School_Year_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "school_year" */
export enum School_Year_Update_Column {
  /** column name */
  Value = 'value'
}

export type School_Year_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<School_Year_Set_Input>;
  /** filter the rows which have to be updated */
  where: School_Year_Bool_Exp;
};

/** columns and relationships of "student_accounts" */
export type Student_Accounts = {
  __typename?: 'student_accounts';
  created: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  userSettings?: Maybe<User_Settings>;
};

/** aggregated selection of "student_accounts" */
export type Student_Accounts_Aggregate = {
  __typename?: 'student_accounts_aggregate';
  aggregate?: Maybe<Student_Accounts_Aggregate_Fields>;
  nodes: Array<Student_Accounts>;
};

export type Student_Accounts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Student_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Student_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_accounts" */
export type Student_Accounts_Aggregate_Fields = {
  __typename?: 'student_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Accounts_Max_Fields>;
  min?: Maybe<Student_Accounts_Min_Fields>;
};


/** aggregate fields of "student_accounts" */
export type Student_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_accounts" */
export type Student_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Accounts_Max_Order_By>;
  min?: InputMaybe<Student_Accounts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "student_accounts" */
export type Student_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Student_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_accounts". All fields are combined with a logical 'AND'. */
export type Student_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Student_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Accounts_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  settingsId?: InputMaybe<Uuid_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSettings?: InputMaybe<User_Settings_Bool_Exp>;
};

/** unique or primary key constraints on table "student_accounts" */
export enum Student_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentAccountsPkey = 'student_accounts_pkey',
  /** unique or primary key constraint on columns "student_id" */
  StudentAccountsStudentIdKey = 'student_accounts_student_id_key'
}

/** input type for inserting data into table "student_accounts" */
export type Student_Accounts_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userSettings?: InputMaybe<User_Settings_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Student_Accounts_Max_Fields = {
  __typename?: 'student_accounts_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_accounts" */
export type Student_Accounts_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Accounts_Min_Fields = {
  __typename?: 'student_accounts_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_accounts" */
export type Student_Accounts_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_accounts" */
export type Student_Accounts_Mutation_Response = {
  __typename?: 'student_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Accounts>;
};

/** input type for inserting object relation for remote table "student_accounts" */
export type Student_Accounts_Obj_Rel_Insert_Input = {
  data: Student_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "student_accounts" */
export type Student_Accounts_On_Conflict = {
  constraint: Student_Accounts_Constraint;
  update_columns?: Array<Student_Accounts_Update_Column>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "student_accounts". */
export type Student_Accounts_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userSettings?: InputMaybe<User_Settings_Order_By>;
};

/** primary key columns input for table: student_accounts */
export type Student_Accounts_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "student_accounts" */
export enum Student_Accounts_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "student_accounts" */
export type Student_Accounts_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "student_accounts" */
export type Student_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Accounts_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "student_accounts" */
export enum Student_Accounts_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Accounts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Accounts_Bool_Exp;
};

/** columns and relationships of "student_assignment_status" */
export type Student_Assignment_Status = {
  __typename?: 'student_assignment_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "student_assignment_status" */
export type Student_Assignment_Status_Aggregate = {
  __typename?: 'student_assignment_status_aggregate';
  aggregate?: Maybe<Student_Assignment_Status_Aggregate_Fields>;
  nodes: Array<Student_Assignment_Status>;
};

/** aggregate fields of "student_assignment_status" */
export type Student_Assignment_Status_Aggregate_Fields = {
  __typename?: 'student_assignment_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Assignment_Status_Max_Fields>;
  min?: Maybe<Student_Assignment_Status_Min_Fields>;
};


/** aggregate fields of "student_assignment_status" */
export type Student_Assignment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "student_assignment_status". All fields are combined with a logical 'AND'. */
export type Student_Assignment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Assignment_Status_Bool_Exp>>;
  _not?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Assignment_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_assignment_status" */
export enum Student_Assignment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  StudentAssignmentStatusPkey = 'student_assignment_status_pkey'
}

export enum Student_Assignment_Status_Enum {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

/** Boolean expression to compare columns of type "student_assignment_status_enum". All fields are combined with logical 'AND'. */
export type Student_Assignment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Student_Assignment_Status_Enum>;
  _in?: InputMaybe<Array<Student_Assignment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Student_Assignment_Status_Enum>;
  _nin?: InputMaybe<Array<Student_Assignment_Status_Enum>>;
};

/** input type for inserting data into table "student_assignment_status" */
export type Student_Assignment_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Student_Assignment_Status_Max_Fields = {
  __typename?: 'student_assignment_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Student_Assignment_Status_Min_Fields = {
  __typename?: 'student_assignment_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "student_assignment_status" */
export type Student_Assignment_Status_Mutation_Response = {
  __typename?: 'student_assignment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Assignment_Status>;
};

/** on_conflict condition type for table "student_assignment_status" */
export type Student_Assignment_Status_On_Conflict = {
  constraint: Student_Assignment_Status_Constraint;
  update_columns?: Array<Student_Assignment_Status_Update_Column>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "student_assignment_status". */
export type Student_Assignment_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_assignment_status */
export type Student_Assignment_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "student_assignment_status" */
export enum Student_Assignment_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "student_assignment_status" */
export type Student_Assignment_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "student_assignment_status" */
export type Student_Assignment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Assignment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Assignment_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "student_assignment_status" */
export enum Student_Assignment_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Student_Assignment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Assignment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Assignment_Status_Bool_Exp;
};

/** columns and relationships of "student_assignments" */
export type Student_Assignments = {
  __typename?: 'student_assignments';
  /** An object relationship */
  assignment: Assignments;
  assignmentId: Scalars['uuid']['output'];
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  completed?: Maybe<Scalars['timestamptz']['output']>;
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  created: Scalars['timestamptz']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  endDisplayOrder?: Maybe<Scalars['Int']['output']>;
  freeForm: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  status: Student_Assignment_Status_Enum;
  /** An object relationship */
  student: Students;
  /** An object relationship */
  studentCourse: Student_Courses;
  studentCourseId: Scalars['uuid']['output'];
  studentId: Scalars['String']['output'];
  /** An array relationship */
  submissions: Array<Files>;
  /** An aggregate relationship */
  submissions_aggregate: Files_Aggregate;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsSubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsSubmissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "student_assignments" */
export type Student_Assignments_Aggregate = {
  __typename?: 'student_assignments_aggregate';
  aggregate?: Maybe<Student_Assignments_Aggregate_Fields>;
  nodes: Array<Student_Assignments>;
};

export type Student_Assignments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp_Count>;
};

export type Student_Assignments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Student_Assignments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Student_Assignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Assignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_assignments" */
export type Student_Assignments_Aggregate_Fields = {
  __typename?: 'student_assignments_aggregate_fields';
  avg?: Maybe<Student_Assignments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Assignments_Max_Fields>;
  min?: Maybe<Student_Assignments_Min_Fields>;
  stddev?: Maybe<Student_Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Student_Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Student_Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Student_Assignments_Sum_Fields>;
  var_pop?: Maybe<Student_Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Student_Assignments_Var_Samp_Fields>;
  variance?: Maybe<Student_Assignments_Variance_Fields>;
};


/** aggregate fields of "student_assignments" */
export type Student_Assignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_assignments" */
export type Student_Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Student_Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Assignments_Max_Order_By>;
  min?: InputMaybe<Student_Assignments_Min_Order_By>;
  stddev?: InputMaybe<Student_Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Student_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Student_Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Student_Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Student_Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Student_Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Student_Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "student_assignments" */
export type Student_Assignments_Arr_Rel_Insert_Input = {
  data: Array<Student_Assignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Student_Assignments_Avg_Fields = {
  __typename?: 'student_assignments_avg_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "student_assignments" */
export type Student_Assignments_Avg_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "student_assignments". All fields are combined with a logical 'AND'. */
export type Student_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Student_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Assignments_Bool_Exp>>;
  assignment?: InputMaybe<Assignments_Bool_Exp>;
  assignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Bool_Exp>;
  completed?: InputMaybe<Timestamptz_Comparison_Exp>;
  courseDayOffset?: InputMaybe<Int_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayOrder?: InputMaybe<Int_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  endDisplayOrder?: InputMaybe<Int_Comparison_Exp>;
  freeForm?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pointsAvailable?: InputMaybe<Numeric_Comparison_Exp>;
  pointsEarned?: InputMaybe<Numeric_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Student_Assignment_Status_Enum_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentCourse?: InputMaybe<Student_Courses_Bool_Exp>;
  studentCourseId?: InputMaybe<Uuid_Comparison_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  submissions?: InputMaybe<Files_Bool_Exp>;
  submissions_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_assignments" */
export enum Student_Assignments_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentAssignmentsPkey = 'student_assignments_pkey'
}

/** input type for incrementing numeric columns in table "student_assignments" */
export type Student_Assignments_Inc_Input = {
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  endDisplayOrder?: InputMaybe<Scalars['Int']['input']>;
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "student_assignments" */
export type Student_Assignments_Insert_Input = {
  assignment?: InputMaybe<Assignments_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  endDisplayOrder?: InputMaybe<Scalars['Int']['input']>;
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Assignment_Status_Enum>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentCourse?: InputMaybe<Student_Courses_Obj_Rel_Insert_Input>;
  studentCourseId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Student_Assignments_Max_Fields = {
  __typename?: 'student_assignments_max_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  completed?: Maybe<Scalars['timestamptz']['output']>;
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  endDisplayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentCourseId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_assignments" */
export type Student_Assignments_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  courseDayOffset?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentCourseId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Assignments_Min_Fields = {
  __typename?: 'student_assignments_min_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  completed?: Maybe<Scalars['timestamptz']['output']>;
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  endDisplayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentCourseId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_assignments" */
export type Student_Assignments_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  courseDayOffset?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentCourseId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_assignments" */
export type Student_Assignments_Mutation_Response = {
  __typename?: 'student_assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Assignments>;
};

/** input type for inserting object relation for remote table "student_assignments" */
export type Student_Assignments_Obj_Rel_Insert_Input = {
  data: Student_Assignments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};

/** on_conflict condition type for table "student_assignments" */
export type Student_Assignments_On_Conflict = {
  constraint: Student_Assignments_Constraint;
  update_columns?: Array<Student_Assignments_Update_Column>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "student_assignments". */
export type Student_Assignments_Order_By = {
  assignment?: InputMaybe<Assignments_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  completed?: InputMaybe<Order_By>;
  courseDayOffset?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  freeForm?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentCourse?: InputMaybe<Student_Courses_Order_By>;
  studentCourseId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  submissions_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_assignments */
export type Student_Assignments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "student_assignments" */
export enum Student_Assignments_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseDayOffset = 'courseDayOffset',
  /** column name */
  Created = 'created',
  /** column name */
  DisplayOrder = 'displayOrder',
  /** column name */
  End = 'end',
  /** column name */
  EndDisplayOrder = 'endDisplayOrder',
  /** column name */
  FreeForm = 'freeForm',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PointsAvailable = 'pointsAvailable',
  /** column name */
  PointsEarned = 'pointsEarned',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentCourseId = 'studentCourseId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** select "student_assignments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "student_assignments" */
export enum Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FreeForm = 'freeForm'
}

/** select "student_assignments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "student_assignments" */
export enum Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FreeForm = 'freeForm'
}

/** input type for updating data in table "student_assignments" */
export type Student_Assignments_Set_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  endDisplayOrder?: InputMaybe<Scalars['Int']['input']>;
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Assignment_Status_Enum>;
  studentCourseId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Student_Assignments_Stddev_Fields = {
  __typename?: 'student_assignments_stddev_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "student_assignments" */
export type Student_Assignments_Stddev_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Student_Assignments_Stddev_Pop_Fields = {
  __typename?: 'student_assignments_stddev_pop_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "student_assignments" */
export type Student_Assignments_Stddev_Pop_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Student_Assignments_Stddev_Samp_Fields = {
  __typename?: 'student_assignments_stddev_samp_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "student_assignments" */
export type Student_Assignments_Stddev_Samp_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "student_assignments" */
export type Student_Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Assignments_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  endDisplayOrder?: InputMaybe<Scalars['Int']['input']>;
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Assignment_Status_Enum>;
  studentCourseId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Student_Assignments_Sum_Fields = {
  __typename?: 'student_assignments_sum_fields';
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  endDisplayOrder?: Maybe<Scalars['Int']['output']>;
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "student_assignments" */
export type Student_Assignments_Sum_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** update columns of table "student_assignments" */
export enum Student_Assignments_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseDayOffset = 'courseDayOffset',
  /** column name */
  Created = 'created',
  /** column name */
  DisplayOrder = 'displayOrder',
  /** column name */
  End = 'end',
  /** column name */
  EndDisplayOrder = 'endDisplayOrder',
  /** column name */
  FreeForm = 'freeForm',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PointsAvailable = 'pointsAvailable',
  /** column name */
  PointsEarned = 'pointsEarned',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentCourseId = 'studentCourseId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Assignments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Student_Assignments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Assignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Assignments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Student_Assignments_Var_Pop_Fields = {
  __typename?: 'student_assignments_var_pop_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "student_assignments" */
export type Student_Assignments_Var_Pop_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Student_Assignments_Var_Samp_Fields = {
  __typename?: 'student_assignments_var_samp_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "student_assignments" */
export type Student_Assignments_Var_Samp_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Student_Assignments_Variance_Fields = {
  __typename?: 'student_assignments_variance_fields';
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  endDisplayOrder?: Maybe<Scalars['Float']['output']>;
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "student_assignments" */
export type Student_Assignments_Variance_Order_By = {
  courseDayOffset?: InputMaybe<Order_By>;
  displayOrder?: InputMaybe<Order_By>;
  endDisplayOrder?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
};

/** columns and relationships of "student_course_status" */
export type Student_Course_Status = {
  __typename?: 'student_course_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "student_course_status" */
export type Student_Course_Status_Aggregate = {
  __typename?: 'student_course_status_aggregate';
  aggregate?: Maybe<Student_Course_Status_Aggregate_Fields>;
  nodes: Array<Student_Course_Status>;
};

/** aggregate fields of "student_course_status" */
export type Student_Course_Status_Aggregate_Fields = {
  __typename?: 'student_course_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Course_Status_Max_Fields>;
  min?: Maybe<Student_Course_Status_Min_Fields>;
};


/** aggregate fields of "student_course_status" */
export type Student_Course_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "student_course_status". All fields are combined with a logical 'AND'. */
export type Student_Course_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Course_Status_Bool_Exp>>;
  _not?: InputMaybe<Student_Course_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Course_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_course_status" */
export enum Student_Course_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  StudentCourseStatusPkey = 'student_course_status_pkey'
}

export enum Student_Course_Status_Enum {
  Completed = 'COMPLETED',
  Dropped = 'DROPPED',
  Enrolled = 'ENROLLED'
}

/** Boolean expression to compare columns of type "student_course_status_enum". All fields are combined with logical 'AND'. */
export type Student_Course_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Student_Course_Status_Enum>;
  _in?: InputMaybe<Array<Student_Course_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Student_Course_Status_Enum>;
  _nin?: InputMaybe<Array<Student_Course_Status_Enum>>;
};

/** input type for inserting data into table "student_course_status" */
export type Student_Course_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Student_Course_Status_Max_Fields = {
  __typename?: 'student_course_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Student_Course_Status_Min_Fields = {
  __typename?: 'student_course_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "student_course_status" */
export type Student_Course_Status_Mutation_Response = {
  __typename?: 'student_course_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Course_Status>;
};

/** on_conflict condition type for table "student_course_status" */
export type Student_Course_Status_On_Conflict = {
  constraint: Student_Course_Status_Constraint;
  update_columns?: Array<Student_Course_Status_Update_Column>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "student_course_status". */
export type Student_Course_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_course_status */
export type Student_Course_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "student_course_status" */
export enum Student_Course_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "student_course_status" */
export type Student_Course_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "student_course_status" */
export type Student_Course_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Course_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Course_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "student_course_status" */
export enum Student_Course_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Student_Course_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Course_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Course_Status_Bool_Exp;
};

/** columns and relationships of "student_courses" */
export type Student_Courses = {
  __typename?: 'student_courses';
  calendarYear?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  course?: Maybe<Courses>;
  courseDayOffsets?: Maybe<Scalars['jsonb']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  courseSnapshot?: Maybe<Scalars['jsonb']['output']>;
  created: Scalars['timestamptz']['output'];
  dailySortOrder: Scalars['jsonb']['output'];
  daysOfTheWeek: Scalars['jsonb']['output'];
  end: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  schoolYear?: Maybe<School_Year_Enum>;
  start: Scalars['date']['output'];
  status: Student_Course_Status_Enum;
  /** An object relationship */
  student: Students;
  /** An array relationship */
  studentAssignments: Array<Student_Assignments>;
  /** An aggregate relationship */
  studentAssignments_aggregate: Student_Assignments_Aggregate;
  studentId: Scalars['String']['output'];
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesCourseDayOffsetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesCourseSnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesDailySortOrderArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesDaysOfTheWeekArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesStudentAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesStudentAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};

/** aggregated selection of "student_courses" */
export type Student_Courses_Aggregate = {
  __typename?: 'student_courses_aggregate';
  aggregate?: Maybe<Student_Courses_Aggregate_Fields>;
  nodes: Array<Student_Courses>;
};

export type Student_Courses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Student_Courses_Aggregate_Bool_Exp_Count>;
};

export type Student_Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_courses" */
export type Student_Courses_Aggregate_Fields = {
  __typename?: 'student_courses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Courses_Max_Fields>;
  min?: Maybe<Student_Courses_Min_Fields>;
};


/** aggregate fields of "student_courses" */
export type Student_Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_courses" */
export type Student_Courses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Courses_Max_Order_By>;
  min?: InputMaybe<Student_Courses_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Student_Courses_Append_Input = {
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "student_courses" */
export type Student_Courses_Arr_Rel_Insert_Input = {
  data: Array<Student_Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_courses". All fields are combined with a logical 'AND'. */
export type Student_Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Courses_Bool_Exp>>;
  _not?: InputMaybe<Student_Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Courses_Bool_Exp>>;
  calendarYear?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseDayOffsets?: InputMaybe<Jsonb_Comparison_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  courseSnapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  dailySortOrder?: InputMaybe<Jsonb_Comparison_Exp>;
  daysOfTheWeek?: InputMaybe<Jsonb_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  schoolYear?: InputMaybe<School_Year_Enum_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Student_Course_Status_Enum_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentAssignments?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_courses" */
export enum Student_Courses_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentCoursesPkey = 'student_courses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Student_Courses_Delete_At_Path_Input = {
  courseDayOffsets?: InputMaybe<Array<Scalars['String']['input']>>;
  courseSnapshot?: InputMaybe<Array<Scalars['String']['input']>>;
  dailySortOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  daysOfTheWeek?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Student_Courses_Delete_Elem_Input = {
  courseDayOffsets?: InputMaybe<Scalars['Int']['input']>;
  courseSnapshot?: InputMaybe<Scalars['Int']['input']>;
  dailySortOrder?: InputMaybe<Scalars['Int']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Student_Courses_Delete_Key_Input = {
  courseDayOffsets?: InputMaybe<Scalars['String']['input']>;
  courseSnapshot?: InputMaybe<Scalars['String']['input']>;
  dailySortOrder?: InputMaybe<Scalars['String']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "student_courses" */
export type Student_Courses_Insert_Input = {
  calendarYear?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Course_Status_Enum>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentAssignments?: InputMaybe<Student_Assignments_Arr_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Student_Courses_Max_Fields = {
  __typename?: 'student_courses_max_fields';
  calendarYear?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_courses" */
export type Student_Courses_Max_Order_By = {
  calendarYear?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Courses_Min_Fields = {
  __typename?: 'student_courses_min_fields';
  calendarYear?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_courses" */
export type Student_Courses_Min_Order_By = {
  calendarYear?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_courses" */
export type Student_Courses_Mutation_Response = {
  __typename?: 'student_courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Courses>;
};

/** input type for inserting object relation for remote table "student_courses" */
export type Student_Courses_Obj_Rel_Insert_Input = {
  data: Student_Courses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};

/** on_conflict condition type for table "student_courses" */
export type Student_Courses_On_Conflict = {
  constraint: Student_Courses_Constraint;
  update_columns?: Array<Student_Courses_Update_Column>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "student_courses". */
export type Student_Courses_Order_By = {
  calendarYear?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseDayOffsets?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseSnapshot?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  dailySortOrder?: InputMaybe<Order_By>;
  daysOfTheWeek?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  schoolYear?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_courses */
export type Student_Courses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Student_Courses_Prepend_Input = {
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "student_courses" */
export enum Student_Courses_Select_Column {
  /** column name */
  CalendarYear = 'calendarYear',
  /** column name */
  CourseDayOffsets = 'courseDayOffsets',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseSnapshot = 'courseSnapshot',
  /** column name */
  Created = 'created',
  /** column name */
  DailySortOrder = 'dailySortOrder',
  /** column name */
  DaysOfTheWeek = 'daysOfTheWeek',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "student_courses" */
export type Student_Courses_Set_Input = {
  calendarYear?: InputMaybe<Scalars['String']['input']>;
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Course_Status_Enum>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "student_courses" */
export type Student_Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Courses_Stream_Cursor_Value_Input = {
  calendarYear?: InputMaybe<Scalars['String']['input']>;
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Course_Status_Enum>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "student_courses" */
export enum Student_Courses_Update_Column {
  /** column name */
  CalendarYear = 'calendarYear',
  /** column name */
  CourseDayOffsets = 'courseDayOffsets',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseSnapshot = 'courseSnapshot',
  /** column name */
  Created = 'created',
  /** column name */
  DailySortOrder = 'dailySortOrder',
  /** column name */
  DaysOfTheWeek = 'daysOfTheWeek',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Courses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Student_Courses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Student_Courses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Student_Courses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Student_Courses_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Student_Courses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Courses_Bool_Exp;
};

/** columns and relationships of "student_events" */
export type Student_Events = {
  __typename?: 'student_events';
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "student_events" */
export type Student_Events_Aggregate = {
  __typename?: 'student_events_aggregate';
  aggregate?: Maybe<Student_Events_Aggregate_Fields>;
  nodes: Array<Student_Events>;
};

export type Student_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Student_Events_Aggregate_Bool_Exp_Count>;
};

export type Student_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_events" */
export type Student_Events_Aggregate_Fields = {
  __typename?: 'student_events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Events_Max_Fields>;
  min?: Maybe<Student_Events_Min_Fields>;
};


/** aggregate fields of "student_events" */
export type Student_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_events" */
export type Student_Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Events_Max_Order_By>;
  min?: InputMaybe<Student_Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "student_events" */
export type Student_Events_Arr_Rel_Insert_Input = {
  data: Array<Student_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_events". All fields are combined with a logical 'AND'. */
export type Student_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Events_Bool_Exp>>;
  _not?: InputMaybe<Student_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Events_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_events" */
export enum Student_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentEventsPkey = 'student_events_pkey'
}

/** input type for inserting data into table "student_events" */
export type Student_Events_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Student_Events_Max_Fields = {
  __typename?: 'student_events_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_events" */
export type Student_Events_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Events_Min_Fields = {
  __typename?: 'student_events_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_events" */
export type Student_Events_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_events" */
export type Student_Events_Mutation_Response = {
  __typename?: 'student_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Events>;
};

/** on_conflict condition type for table "student_events" */
export type Student_Events_On_Conflict = {
  constraint: Student_Events_Constraint;
  update_columns?: Array<Student_Events_Update_Column>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "student_events". */
export type Student_Events_Order_By = {
  created?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_events */
export type Student_Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "student_events" */
export enum Student_Events_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "student_events" */
export type Student_Events_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "student_events" */
export type Student_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Events_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "student_events" */
export enum Student_Events_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Events_Bool_Exp;
};

/** columns and relationships of "students" */
export type Students = {
  __typename?: 'students';
  created: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  schoolYear?: Maybe<School_Year_Enum>;
  /** An object relationship */
  studentAccount?: Maybe<Student_Accounts>;
  /** An array relationship */
  studentAssignments: Array<Student_Assignments>;
  /** An aggregate relationship */
  studentAssignments_aggregate: Student_Assignments_Aggregate;
  /** An array relationship */
  studentCourses: Array<Student_Courses>;
  /** An aggregate relationship */
  studentCourses_aggregate: Student_Courses_Aggregate;
  /** An array relationship */
  studentEvents: Array<Student_Events>;
  /** An aggregate relationship */
  studentEvents_aggregate: Student_Events_Aggregate;
  /** An array relationship */
  teachers: Array<Teachers_Students>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Students_Aggregate;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "students" */
export type StudentsStudentAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentCoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentEventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};

/** aggregated selection of "students" */
export type Students_Aggregate = {
  __typename?: 'students_aggregate';
  aggregate?: Maybe<Students_Aggregate_Fields>;
  nodes: Array<Students>;
};

/** aggregate fields of "students" */
export type Students_Aggregate_Fields = {
  __typename?: 'students_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Students_Max_Fields>;
  min?: Maybe<Students_Min_Fields>;
};


/** aggregate fields of "students" */
export type Students_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Students_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export type Students_Bool_Exp = {
  _and?: InputMaybe<Array<Students_Bool_Exp>>;
  _not?: InputMaybe<Students_Bool_Exp>;
  _or?: InputMaybe<Array<Students_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  schoolYear?: InputMaybe<School_Year_Enum_Comparison_Exp>;
  studentAccount?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAssignments?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp>;
  studentCourses?: InputMaybe<Student_Courses_Bool_Exp>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Bool_Exp>;
  studentEvents?: InputMaybe<Student_Events_Bool_Exp>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Bool_Exp>;
  teachers?: InputMaybe<Teachers_Students_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Teachers_Students_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "students" */
export enum Students_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentsPkey = 'students_pkey'
}

/** input type for inserting data into table "students" */
export type Students_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  studentAccount?: InputMaybe<Student_Accounts_Obj_Rel_Insert_Input>;
  studentAssignments?: InputMaybe<Student_Assignments_Arr_Rel_Insert_Input>;
  studentCourses?: InputMaybe<Student_Courses_Arr_Rel_Insert_Input>;
  studentEvents?: InputMaybe<Student_Events_Arr_Rel_Insert_Input>;
  teachers?: InputMaybe<Teachers_Students_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Students_Max_Fields = {
  __typename?: 'students_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Students_Min_Fields = {
  __typename?: 'students_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "students" */
export type Students_Mutation_Response = {
  __typename?: 'students_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Students>;
};

/** input type for inserting object relation for remote table "students" */
export type Students_Obj_Rel_Insert_Input = {
  data: Students_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Students_On_Conflict>;
};

/** on_conflict condition type for table "students" */
export type Students_On_Conflict = {
  constraint: Students_Constraint;
  update_columns?: Array<Students_Update_Column>;
  where?: InputMaybe<Students_Bool_Exp>;
};

/** Ordering options when selecting data from "students". */
export type Students_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  schoolYear?: InputMaybe<Order_By>;
  studentAccount?: InputMaybe<Student_Accounts_Order_By>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Order_By>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Order_By>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Order_By>;
  teachers_aggregate?: InputMaybe<Teachers_Students_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: students */
export type Students_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "students" */
export enum Students_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "students" */
export type Students_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "students" */
export type Students_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Students_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Students_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "students" */
export enum Students_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Updated = 'updated'
}

export type Students_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Students_Set_Input>;
  /** filter the rows which have to be updated */
  where: Students_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "assignments" using primary key columns */
  assignment?: Maybe<Assignments>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: Array<Assignment_Type>;
  /** fetch aggregated fields from the table: "assignment_type" */
  assignment_type_aggregate: Assignment_Type_Aggregate;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** fetch data from the table in a streaming manner: "assignment_type" */
  assignment_type_stream: Array<Assignment_Type>;
  /** fetch data from the table: "assignment_type_weights" using primary key columns */
  assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** fetch data from the table: "assignment_type_weights" */
  assignment_type_weights: Array<Assignment_Type_Weights>;
  /** fetch aggregated fields from the table: "assignment_type_weights" */
  assignment_type_weights_aggregate: Assignment_Type_Weights_Aggregate;
  /** fetch data from the table in a streaming manner: "assignment_type_weights" */
  assignment_type_weights_stream: Array<Assignment_Type_Weights>;
  /** An array relationship */
  assignments: Array<Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Assignments_Aggregate;
  /** fetch data from the table in a streaming manner: "assignments" */
  assignments_stream: Array<Assignments>;
  /** fetch data from the table: "comments" using primary key columns */
  comment?: Maybe<Comments>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table in a streaming manner: "comments" */
  comments_stream: Array<Comments>;
  /** fetch data from the table: "courses" using primary key columns */
  course?: Maybe<Courses>;
  /** fetch data from the table: "course_share_links" using primary key columns */
  course_share_link?: Maybe<Course_Share_Links>;
  /** fetch data from the table: "course_share_links" */
  course_share_links: Array<Course_Share_Links>;
  /** fetch aggregated fields from the table: "course_share_links" */
  course_share_links_aggregate: Course_Share_Links_Aggregate;
  /** fetch data from the table in a streaming manner: "course_share_links" */
  course_share_links_stream: Array<Course_Share_Links>;
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  /** fetch data from the table in a streaming manner: "courses" */
  courses_stream: Array<Courses>;
  /** fetch data from the table: "custom_assignment_types" using primary key columns */
  custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** fetch data from the table: "custom_assignment_types" */
  custom_assignment_types: Array<Custom_Assignment_Types>;
  /** fetch aggregated fields from the table: "custom_assignment_types" */
  custom_assignment_types_aggregate: Custom_Assignment_Types_Aggregate;
  /** fetch data from the table in a streaming manner: "custom_assignment_types" */
  custom_assignment_types_stream: Array<Custom_Assignment_Types>;
  /** fetch data from the table: "customers" using primary key columns */
  customer?: Maybe<Customers>;
  /** fetch data from the table: "customers" */
  customers: Array<Customers>;
  /** fetch aggregated fields from the table: "customers" */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table in a streaming manner: "customers" */
  customers_stream: Array<Customers>;
  /** fetch data from the table: "events" using primary key columns */
  event?: Maybe<Events>;
  /** fetch data from the table: "event_ignored_courses" */
  event_ignored_courses: Array<Event_Ignored_Courses>;
  /** fetch aggregated fields from the table: "event_ignored_courses" */
  event_ignored_courses_aggregate: Event_Ignored_Courses_Aggregate;
  /** fetch data from the table: "event_ignored_courses" using primary key columns */
  event_ignored_courses_by_pk?: Maybe<Event_Ignored_Courses>;
  /** fetch data from the table in a streaming manner: "event_ignored_courses" */
  event_ignored_courses_stream: Array<Event_Ignored_Courses>;
  /** fetch data from the table: "event_t" */
  event_t: Array<Event_T>;
  /** fetch aggregated fields from the table: "event_t" */
  event_t_aggregate: Event_T_Aggregate;
  /** fetch data from the table in a streaming manner: "event_t" */
  event_t_stream: Array<Event_T>;
  /** fetch data from the table: "event_t" using primary key columns */
  event_type?: Maybe<Event_T>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** fetch data from the table: "files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "grading_style" */
  grading_style: Array<Grading_Style>;
  /** fetch aggregated fields from the table: "grading_style" */
  grading_style_aggregate: Grading_Style_Aggregate;
  /** fetch data from the table: "grading_style" using primary key columns */
  grading_style_by_pk?: Maybe<Grading_Style>;
  /** fetch data from the table in a streaming manner: "grading_style" */
  grading_style_stream: Array<Grading_Style>;
  /** fetch data from the table: "organizations" using primary key columns */
  organization?: Maybe<Organizations>;
  /** fetch data from the table: "organization_admins" using primary key columns */
  organization_admin?: Maybe<Organization_Admins>;
  /** fetch data from the table: "organization_admins" */
  organization_admins: Array<Organization_Admins>;
  /** fetch aggregated fields from the table: "organization_admins" */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_admins" */
  organization_admins_stream: Array<Organization_Admins>;
  /** fetch data from the table: "organization_codes" using primary key columns */
  organization_code?: Maybe<Organization_Codes>;
  /** fetch data from the table: "organization_codes" */
  organization_codes: Array<Organization_Codes>;
  /** fetch aggregated fields from the table: "organization_codes" */
  organization_codes_aggregate: Organization_Codes_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_codes" */
  organization_codes_stream: Array<Organization_Codes>;
  /** fetch data from the table: "organization_course_groups" using primary key columns */
  organization_course_group?: Maybe<Organization_Course_Groups>;
  /** fetch data from the table: "organization_course_groups" */
  organization_course_groups: Array<Organization_Course_Groups>;
  /** fetch aggregated fields from the table: "organization_course_groups" */
  organization_course_groups_aggregate: Organization_Course_Groups_Aggregate;
  /** fetch data from the table: "organization_course_groups_courses" */
  organization_course_groups_courses: Array<Organization_Course_Groups_Courses>;
  /** fetch aggregated fields from the table: "organization_course_groups_courses" */
  organization_course_groups_courses_aggregate: Organization_Course_Groups_Courses_Aggregate;
  /** fetch data from the table: "organization_course_groups_courses" using primary key columns */
  organization_course_groups_courses_by_pk?: Maybe<Organization_Course_Groups_Courses>;
  /** fetch data from the table in a streaming manner: "organization_course_groups_courses" */
  organization_course_groups_courses_stream: Array<Organization_Course_Groups_Courses>;
  /** fetch data from the table: "organization_course_groups_organization_codes" */
  organization_course_groups_organization_codes: Array<Organization_Course_Groups_Organization_Codes>;
  /** fetch aggregated fields from the table: "organization_course_groups_organization_codes" */
  organization_course_groups_organization_codes_aggregate: Organization_Course_Groups_Organization_Codes_Aggregate;
  /** fetch data from the table: "organization_course_groups_organization_codes" using primary key columns */
  organization_course_groups_organization_codes_by_pk?: Maybe<Organization_Course_Groups_Organization_Codes>;
  /** fetch data from the table in a streaming manner: "organization_course_groups_organization_codes" */
  organization_course_groups_organization_codes_stream: Array<Organization_Course_Groups_Organization_Codes>;
  /** fetch data from the table in a streaming manner: "organization_course_groups" */
  organization_course_groups_stream: Array<Organization_Course_Groups>;
  /** fetch data from the table: "organization_course_groups_teachers" */
  organization_course_groups_teachers: Array<Organization_Course_Groups_Teachers>;
  /** fetch aggregated fields from the table: "organization_course_groups_teachers" */
  organization_course_groups_teachers_aggregate: Organization_Course_Groups_Teachers_Aggregate;
  /** fetch data from the table: "organization_course_groups_teachers" using primary key columns */
  organization_course_groups_teachers_by_pk?: Maybe<Organization_Course_Groups_Teachers>;
  /** fetch data from the table in a streaming manner: "organization_course_groups_teachers" */
  organization_course_groups_teachers_stream: Array<Organization_Course_Groups_Teachers>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** fetch data from the table: "parrot_requests" using primary key columns */
  parrot_request?: Maybe<Parrot_Requests>;
  /** fetch data from the table: "parrot_request_status" */
  parrot_request_status: Array<Parrot_Request_Status>;
  /** fetch aggregated fields from the table: "parrot_request_status" */
  parrot_request_status_aggregate: Parrot_Request_Status_Aggregate;
  /** fetch data from the table: "parrot_request_status" using primary key columns */
  parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** fetch data from the table in a streaming manner: "parrot_request_status" */
  parrot_request_status_stream: Array<Parrot_Request_Status>;
  /** fetch data from the table: "parrot_requests" */
  parrot_requests: Array<Parrot_Requests>;
  /** fetch aggregated fields from the table: "parrot_requests" */
  parrot_requests_aggregate: Parrot_Requests_Aggregate;
  /** fetch data from the table in a streaming manner: "parrot_requests" */
  parrot_requests_stream: Array<Parrot_Requests>;
  /** fetch data from the table: "plan_tier" */
  plan_tier: Array<Plan_Tier>;
  /** fetch aggregated fields from the table: "plan_tier" */
  plan_tier_aggregate: Plan_Tier_Aggregate;
  /** fetch data from the table: "plan_tier" using primary key columns */
  plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** fetch data from the table in a streaming manner: "plan_tier" */
  plan_tier_stream: Array<Plan_Tier>;
  /** fetch data from the table: "printing_jobs" using primary key columns */
  printing_job?: Maybe<Printing_Jobs>;
  /** fetch data from the table: "printing_job_status" */
  printing_job_status: Array<Printing_Job_Status>;
  /** fetch aggregated fields from the table: "printing_job_status" */
  printing_job_status_aggregate: Printing_Job_Status_Aggregate;
  /** fetch data from the table: "printing_job_status" using primary key columns */
  printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** fetch data from the table in a streaming manner: "printing_job_status" */
  printing_job_status_stream: Array<Printing_Job_Status>;
  /** fetch data from the table: "printing_job_type" */
  printing_job_type: Array<Printing_Job_Type>;
  /** fetch aggregated fields from the table: "printing_job_type" */
  printing_job_type_aggregate: Printing_Job_Type_Aggregate;
  /** fetch data from the table: "printing_job_type" using primary key columns */
  printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** fetch data from the table in a streaming manner: "printing_job_type" */
  printing_job_type_stream: Array<Printing_Job_Type>;
  /** fetch data from the table: "printing_jobs" */
  printing_jobs: Array<Printing_Jobs>;
  /** fetch aggregated fields from the table: "printing_jobs" */
  printing_jobs_aggregate: Printing_Jobs_Aggregate;
  /** fetch data from the table in a streaming manner: "printing_jobs" */
  printing_jobs_stream: Array<Printing_Jobs>;
  /** fetch data from the table: "reschedule_actions" using primary key columns */
  reschedule_action?: Maybe<Reschedule_Actions>;
  /** fetch data from the table: "reschedule_action_statuses" */
  reschedule_action_statuses: Array<Reschedule_Action_Statuses>;
  /** fetch aggregated fields from the table: "reschedule_action_statuses" */
  reschedule_action_statuses_aggregate: Reschedule_Action_Statuses_Aggregate;
  /** fetch data from the table: "reschedule_action_statuses" using primary key columns */
  reschedule_action_statuses_by_pk?: Maybe<Reschedule_Action_Statuses>;
  /** fetch data from the table in a streaming manner: "reschedule_action_statuses" */
  reschedule_action_statuses_stream: Array<Reschedule_Action_Statuses>;
  /** fetch data from the table: "reschedule_action_types" */
  reschedule_action_types: Array<Reschedule_Action_Types>;
  /** fetch aggregated fields from the table: "reschedule_action_types" */
  reschedule_action_types_aggregate: Reschedule_Action_Types_Aggregate;
  /** fetch data from the table: "reschedule_action_types" using primary key columns */
  reschedule_action_types_by_pk?: Maybe<Reschedule_Action_Types>;
  /** fetch data from the table in a streaming manner: "reschedule_action_types" */
  reschedule_action_types_stream: Array<Reschedule_Action_Types>;
  /** fetch data from the table: "reschedule_actions" */
  reschedule_actions: Array<Reschedule_Actions>;
  /** fetch aggregated fields from the table: "reschedule_actions" */
  reschedule_actions_aggregate: Reschedule_Actions_Aggregate;
  /** fetch data from the table in a streaming manner: "reschedule_actions" */
  reschedule_actions_stream: Array<Reschedule_Actions>;
  /** fetch data from the table: "school_year" */
  school_year: Array<School_Year>;
  /** fetch aggregated fields from the table: "school_year" */
  school_year_aggregate: School_Year_Aggregate;
  /** fetch data from the table: "school_year" using primary key columns */
  school_year_by_pk?: Maybe<School_Year>;
  /** fetch data from the table in a streaming manner: "school_year" */
  school_year_stream: Array<School_Year>;
  /** fetch data from the table: "students" using primary key columns */
  student?: Maybe<Students>;
  /** fetch data from the table: "student_accounts" using primary key columns */
  student_account?: Maybe<Student_Accounts>;
  /** fetch data from the table: "student_accounts" */
  student_accounts: Array<Student_Accounts>;
  /** fetch aggregated fields from the table: "student_accounts" */
  student_accounts_aggregate: Student_Accounts_Aggregate;
  /** fetch data from the table in a streaming manner: "student_accounts" */
  student_accounts_stream: Array<Student_Accounts>;
  /** fetch data from the table: "student_assignments" using primary key columns */
  student_assignment?: Maybe<Student_Assignments>;
  /** fetch data from the table: "student_assignment_status" */
  student_assignment_status: Array<Student_Assignment_Status>;
  /** fetch aggregated fields from the table: "student_assignment_status" */
  student_assignment_status_aggregate: Student_Assignment_Status_Aggregate;
  /** fetch data from the table: "student_assignment_status" using primary key columns */
  student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** fetch data from the table in a streaming manner: "student_assignment_status" */
  student_assignment_status_stream: Array<Student_Assignment_Status>;
  /** fetch data from the table: "student_assignments" */
  student_assignments: Array<Student_Assignments>;
  /** fetch aggregated fields from the table: "student_assignments" */
  student_assignments_aggregate: Student_Assignments_Aggregate;
  /** fetch data from the table in a streaming manner: "student_assignments" */
  student_assignments_stream: Array<Student_Assignments>;
  /** fetch data from the table: "student_courses" using primary key columns */
  student_course?: Maybe<Student_Courses>;
  /** fetch data from the table: "student_course_status" */
  student_course_status: Array<Student_Course_Status>;
  /** fetch aggregated fields from the table: "student_course_status" */
  student_course_status_aggregate: Student_Course_Status_Aggregate;
  /** fetch data from the table: "student_course_status" using primary key columns */
  student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** fetch data from the table in a streaming manner: "student_course_status" */
  student_course_status_stream: Array<Student_Course_Status>;
  /** fetch data from the table: "student_courses" */
  student_courses: Array<Student_Courses>;
  /** fetch aggregated fields from the table: "student_courses" */
  student_courses_aggregate: Student_Courses_Aggregate;
  /** fetch data from the table in a streaming manner: "student_courses" */
  student_courses_stream: Array<Student_Courses>;
  /** fetch data from the table: "student_events" using primary key columns */
  student_event?: Maybe<Student_Events>;
  /** fetch data from the table: "student_events" */
  student_events: Array<Student_Events>;
  /** fetch aggregated fields from the table: "student_events" */
  student_events_aggregate: Student_Events_Aggregate;
  /** fetch data from the table in a streaming manner: "student_events" */
  student_events_stream: Array<Student_Events>;
  /** fetch data from the table: "students" */
  students: Array<Students>;
  /** fetch aggregated fields from the table: "students" */
  students_aggregate: Students_Aggregate;
  /** fetch data from the table in a streaming manner: "students" */
  students_stream: Array<Students>;
  /** fetch data from the table: "teachers" using primary key columns */
  teacher?: Maybe<Teachers>;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  /** fetch data from the table in a streaming manner: "teachers" */
  teachers_stream: Array<Teachers>;
  /** fetch data from the table: "teachers_students" */
  teachers_students: Array<Teachers_Students>;
  /** fetch aggregated fields from the table: "teachers_students" */
  teachers_students_aggregate: Teachers_Students_Aggregate;
  /** fetch data from the table: "teachers_students" using primary key columns */
  teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** fetch data from the table in a streaming manner: "teachers_students" */
  teachers_students_stream: Array<Teachers_Students>;
  /** An array relationship */
  themes: Array<Themes>;
  /** An aggregate relationship */
  themes_aggregate: Themes_Aggregate;
  /** fetch data from the table: "themes" using primary key columns */
  themes_by_pk?: Maybe<Themes>;
  /** fetch data from the table in a streaming manner: "themes" */
  themes_stream: Array<Themes>;
  /** fetch data from the table: "transcript_drafts" using primary key columns */
  transcript_draft?: Maybe<Transcript_Drafts>;
  /** fetch data from the table: "transcript_drafts" */
  transcript_drafts: Array<Transcript_Drafts>;
  /** fetch aggregated fields from the table: "transcript_drafts" */
  transcript_drafts_aggregate: Transcript_Drafts_Aggregate;
  /** fetch data from the table in a streaming manner: "transcript_drafts" */
  transcript_drafts_stream: Array<Transcript_Drafts>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table in a streaming manner: "user_settings" */
  user_settings_stream: Array<User_Settings>;
};


export type Subscription_RootAssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssignment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAssignment_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignment_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_WeightArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssignment_Type_WeightsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_Weights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_Weights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignment_Type_Weights_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Subscription_RootAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Subscription_RootAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Subscription_RootAssignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Subscription_RootCommentArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootCourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCourse_Share_LinkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCourse_Share_LinksArgs = {
  distinct_on?: InputMaybe<Array<Course_Share_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Course_Share_Links_Order_By>>;
  where?: InputMaybe<Course_Share_Links_Bool_Exp>;
};


export type Subscription_RootCourse_Share_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Share_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Course_Share_Links_Order_By>>;
  where?: InputMaybe<Course_Share_Links_Bool_Exp>;
};


export type Subscription_RootCourse_Share_Links_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Course_Share_Links_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Share_Links_Bool_Exp>;
};


export type Subscription_RootCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Subscription_RootCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Subscription_RootCourses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Subscription_RootCustom_Assignment_TypeArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Assignment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Subscription_RootCustom_Assignment_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Subscription_RootCustom_Assignment_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Assignment_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Subscription_RootCustomerArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootEventArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvent_Ignored_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Ignored_Courses_Order_By>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


export type Subscription_RootEvent_Ignored_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Ignored_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Ignored_Courses_Order_By>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


export type Subscription_RootEvent_Ignored_Courses_By_PkArgs = {
  courseId: Scalars['uuid']['input'];
  eventId: Scalars['uuid']['input'];
};


export type Subscription_RootEvent_Ignored_Courses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_Ignored_Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Ignored_Courses_Bool_Exp>;
};


export type Subscription_RootEvent_TArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Subscription_RootEvent_T_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Subscription_RootEvent_T_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_T_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Subscription_RootEvent_TypeArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootGrading_StyleArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Subscription_RootGrading_Style_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Subscription_RootGrading_Style_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootGrading_Style_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Grading_Style_Stream_Cursor_Input>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_AdminArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_Admins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Admins_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_CodeArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_CodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_GroupArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Course_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Courses_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Courses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Course_Groups_Courses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Course_Groups_Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Course_Groups_Courses_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Organization_CodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Organization_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Organization_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Course_Groups_Organization_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Course_Groups_Organization_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Course_Groups_Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Course_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Course_Groups_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_TeachersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Teachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


export type Subscription_RootOrganization_Course_Groups_Teachers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Course_Groups_Teachers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Course_Groups_Teachers_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootParrot_RequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootParrot_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Subscription_RootParrot_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Subscription_RootParrot_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootParrot_Request_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parrot_Request_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Subscription_RootParrot_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Subscription_RootParrot_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Subscription_RootParrot_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parrot_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Subscription_RootPlan_TierArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Subscription_RootPlan_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Subscription_RootPlan_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPlan_Tier_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Plan_Tier_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Subscription_RootPrinting_JobArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrinting_Job_StatusArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPrinting_Job_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printing_Job_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPrinting_Job_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printing_Job_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Subscription_RootPrinting_JobsArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Subscription_RootPrinting_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Subscription_RootPrinting_Jobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printing_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Subscription_RootReschedule_ActionArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReschedule_Action_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Statuses_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
};


export type Subscription_RootReschedule_Action_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Statuses_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
};


export type Subscription_RootReschedule_Action_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootReschedule_Action_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reschedule_Action_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Reschedule_Action_Statuses_Bool_Exp>;
};


export type Subscription_RootReschedule_Action_TypesArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Types_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
};


export type Subscription_RootReschedule_Action_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Action_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Action_Types_Order_By>>;
  where?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
};


export type Subscription_RootReschedule_Action_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootReschedule_Action_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reschedule_Action_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Reschedule_Action_Types_Bool_Exp>;
};


export type Subscription_RootReschedule_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Actions_Order_By>>;
  where?: InputMaybe<Reschedule_Actions_Bool_Exp>;
};


export type Subscription_RootReschedule_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reschedule_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reschedule_Actions_Order_By>>;
  where?: InputMaybe<Reschedule_Actions_Bool_Exp>;
};


export type Subscription_RootReschedule_Actions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reschedule_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Reschedule_Actions_Bool_Exp>;
};


export type Subscription_RootSchool_YearArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Subscription_RootSchool_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Subscription_RootSchool_Year_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSchool_Year_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<School_Year_Stream_Cursor_Input>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Subscription_RootStudentArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootStudent_AccountArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootStudent_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Subscription_RootStudent_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Subscription_RootStudent_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Subscription_RootStudent_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStudent_Assignment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Assignment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStudent_Assignment_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Assignment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootStudent_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Subscription_RootStudent_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Subscription_RootStudent_Assignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Subscription_RootStudent_CourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStudent_Course_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Course_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Course_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStudent_Course_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Course_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Subscription_RootStudent_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Subscription_RootStudent_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Subscription_RootStudent_Courses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Subscription_RootStudent_EventArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStudent_EventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Subscription_RootStudent_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Subscription_RootStudent_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Subscription_RootStudentsArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Subscription_RootStudents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Subscription_RootStudents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Students_Stream_Cursor_Input>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Subscription_RootTeacherArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Subscription_RootTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Subscription_RootTeachers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teachers_Stream_Cursor_Input>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Subscription_RootTeachers_StudentsArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Subscription_RootTeachers_Students_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Subscription_RootTeachers_Students_By_PkArgs = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


export type Subscription_RootTeachers_Students_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teachers_Students_Stream_Cursor_Input>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Subscription_RootThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootThemes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootThemes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Themes_Stream_Cursor_Input>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootTranscript_DraftArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTranscript_DraftsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Drafts_Order_By>>;
  where?: InputMaybe<Transcript_Drafts_Bool_Exp>;
};


export type Subscription_RootTranscript_Drafts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Drafts_Order_By>>;
  where?: InputMaybe<Transcript_Drafts_Bool_Exp>;
};


export type Subscription_RootTranscript_Drafts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transcript_Drafts_Stream_Cursor_Input>>;
  where?: InputMaybe<Transcript_Drafts_Bool_Exp>;
};


export type Subscription_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** columns and relationships of "teachers" */
export type Teachers = {
  __typename?: 'teachers';
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer?: Maybe<Customers>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  hasSeenDragDropIntro: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  needsDemoData: Scalars['Boolean']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  /** An array relationship */
  organizationCourseGroups: Array<Organization_Course_Groups_Teachers>;
  /** An aggregate relationship */
  organizationCourseGroups_aggregate: Organization_Course_Groups_Teachers_Aggregate;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  parrotRequests: Array<Parrot_Requests>;
  /** An aggregate relationship */
  parrotRequests_aggregate: Parrot_Requests_Aggregate;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  students: Array<Teachers_Students>;
  /** An aggregate relationship */
  students_aggregate: Teachers_Students_Aggregate;
  toured?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  userSettings?: Maybe<User_Settings>;
};


/** columns and relationships of "teachers" */
export type TeachersCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersOrganizationCourseGroupsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersOrganizationCourseGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Course_Groups_Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Course_Groups_Teachers_Order_By>>;
  where?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersParrotRequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersParrotRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersStudentsArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersStudents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};

/** aggregated selection of "teachers" */
export type Teachers_Aggregate = {
  __typename?: 'teachers_aggregate';
  aggregate?: Maybe<Teachers_Aggregate_Fields>;
  nodes: Array<Teachers>;
};

export type Teachers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teachers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teachers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teachers_Aggregate_Bool_Exp_Count>;
};

export type Teachers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teachers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teachers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teachers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teachers" */
export type Teachers_Aggregate_Fields = {
  __typename?: 'teachers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Teachers_Max_Fields>;
  min?: Maybe<Teachers_Min_Fields>;
};


/** aggregate fields of "teachers" */
export type Teachers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teachers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teachers" */
export type Teachers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teachers_Max_Order_By>;
  min?: InputMaybe<Teachers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "teachers" */
export type Teachers_Arr_Rel_Insert_Input = {
  data: Array<Teachers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export type Teachers_Bool_Exp = {
  _and?: InputMaybe<Array<Teachers_Bool_Exp>>;
  _not?: InputMaybe<Teachers_Bool_Exp>;
  _or?: InputMaybe<Array<Teachers_Bool_Exp>>;
  courses?: InputMaybe<Courses_Bool_Exp>;
  courses_aggregate?: InputMaybe<Courses_Aggregate_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<Customers_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  hasSeenDragDropIntro?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  needsDemoData?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationCourseGroups?: InputMaybe<Organization_Course_Groups_Teachers_Bool_Exp>;
  organizationCourseGroups_aggregate?: InputMaybe<Organization_Course_Groups_Teachers_Aggregate_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  parrotRequests?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Bool_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  settingsId?: InputMaybe<Uuid_Comparison_Exp>;
  students?: InputMaybe<Teachers_Students_Bool_Exp>;
  students_aggregate?: InputMaybe<Teachers_Students_Aggregate_Bool_Exp>;
  toured?: InputMaybe<Boolean_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSettings?: InputMaybe<User_Settings_Bool_Exp>;
};

/** unique or primary key constraints on table "teachers" */
export enum Teachers_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeachersPkey = 'teachers_pkey'
}

/** input type for inserting data into table "teachers" */
export type Teachers_Insert_Input = {
  courses?: InputMaybe<Courses_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Customers_Obj_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  hasSeenDragDropIntro?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationCourseGroups?: InputMaybe<Organization_Course_Groups_Teachers_Arr_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequests?: InputMaybe<Parrot_Requests_Arr_Rel_Insert_Input>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  students?: InputMaybe<Teachers_Students_Arr_Rel_Insert_Input>;
  toured?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userSettings?: InputMaybe<User_Settings_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Teachers_Max_Fields = {
  __typename?: 'teachers_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "teachers" */
export type Teachers_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teachers_Min_Fields = {
  __typename?: 'teachers_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "teachers" */
export type Teachers_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teachers" */
export type Teachers_Mutation_Response = {
  __typename?: 'teachers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teachers>;
};

/** input type for inserting object relation for remote table "teachers" */
export type Teachers_Obj_Rel_Insert_Input = {
  data: Teachers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};

/** on_conflict condition type for table "teachers" */
export type Teachers_On_Conflict = {
  constraint: Teachers_Constraint;
  update_columns?: Array<Teachers_Update_Column>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};

/** Ordering options when selecting data from "teachers". */
export type Teachers_Order_By = {
  courses_aggregate?: InputMaybe<Courses_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customers_Order_By>;
  email?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  hasSeenDragDropIntro?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  needsDemoData?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationCourseGroups_aggregate?: InputMaybe<Organization_Course_Groups_Teachers_Aggregate_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  students_aggregate?: InputMaybe<Teachers_Students_Aggregate_Order_By>;
  toured?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userSettings?: InputMaybe<User_Settings_Order_By>;
};

/** primary key columns input for table: teachers */
export type Teachers_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "teachers" */
export enum Teachers_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  HasSeenDragDropIntro = 'hasSeenDragDropIntro',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  Toured = 'toured',
  /** column name */
  Updated = 'updated'
}

/** select "teachers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teachers" */
export enum Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasSeenDragDropIntro = 'hasSeenDragDropIntro',
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  Toured = 'toured'
}

/** select "teachers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teachers" */
export enum Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasSeenDragDropIntro = 'hasSeenDragDropIntro',
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  Toured = 'toured'
}

/** input type for updating data in table "teachers" */
export type Teachers_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasSeenDragDropIntro?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  toured?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "teachers" */
export type Teachers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teachers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teachers_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasSeenDragDropIntro?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  toured?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "teachers_students" */
export type Teachers_Students = {
  __typename?: 'teachers_students';
  created?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "teachers_students" */
export type Teachers_Students_Aggregate = {
  __typename?: 'teachers_students_aggregate';
  aggregate?: Maybe<Teachers_Students_Aggregate_Fields>;
  nodes: Array<Teachers_Students>;
};

export type Teachers_Students_Aggregate_Bool_Exp = {
  count?: InputMaybe<Teachers_Students_Aggregate_Bool_Exp_Count>;
};

export type Teachers_Students_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Students_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teachers_students" */
export type Teachers_Students_Aggregate_Fields = {
  __typename?: 'teachers_students_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Teachers_Students_Max_Fields>;
  min?: Maybe<Teachers_Students_Min_Fields>;
};


/** aggregate fields of "teachers_students" */
export type Teachers_Students_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teachers_students" */
export type Teachers_Students_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teachers_Students_Max_Order_By>;
  min?: InputMaybe<Teachers_Students_Min_Order_By>;
};

/** input type for inserting array relation for remote table "teachers_students" */
export type Teachers_Students_Arr_Rel_Insert_Input = {
  data: Array<Teachers_Students_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_Students_On_Conflict>;
};

/** Boolean expression to filter rows from the table "teachers_students". All fields are combined with a logical 'AND'. */
export type Teachers_Students_Bool_Exp = {
  _and?: InputMaybe<Array<Teachers_Students_Bool_Exp>>;
  _not?: InputMaybe<Teachers_Students_Bool_Exp>;
  _or?: InputMaybe<Array<Teachers_Students_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "teachers_students" */
export enum Teachers_Students_Constraint {
  /** unique or primary key constraint on columns "teacher_id", "student_id" */
  TeachersStudentsPkey = 'teachers_students_pkey'
}

/** input type for inserting data into table "teachers_students" */
export type Teachers_Students_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Teachers_Students_Max_Fields = {
  __typename?: 'teachers_students_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "teachers_students" */
export type Teachers_Students_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teachers_Students_Min_Fields = {
  __typename?: 'teachers_students_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "teachers_students" */
export type Teachers_Students_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teachers_students" */
export type Teachers_Students_Mutation_Response = {
  __typename?: 'teachers_students_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teachers_Students>;
};

/** on_conflict condition type for table "teachers_students" */
export type Teachers_Students_On_Conflict = {
  constraint: Teachers_Students_Constraint;
  update_columns?: Array<Teachers_Students_Update_Column>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};

/** Ordering options when selecting data from "teachers_students". */
export type Teachers_Students_Order_By = {
  created?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teachers_students */
export type Teachers_Students_Pk_Columns_Input = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};

/** select columns of table "teachers_students" */
export enum Teachers_Students_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "teachers_students" */
export type Teachers_Students_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "teachers_students" */
export type Teachers_Students_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teachers_Students_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teachers_Students_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "teachers_students" */
export enum Teachers_Students_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Teachers_Students_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teachers_Students_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teachers_Students_Bool_Exp;
};

/** update columns of table "teachers" */
export enum Teachers_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  HasSeenDragDropIntro = 'hasSeenDragDropIntro',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  Toured = 'toured',
  /** column name */
  Updated = 'updated'
}

export type Teachers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teachers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teachers_Bool_Exp;
};

/** columns and relationships of "themes" */
export type Themes = {
  __typename?: 'themes';
  appBackground?: Maybe<Scalars['String']['output']>;
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
  colorPalette?: Maybe<Scalars['jsonb']['output']>;
  contentBackground?: Maybe<Scalars['String']['output']>;
  contentContrast?: Maybe<Scalars['String']['output']>;
  contentPrimary?: Maybe<Scalars['String']['output']>;
  contentSecondary?: Maybe<Scalars['String']['output']>;
  contentTertiary?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  elementBackground?: Maybe<Scalars['String']['output']>;
  elementBorder?: Maybe<Scalars['String']['output']>;
  faintBorder?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  headerBackground?: Maybe<Scalars['String']['output']>;
  headerForeground?: Maybe<Scalars['String']['output']>;
  headerForegroundActive?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  info?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  isSyllabirdTheme: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  mediumBorder?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negative?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: Organizations_Aggregate;
  portalIconUrl?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  primaryContrast?: Maybe<Scalars['String']['output']>;
  rescheduleFreeform?: Maybe<Scalars['String']['output']>;
  rescheduleNormal?: Maybe<Scalars['String']['output']>;
  rescheduleSetEnd?: Maybe<Scalars['String']['output']>;
  rescheduleShift?: Maybe<Scalars['String']['output']>;
  surfaceBorder?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  vacation?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};


/** columns and relationships of "themes" */
export type ThemesColorPaletteArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "themes" */
export type ThemesOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


/** columns and relationships of "themes" */
export type ThemesOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** aggregated selection of "themes" */
export type Themes_Aggregate = {
  __typename?: 'themes_aggregate';
  aggregate?: Maybe<Themes_Aggregate_Fields>;
  nodes: Array<Themes>;
};

export type Themes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Themes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Themes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Themes_Aggregate_Bool_Exp_Count>;
};

export type Themes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Themes_Select_Column_Themes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Themes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Themes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Themes_Select_Column_Themes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Themes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Themes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Themes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "themes" */
export type Themes_Aggregate_Fields = {
  __typename?: 'themes_aggregate_fields';
  avg?: Maybe<Themes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Themes_Max_Fields>;
  min?: Maybe<Themes_Min_Fields>;
  stddev?: Maybe<Themes_Stddev_Fields>;
  stddev_pop?: Maybe<Themes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Themes_Stddev_Samp_Fields>;
  sum?: Maybe<Themes_Sum_Fields>;
  var_pop?: Maybe<Themes_Var_Pop_Fields>;
  var_samp?: Maybe<Themes_Var_Samp_Fields>;
  variance?: Maybe<Themes_Variance_Fields>;
};


/** aggregate fields of "themes" */
export type Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "themes" */
export type Themes_Aggregate_Order_By = {
  avg?: InputMaybe<Themes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Themes_Max_Order_By>;
  min?: InputMaybe<Themes_Min_Order_By>;
  stddev?: InputMaybe<Themes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Themes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Themes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Themes_Sum_Order_By>;
  var_pop?: InputMaybe<Themes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Themes_Var_Samp_Order_By>;
  variance?: InputMaybe<Themes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Themes_Append_Input = {
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "themes" */
export type Themes_Arr_Rel_Insert_Input = {
  data: Array<Themes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};

/** aggregate avg on columns */
export type Themes_Avg_Fields = {
  __typename?: 'themes_avg_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "themes" */
export type Themes_Avg_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "themes". All fields are combined with a logical 'AND'. */
export type Themes_Bool_Exp = {
  _and?: InputMaybe<Array<Themes_Bool_Exp>>;
  _not?: InputMaybe<Themes_Bool_Exp>;
  _or?: InputMaybe<Array<Themes_Bool_Exp>>;
  appBackground?: InputMaybe<String_Comparison_Exp>;
  baseFontSize?: InputMaybe<Numeric_Comparison_Exp>;
  colorPalette?: InputMaybe<Jsonb_Comparison_Exp>;
  contentBackground?: InputMaybe<String_Comparison_Exp>;
  contentContrast?: InputMaybe<String_Comparison_Exp>;
  contentPrimary?: InputMaybe<String_Comparison_Exp>;
  contentSecondary?: InputMaybe<String_Comparison_Exp>;
  contentTertiary?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  elementBackground?: InputMaybe<String_Comparison_Exp>;
  elementBorder?: InputMaybe<String_Comparison_Exp>;
  faintBorder?: InputMaybe<String_Comparison_Exp>;
  fontFamily?: InputMaybe<String_Comparison_Exp>;
  fontUrl?: InputMaybe<String_Comparison_Exp>;
  headerBackground?: InputMaybe<String_Comparison_Exp>;
  headerForeground?: InputMaybe<String_Comparison_Exp>;
  headerForegroundActive?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<String_Comparison_Exp>;
  isPrimary?: InputMaybe<Boolean_Comparison_Exp>;
  isSyllabirdTheme?: InputMaybe<Boolean_Comparison_Exp>;
  logoUrl?: InputMaybe<String_Comparison_Exp>;
  mediumBorder?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  negative?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  organizations?: InputMaybe<Organizations_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organizations_Aggregate_Bool_Exp>;
  portalIconUrl?: InputMaybe<String_Comparison_Exp>;
  positive?: InputMaybe<String_Comparison_Exp>;
  primary?: InputMaybe<String_Comparison_Exp>;
  primaryContrast?: InputMaybe<String_Comparison_Exp>;
  rescheduleFreeform?: InputMaybe<String_Comparison_Exp>;
  rescheduleNormal?: InputMaybe<String_Comparison_Exp>;
  rescheduleSetEnd?: InputMaybe<String_Comparison_Exp>;
  rescheduleShift?: InputMaybe<String_Comparison_Exp>;
  surfaceBorder?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  vacation?: InputMaybe<String_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "themes" */
export enum Themes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ThemesPkey = 'themes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Themes_Delete_At_Path_Input = {
  colorPalette?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Themes_Delete_Elem_Input = {
  colorPalette?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Themes_Delete_Key_Input = {
  colorPalette?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "themes" */
export type Themes_Inc_Input = {
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "themes" */
export type Themes_Insert_Input = {
  appBackground?: InputMaybe<Scalars['String']['input']>;
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  elementBackground?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isSyllabirdTheme?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizations?: InputMaybe<Organizations_Arr_Rel_Insert_Input>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  primaryContrast?: InputMaybe<Scalars['String']['input']>;
  rescheduleFreeform?: InputMaybe<Scalars['String']['input']>;
  rescheduleNormal?: InputMaybe<Scalars['String']['input']>;
  rescheduleSetEnd?: InputMaybe<Scalars['String']['input']>;
  rescheduleShift?: InputMaybe<Scalars['String']['input']>;
  surfaceBorder?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Themes_Max_Fields = {
  __typename?: 'themes_max_fields';
  appBackground?: Maybe<Scalars['String']['output']>;
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
  contentBackground?: Maybe<Scalars['String']['output']>;
  contentContrast?: Maybe<Scalars['String']['output']>;
  contentPrimary?: Maybe<Scalars['String']['output']>;
  contentSecondary?: Maybe<Scalars['String']['output']>;
  contentTertiary?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  elementBackground?: Maybe<Scalars['String']['output']>;
  elementBorder?: Maybe<Scalars['String']['output']>;
  faintBorder?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  headerBackground?: Maybe<Scalars['String']['output']>;
  headerForeground?: Maybe<Scalars['String']['output']>;
  headerForegroundActive?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mediumBorder?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negative?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  portalIconUrl?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  primaryContrast?: Maybe<Scalars['String']['output']>;
  rescheduleFreeform?: Maybe<Scalars['String']['output']>;
  rescheduleNormal?: Maybe<Scalars['String']['output']>;
  rescheduleSetEnd?: Maybe<Scalars['String']['output']>;
  rescheduleShift?: Maybe<Scalars['String']['output']>;
  surfaceBorder?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  vacation?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "themes" */
export type Themes_Max_Order_By = {
  appBackground?: InputMaybe<Order_By>;
  baseFontSize?: InputMaybe<Order_By>;
  contentBackground?: InputMaybe<Order_By>;
  contentContrast?: InputMaybe<Order_By>;
  contentPrimary?: InputMaybe<Order_By>;
  contentSecondary?: InputMaybe<Order_By>;
  contentTertiary?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  elementBackground?: InputMaybe<Order_By>;
  elementBorder?: InputMaybe<Order_By>;
  faintBorder?: InputMaybe<Order_By>;
  fontFamily?: InputMaybe<Order_By>;
  fontUrl?: InputMaybe<Order_By>;
  headerBackground?: InputMaybe<Order_By>;
  headerForeground?: InputMaybe<Order_By>;
  headerForegroundActive?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  mediumBorder?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  negative?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  portalIconUrl?: InputMaybe<Order_By>;
  positive?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  primaryContrast?: InputMaybe<Order_By>;
  rescheduleFreeform?: InputMaybe<Order_By>;
  rescheduleNormal?: InputMaybe<Order_By>;
  rescheduleSetEnd?: InputMaybe<Order_By>;
  rescheduleShift?: InputMaybe<Order_By>;
  surfaceBorder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  vacation?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Themes_Min_Fields = {
  __typename?: 'themes_min_fields';
  appBackground?: Maybe<Scalars['String']['output']>;
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
  contentBackground?: Maybe<Scalars['String']['output']>;
  contentContrast?: Maybe<Scalars['String']['output']>;
  contentPrimary?: Maybe<Scalars['String']['output']>;
  contentSecondary?: Maybe<Scalars['String']['output']>;
  contentTertiary?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  elementBackground?: Maybe<Scalars['String']['output']>;
  elementBorder?: Maybe<Scalars['String']['output']>;
  faintBorder?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  headerBackground?: Maybe<Scalars['String']['output']>;
  headerForeground?: Maybe<Scalars['String']['output']>;
  headerForegroundActive?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mediumBorder?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negative?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  portalIconUrl?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  primaryContrast?: Maybe<Scalars['String']['output']>;
  rescheduleFreeform?: Maybe<Scalars['String']['output']>;
  rescheduleNormal?: Maybe<Scalars['String']['output']>;
  rescheduleSetEnd?: Maybe<Scalars['String']['output']>;
  rescheduleShift?: Maybe<Scalars['String']['output']>;
  surfaceBorder?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  vacation?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "themes" */
export type Themes_Min_Order_By = {
  appBackground?: InputMaybe<Order_By>;
  baseFontSize?: InputMaybe<Order_By>;
  contentBackground?: InputMaybe<Order_By>;
  contentContrast?: InputMaybe<Order_By>;
  contentPrimary?: InputMaybe<Order_By>;
  contentSecondary?: InputMaybe<Order_By>;
  contentTertiary?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  elementBackground?: InputMaybe<Order_By>;
  elementBorder?: InputMaybe<Order_By>;
  faintBorder?: InputMaybe<Order_By>;
  fontFamily?: InputMaybe<Order_By>;
  fontUrl?: InputMaybe<Order_By>;
  headerBackground?: InputMaybe<Order_By>;
  headerForeground?: InputMaybe<Order_By>;
  headerForegroundActive?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  mediumBorder?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  negative?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  portalIconUrl?: InputMaybe<Order_By>;
  positive?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  primaryContrast?: InputMaybe<Order_By>;
  rescheduleFreeform?: InputMaybe<Order_By>;
  rescheduleNormal?: InputMaybe<Order_By>;
  rescheduleSetEnd?: InputMaybe<Order_By>;
  rescheduleShift?: InputMaybe<Order_By>;
  surfaceBorder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  vacation?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "themes" */
export type Themes_Mutation_Response = {
  __typename?: 'themes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Themes>;
};

/** input type for inserting object relation for remote table "themes" */
export type Themes_Obj_Rel_Insert_Input = {
  data: Themes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};

/** on_conflict condition type for table "themes" */
export type Themes_On_Conflict = {
  constraint: Themes_Constraint;
  update_columns?: Array<Themes_Update_Column>;
  where?: InputMaybe<Themes_Bool_Exp>;
};

/** Ordering options when selecting data from "themes". */
export type Themes_Order_By = {
  appBackground?: InputMaybe<Order_By>;
  baseFontSize?: InputMaybe<Order_By>;
  colorPalette?: InputMaybe<Order_By>;
  contentBackground?: InputMaybe<Order_By>;
  contentContrast?: InputMaybe<Order_By>;
  contentPrimary?: InputMaybe<Order_By>;
  contentSecondary?: InputMaybe<Order_By>;
  contentTertiary?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  elementBackground?: InputMaybe<Order_By>;
  elementBorder?: InputMaybe<Order_By>;
  faintBorder?: InputMaybe<Order_By>;
  fontFamily?: InputMaybe<Order_By>;
  fontUrl?: InputMaybe<Order_By>;
  headerBackground?: InputMaybe<Order_By>;
  headerForeground?: InputMaybe<Order_By>;
  headerForegroundActive?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  isPrimary?: InputMaybe<Order_By>;
  isSyllabirdTheme?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  mediumBorder?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  negative?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<Organizations_Aggregate_Order_By>;
  portalIconUrl?: InputMaybe<Order_By>;
  positive?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  primaryContrast?: InputMaybe<Order_By>;
  rescheduleFreeform?: InputMaybe<Order_By>;
  rescheduleNormal?: InputMaybe<Order_By>;
  rescheduleSetEnd?: InputMaybe<Order_By>;
  rescheduleShift?: InputMaybe<Order_By>;
  surfaceBorder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  vacation?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
};

/** primary key columns input for table: themes */
export type Themes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Themes_Prepend_Input = {
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "themes" */
export enum Themes_Select_Column {
  /** column name */
  AppBackground = 'appBackground',
  /** column name */
  BaseFontSize = 'baseFontSize',
  /** column name */
  ColorPalette = 'colorPalette',
  /** column name */
  ContentBackground = 'contentBackground',
  /** column name */
  ContentContrast = 'contentContrast',
  /** column name */
  ContentPrimary = 'contentPrimary',
  /** column name */
  ContentSecondary = 'contentSecondary',
  /** column name */
  ContentTertiary = 'contentTertiary',
  /** column name */
  Created = 'created',
  /** column name */
  ElementBackground = 'elementBackground',
  /** column name */
  ElementBorder = 'elementBorder',
  /** column name */
  FaintBorder = 'faintBorder',
  /** column name */
  FontFamily = 'fontFamily',
  /** column name */
  FontUrl = 'fontUrl',
  /** column name */
  HeaderBackground = 'headerBackground',
  /** column name */
  HeaderForeground = 'headerForeground',
  /** column name */
  HeaderForegroundActive = 'headerForegroundActive',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  IsSyllabirdTheme = 'isSyllabirdTheme',
  /** column name */
  LogoUrl = 'logoUrl',
  /** column name */
  MediumBorder = 'mediumBorder',
  /** column name */
  Name = 'name',
  /** column name */
  Negative = 'negative',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PortalIconUrl = 'portalIconUrl',
  /** column name */
  Positive = 'positive',
  /** column name */
  Primary = 'primary',
  /** column name */
  PrimaryContrast = 'primaryContrast',
  /** column name */
  RescheduleFreeform = 'rescheduleFreeform',
  /** column name */
  RescheduleNormal = 'rescheduleNormal',
  /** column name */
  RescheduleSetEnd = 'rescheduleSetEnd',
  /** column name */
  RescheduleShift = 'rescheduleShift',
  /** column name */
  SurfaceBorder = 'surfaceBorder',
  /** column name */
  Updated = 'updated',
  /** column name */
  Vacation = 'vacation',
  /** column name */
  Visible = 'visible'
}

/** select "themes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "themes" */
export enum Themes_Select_Column_Themes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  IsSyllabirdTheme = 'isSyllabirdTheme',
  /** column name */
  Visible = 'visible'
}

/** select "themes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "themes" */
export enum Themes_Select_Column_Themes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  IsSyllabirdTheme = 'isSyllabirdTheme',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "themes" */
export type Themes_Set_Input = {
  appBackground?: InputMaybe<Scalars['String']['input']>;
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  elementBackground?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isSyllabirdTheme?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  primaryContrast?: InputMaybe<Scalars['String']['input']>;
  rescheduleFreeform?: InputMaybe<Scalars['String']['input']>;
  rescheduleNormal?: InputMaybe<Scalars['String']['input']>;
  rescheduleSetEnd?: InputMaybe<Scalars['String']['input']>;
  rescheduleShift?: InputMaybe<Scalars['String']['input']>;
  surfaceBorder?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Themes_Stddev_Fields = {
  __typename?: 'themes_stddev_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "themes" */
export type Themes_Stddev_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Themes_Stddev_Pop_Fields = {
  __typename?: 'themes_stddev_pop_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "themes" */
export type Themes_Stddev_Pop_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Themes_Stddev_Samp_Fields = {
  __typename?: 'themes_stddev_samp_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "themes" */
export type Themes_Stddev_Samp_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "themes" */
export type Themes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Themes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Themes_Stream_Cursor_Value_Input = {
  appBackground?: InputMaybe<Scalars['String']['input']>;
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  elementBackground?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isSyllabirdTheme?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  primaryContrast?: InputMaybe<Scalars['String']['input']>;
  rescheduleFreeform?: InputMaybe<Scalars['String']['input']>;
  rescheduleNormal?: InputMaybe<Scalars['String']['input']>;
  rescheduleSetEnd?: InputMaybe<Scalars['String']['input']>;
  rescheduleShift?: InputMaybe<Scalars['String']['input']>;
  surfaceBorder?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Themes_Sum_Fields = {
  __typename?: 'themes_sum_fields';
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "themes" */
export type Themes_Sum_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** update columns of table "themes" */
export enum Themes_Update_Column {
  /** column name */
  AppBackground = 'appBackground',
  /** column name */
  BaseFontSize = 'baseFontSize',
  /** column name */
  ColorPalette = 'colorPalette',
  /** column name */
  ContentBackground = 'contentBackground',
  /** column name */
  ContentContrast = 'contentContrast',
  /** column name */
  ContentPrimary = 'contentPrimary',
  /** column name */
  ContentSecondary = 'contentSecondary',
  /** column name */
  ContentTertiary = 'contentTertiary',
  /** column name */
  Created = 'created',
  /** column name */
  ElementBackground = 'elementBackground',
  /** column name */
  ElementBorder = 'elementBorder',
  /** column name */
  FaintBorder = 'faintBorder',
  /** column name */
  FontFamily = 'fontFamily',
  /** column name */
  FontUrl = 'fontUrl',
  /** column name */
  HeaderBackground = 'headerBackground',
  /** column name */
  HeaderForeground = 'headerForeground',
  /** column name */
  HeaderForegroundActive = 'headerForegroundActive',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  IsSyllabirdTheme = 'isSyllabirdTheme',
  /** column name */
  LogoUrl = 'logoUrl',
  /** column name */
  MediumBorder = 'mediumBorder',
  /** column name */
  Name = 'name',
  /** column name */
  Negative = 'negative',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PortalIconUrl = 'portalIconUrl',
  /** column name */
  Positive = 'positive',
  /** column name */
  Primary = 'primary',
  /** column name */
  PrimaryContrast = 'primaryContrast',
  /** column name */
  RescheduleFreeform = 'rescheduleFreeform',
  /** column name */
  RescheduleNormal = 'rescheduleNormal',
  /** column name */
  RescheduleSetEnd = 'rescheduleSetEnd',
  /** column name */
  RescheduleShift = 'rescheduleShift',
  /** column name */
  SurfaceBorder = 'surfaceBorder',
  /** column name */
  Updated = 'updated',
  /** column name */
  Vacation = 'vacation',
  /** column name */
  Visible = 'visible'
}

export type Themes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Themes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Themes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Themes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Themes_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Themes_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Themes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Themes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Themes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Themes_Var_Pop_Fields = {
  __typename?: 'themes_var_pop_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "themes" */
export type Themes_Var_Pop_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Themes_Var_Samp_Fields = {
  __typename?: 'themes_var_samp_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "themes" */
export type Themes_Var_Samp_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Themes_Variance_Fields = {
  __typename?: 'themes_variance_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "themes" */
export type Themes_Variance_Order_By = {
  baseFontSize?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "transcript_drafts" */
export type Transcript_Drafts = {
  __typename?: 'transcript_drafts';
  created: Scalars['timestamptz']['output'];
  draftData: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "transcript_drafts" */
export type Transcript_DraftsDraftDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "transcript_drafts" */
export type Transcript_Drafts_Aggregate = {
  __typename?: 'transcript_drafts_aggregate';
  aggregate?: Maybe<Transcript_Drafts_Aggregate_Fields>;
  nodes: Array<Transcript_Drafts>;
};

/** aggregate fields of "transcript_drafts" */
export type Transcript_Drafts_Aggregate_Fields = {
  __typename?: 'transcript_drafts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transcript_Drafts_Max_Fields>;
  min?: Maybe<Transcript_Drafts_Min_Fields>;
};


/** aggregate fields of "transcript_drafts" */
export type Transcript_Drafts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transcript_Drafts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Drafts_Append_Input = {
  draftData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "transcript_drafts". All fields are combined with a logical 'AND'. */
export type Transcript_Drafts_Bool_Exp = {
  _and?: InputMaybe<Array<Transcript_Drafts_Bool_Exp>>;
  _not?: InputMaybe<Transcript_Drafts_Bool_Exp>;
  _or?: InputMaybe<Array<Transcript_Drafts_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  draftData?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "transcript_drafts" */
export enum Transcript_Drafts_Constraint {
  /** unique or primary key constraint on columns "id" */
  TranscriptDraftsPkey = 'transcript_drafts_pkey',
  /** unique or primary key constraint on columns "teacher_id", "student_id" */
  TranscriptDraftsStudentIdTeacherIdKey = 'transcript_drafts_student_id_teacher_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transcript_Drafts_Delete_At_Path_Input = {
  draftData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transcript_Drafts_Delete_Elem_Input = {
  draftData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transcript_Drafts_Delete_Key_Input = {
  draftData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "transcript_drafts" */
export type Transcript_Drafts_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  draftData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Transcript_Drafts_Max_Fields = {
  __typename?: 'transcript_drafts_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Transcript_Drafts_Min_Fields = {
  __typename?: 'transcript_drafts_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "transcript_drafts" */
export type Transcript_Drafts_Mutation_Response = {
  __typename?: 'transcript_drafts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transcript_Drafts>;
};

/** on_conflict condition type for table "transcript_drafts" */
export type Transcript_Drafts_On_Conflict = {
  constraint: Transcript_Drafts_Constraint;
  update_columns?: Array<Transcript_Drafts_Update_Column>;
  where?: InputMaybe<Transcript_Drafts_Bool_Exp>;
};

/** Ordering options when selecting data from "transcript_drafts". */
export type Transcript_Drafts_Order_By = {
  created?: InputMaybe<Order_By>;
  draftData?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transcript_drafts */
export type Transcript_Drafts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Drafts_Prepend_Input = {
  draftData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "transcript_drafts" */
export enum Transcript_Drafts_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  DraftData = 'draftData',
  /** column name */
  Id = 'id',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "transcript_drafts" */
export type Transcript_Drafts_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  draftData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "transcript_drafts" */
export type Transcript_Drafts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transcript_Drafts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transcript_Drafts_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  draftData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "transcript_drafts" */
export enum Transcript_Drafts_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  DraftData = 'draftData',
  /** column name */
  Id = 'id',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Transcript_Drafts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transcript_Drafts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transcript_Drafts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transcript_Drafts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transcript_Drafts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transcript_Drafts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transcript_Drafts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transcript_Drafts_Bool_Exp;
};

/** columns and relationships of "user_settings" */
export type User_Settings = {
  __typename?: 'user_settings';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  selectedTheme?: Maybe<Themes>;
  selectedThemeId?: Maybe<Scalars['uuid']['output']>;
  showEmptyAssignmentDays: Scalars['Boolean']['output'];
  /** An array relationship */
  studentAccounts: Array<Student_Accounts>;
  /** An aggregate relationship */
  studentAccounts_aggregate: Student_Accounts_Aggregate;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  weekStartDay: Scalars['Int']['output'];
};


/** columns and relationships of "user_settings" */
export type User_SettingsStudentAccountsArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsStudentAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};

/** aggregated selection of "user_settings" */
export type User_Settings_Aggregate = {
  __typename?: 'user_settings_aggregate';
  aggregate?: Maybe<User_Settings_Aggregate_Fields>;
  nodes: Array<User_Settings>;
};

/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_Fields = {
  __typename?: 'user_settings_aggregate_fields';
  avg?: Maybe<User_Settings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Settings_Max_Fields>;
  min?: Maybe<User_Settings_Min_Fields>;
  stddev?: Maybe<User_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<User_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<User_Settings_Sum_Fields>;
  var_pop?: Maybe<User_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<User_Settings_Var_Samp_Fields>;
  variance?: Maybe<User_Settings_Variance_Fields>;
};


/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Settings_Avg_Fields = {
  __typename?: 'user_settings_avg_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_settings". All fields are combined with a logical 'AND'. */
export type User_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  _not?: InputMaybe<User_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  selectedTheme?: InputMaybe<Themes_Bool_Exp>;
  selectedThemeId?: InputMaybe<Uuid_Comparison_Exp>;
  showEmptyAssignmentDays?: InputMaybe<Boolean_Comparison_Exp>;
  studentAccounts?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAccounts_aggregate?: InputMaybe<Student_Accounts_Aggregate_Bool_Exp>;
  teachers?: InputMaybe<Teachers_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Bool_Exp>;
  weekStartDay?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_settings" */
export enum User_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSettingsPkey = 'user_settings_pkey'
}

/** input type for incrementing numeric columns in table "user_settings" */
export type User_Settings_Inc_Input = {
  weekStartDay?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_settings" */
export type User_Settings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  selectedTheme?: InputMaybe<Themes_Obj_Rel_Insert_Input>;
  selectedThemeId?: InputMaybe<Scalars['uuid']['input']>;
  showEmptyAssignmentDays?: InputMaybe<Scalars['Boolean']['input']>;
  studentAccounts?: InputMaybe<Student_Accounts_Arr_Rel_Insert_Input>;
  teachers?: InputMaybe<Teachers_Arr_Rel_Insert_Input>;
  weekStartDay?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type User_Settings_Max_Fields = {
  __typename?: 'user_settings_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  selectedThemeId?: Maybe<Scalars['uuid']['output']>;
  weekStartDay?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type User_Settings_Min_Fields = {
  __typename?: 'user_settings_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  selectedThemeId?: Maybe<Scalars['uuid']['output']>;
  weekStartDay?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "user_settings" */
export type User_Settings_Mutation_Response = {
  __typename?: 'user_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Settings>;
};

/** input type for inserting object relation for remote table "user_settings" */
export type User_Settings_Obj_Rel_Insert_Input = {
  data: User_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};

/** on_conflict condition type for table "user_settings" */
export type User_Settings_On_Conflict = {
  constraint: User_Settings_Constraint;
  update_columns?: Array<User_Settings_Update_Column>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "user_settings". */
export type User_Settings_Order_By = {
  id?: InputMaybe<Order_By>;
  selectedTheme?: InputMaybe<Themes_Order_By>;
  selectedThemeId?: InputMaybe<Order_By>;
  showEmptyAssignmentDays?: InputMaybe<Order_By>;
  studentAccounts_aggregate?: InputMaybe<Student_Accounts_Aggregate_Order_By>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Order_By>;
  weekStartDay?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_settings */
export type User_Settings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_settings" */
export enum User_Settings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SelectedThemeId = 'selectedThemeId',
  /** column name */
  ShowEmptyAssignmentDays = 'showEmptyAssignmentDays',
  /** column name */
  WeekStartDay = 'weekStartDay'
}

/** input type for updating data in table "user_settings" */
export type User_Settings_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  selectedThemeId?: InputMaybe<Scalars['uuid']['input']>;
  showEmptyAssignmentDays?: InputMaybe<Scalars['Boolean']['input']>;
  weekStartDay?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type User_Settings_Stddev_Fields = {
  __typename?: 'user_settings_stddev_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Settings_Stddev_Pop_Fields = {
  __typename?: 'user_settings_stddev_pop_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Settings_Stddev_Samp_Fields = {
  __typename?: 'user_settings_stddev_samp_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_settings" */
export type User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Settings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  selectedThemeId?: InputMaybe<Scalars['uuid']['input']>;
  showEmptyAssignmentDays?: InputMaybe<Scalars['Boolean']['input']>;
  weekStartDay?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type User_Settings_Sum_Fields = {
  __typename?: 'user_settings_sum_fields';
  weekStartDay?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_settings" */
export enum User_Settings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SelectedThemeId = 'selectedThemeId',
  /** column name */
  ShowEmptyAssignmentDays = 'showEmptyAssignmentDays',
  /** column name */
  WeekStartDay = 'weekStartDay'
}

export type User_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Settings_Var_Pop_Fields = {
  __typename?: 'user_settings_var_pop_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Settings_Var_Samp_Fields = {
  __typename?: 'user_settings_var_samp_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Settings_Variance_Fields = {
  __typename?: 'user_settings_variance_fields';
  weekStartDay?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};
